(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Banner-imagen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefiereReducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function preparar(ambito) {
      var raiz = ambito || document;
      var lista = raiz.querySelectorAll('.banner-imagen[data-bi-entrada]:not([data-bi-entrada="ninguna"])');

      Array.prototype.forEach.call(lista, function (el) {
        if (el.getAttribute('data-bi-listo') === '1') return;
        el.setAttribute('data-bi-listo', '1');
        el.classList.add('banner-imagen--anim-lista');

        if (prefiereReducir || !('IntersectionObserver' in window)) {
          el.classList.add('esta-dentro');
          return;
        }

        var observador = new IntersectionObserver(function (entradas, obs) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              entrada.target.classList.add('esta-dentro');
              obs.unobserve(entrada.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

        observador.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { preparar(document); });
    } else {
      preparar(document);
    }

    document.addEventListener('shopify:section:load', function (evt) {
      preparar(evt.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-de-anuncios-ok"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instancias = {};

    function dosCifras(numero) {
      return numero < 10 ? '0' + numero : String(numero);
    }

    function leerFechaFija(anuncio) {
      var partes = (anuncio.getAttribute('data-fecha') || '').trim().split(/[\/\-.]/);
      var hora = (anuncio.getAttribute('data-hora') || '').trim().split(':');
      var anio;
      var mes;
      var dia;

      if (partes.length !== 3) return null;

      if (partes[0].length === 4) {
        anio = parseInt(partes[0], 10);
        mes = parseInt(partes[1], 10);
        dia = parseInt(partes[2], 10);
      } else {
        dia = parseInt(partes[0], 10);
        mes = parseInt(partes[1], 10);
        anio = parseInt(partes[2], 10);
      }

      if (isNaN(anio) || isNaN(mes) || isNaN(dia)) return null;
      if (anio < 100) anio += 2000;

      var fecha = new Date(anio, mes - 1, dia, parseInt(hora[0], 10) || 0, parseInt(hora[1], 10) || 0, 0);
      return isNaN(fecha.getTime()) ? null : fecha;
    }

    function siguienteReinicio(horaReinicio) {
      var ahora = new Date();
      var objetivo = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), horaReinicio, 0, 0);
      if (objetivo.getTime() <= ahora.getTime()) objetivo.setDate(objetivo.getDate() + 1);
      return objetivo;
    }

    function esFocoTeclado(elemento) {
      try {
        return elemento.matches(':focus-visible');
      } catch (error) {
        return true;
      }
    }

    function recalcularCabecera() {
      var stickyHeader = document.querySelector('.section-header sticky-header');
      if (!stickyHeader) return;
      if (typeof stickyHeader.setHeaderHeight === 'function') stickyHeader.setHeaderHeight();
      if (typeof stickyHeader.createObserver === 'function') stickyHeader.createObserver();
    }

    function colocarSobreCabecera(raiz) {
      if (raiz.getAttribute('data-sobre-cabecera') !== 'true') return;

      var seccion = raiz.closest('.shopify-section');
      var cabecera = document.querySelector('.section-header');
      if (!seccion || !cabecera || seccion === cabecera) return;
      if (seccion.parentNode !== cabecera.parentNode) return;
      if (!(cabecera.compareDocumentPosition(seccion) & Node.DOCUMENT_POSITION_FOLLOWING)) return;

      cabecera.parentNode.insertBefore(seccion, cabecera);
      recalcularCabecera();
    }

    function detectarCabeceraPegajosa(raiz) {
      if (raiz.getAttribute('data-fija') !== 'true') return;

      var cabecera = document.querySelector('.section-header');
      if (!cabecera || cabecera.classList.contains('scrolled-past-header')) return;
      if (window.getComputedStyle(cabecera).position === 'sticky') {
        document.documentElement.classList.add('barra-anuncios-cabecera-pegajosa');
      }
    }

    function crearInstancia(raiz) {
      var pista = raiz.querySelector('.barra-anuncios__pista');
      if (!pista) return null;

      colocarSobreCabecera(raiz);
      detectarCabeceraPegajosa(raiz);

      var claseActivo = 'barra-anuncios__anuncio--activo';
      var claseSaliendo = 'barra-anuncios__anuncio--saliendo';
      var autoplay = raiz.getAttribute('data-autoplay') === 'true';
      var pausarHover = raiz.getAttribute('data-pausar-hover') === 'true';
      var modoEditor = raiz.getAttribute('data-editor') === 'true';
      var posicionada = raiz.getAttribute('data-posicionada') === 'true';
      var intervalo = (parseFloat(raiz.getAttribute('data-intervalo')) || 4) * 1000;
      var duracion = parseInt(raiz.getAttribute('data-duracion'), 10) || 700;
      var progreso = raiz.querySelector('.barra-anuncios__progreso');
      var destello = raiz.querySelector('.barra-anuncios__destello');
      var pausas = { raton: false, foco: false, editor: false, oculta: document.hidden };
      var restante = intervalo;
      var inicioTramo = 0;
      var alturaMedida = null;
      var temporizadorRotacion = null;
      var temporizadorSalida = null;
      var temporizadorCuentas = null;
      var observadorAltura = null;
      var cuentas = [];
      var inicioX = null;
      var inicioY = null;

      function anuncios() {
        return Array.prototype.slice.call(pista.querySelectorAll('.barra-anuncios__anuncio'));
      }

      function indiceActivo(lista) {
        for (var i = 0; i < lista.length; i++) {
          if (lista[i].classList.contains(claseActivo)) return i;
        }
        return -1;
      }

      function instantaneo(accion) {
        raiz.classList.add('barra-anuncios--instantaneo');
        accion();
        void raiz.offsetWidth;
        raiz.classList.remove('barra-anuncios--instantaneo');
      }

      function lanzarDestello() {
        if (!destello) return;
        raiz.classList.remove('barra-anuncios--destello-activo');
        void raiz.offsetWidth;
        raiz.classList.add('barra-anuncios--destello-activo');
      }

      function reiniciarProgreso() {
        if (!progreso) return;
        raiz.classList.remove('barra-anuncios--progreso-activo');
        if (!autoplay || anuncios().length < 2) return;
        void raiz.offsetWidth;
        raiz.classList.add('barra-anuncios--progreso-activo');
      }

      function mostrar(destino, atras) {
        var lista = anuncios();
        var total = lista.length;
        if (!total) return;

        destino = ((destino % total) + total) % total;
        var actual = indiceActivo(lista);
        if (destino === actual) return;

        clearTimeout(temporizadorSalida);
        lista.forEach(function (anuncio) {
          anuncio.classList.remove(claseSaliendo);
        });

        raiz.classList.toggle('barra-anuncios--atras', !!atras);
        void pista.offsetWidth;

        var saliente = actual > -1 ? lista[actual] : null;
        if (saliente) {
          saliente.classList.remove(claseActivo);
          saliente.classList.add(claseSaliendo);
        }
        lista[destino].classList.add(claseActivo);
        lanzarDestello();

        temporizadorSalida = setTimeout(function () {
          if (saliente) saliente.classList.remove(claseSaliendo);
        }, duracion + 50);
      }

      function siguiente() {
        mostrar(indiceActivo(anuncios()) + 1, false);
      }

      function anterior() {
        mostrar(indiceActivo(anuncios()) - 1, true);
      }

      function puedeRotar() {
        if (!autoplay || pausas.raton || pausas.foco || pausas.editor || pausas.oculta) return false;
        return anuncios().length > 1;
      }

      function detener() {
        if (!temporizadorRotacion) return;
        clearTimeout(temporizadorRotacion);
        temporizadorRotacion = null;
        restante = Math.max(0, restante - (Date.now() - inicioTramo));
      }

      function programar() {
        detener();
        var activa = puedeRotar();
        raiz.classList.toggle('barra-anuncios--pausada', !activa);
        if (!activa) return;

        inicioTramo = Date.now();
        temporizadorRotacion = setTimeout(function () {
          temporizadorRotacion = null;
          restante = intervalo;
          siguiente();
          reiniciarProgreso();
          programar();
        }, restante);
      }

      function reiniciarCiclo() {
        detener();
        restante = intervalo;
        reiniciarProgreso();
        programar();
      }

      function actualizarEstado() {
        var total = anuncios().length;
        raiz.classList.toggle('barra-anuncios--un-anuncio', total < 2);
        if (!total) raiz.style.setProperty('display', 'none', 'important');
      }

      function medirAltura() {
        if (!posicionada) return;
        var alto = raiz.offsetHeight;
        if (alto === alturaMedida) return;
        alturaMedida = alto;
        document.documentElement.style.setProperty('--barra-anuncios-altura', alto + 'px', 'important');
        if (window.pageYOffset < 1) recalcularCabecera();
      }

      function quitar(anuncio) {
        var lista = anuncios();
        var indice = lista.indexOf(anuncio);
        if (indice === -1) return;

        if (anuncio.classList.contains(claseActivo) && lista.length > 1) {
          instantaneo(function () {
            mostrar(indice + 1, false);
          });
        }

        if (anuncio.parentNode) anuncio.parentNode.removeChild(anuncio);
        actualizarEstado();
        reiniciarCiclo();
      }

      function terminar(cuenta) {
        cuenta.terminada = true;

        if (cuenta.alTerminar === 'ocultar' && !modoEditor) {
          quitar(cuenta.anuncio);
          return;
        }

        if (cuenta.textoFinal) {
          if (cuenta.prefijo) cuenta.prefijo.style.setProperty('display', 'none', 'important');
          cuenta.reloj.textContent = cuenta.textoFinal;
        } else {
          cuenta.reloj.textContent = '00:00:00';
        }
        cuenta.reloj.classList.add('barra-anuncios__reloj--listo');
      }

      function actualizarCuentas() {
        var ahora = Date.now();

        cuentas.forEach(function (cuenta) {
          if (cuenta.terminada) return;

          var restanteCuenta = cuenta.objetivo.getTime() - ahora;
          if (restanteCuenta <= 0) {
            if (cuenta.fija) {
              terminar(cuenta);
              return;
            }
            cuenta.objetivo = siguienteReinicio(cuenta.horaReinicio);
            restanteCuenta = cuenta.objetivo.getTime() - ahora;
          }

          var segundosTotales = Math.floor(restanteCuenta / 1000);
          var dias = Math.floor(segundosTotales / 86400);
          var horas = Math.floor((segundosTotales % 86400) / 3600);
          var minutos = Math.floor((segundosTotales % 3600) / 60);
          var segundos = segundosTotales % 60;
          var texto = dosCifras(horas) + ':' + dosCifras(minutos) + ':' + dosCifras(segundos);

          if (dias > 0) texto = dias + cuenta.etiquetaDias + ' ' + texto;
          if (cuenta.reloj.textContent !== texto) cuenta.reloj.textContent = texto;
          cuenta.reloj.classList.add('barra-anuncios__reloj--listo');
        });
      }

      function prepararCuentas() {
        anuncios().forEach(function (anuncio) {
          if (!anuncio.hasAttribute('data-cuenta-atras')) return;

          var reloj = anuncio.querySelector('[data-reloj]');
          if (!reloj) return;

          var horaReinicio = parseInt(anuncio.getAttribute('data-hora-reinicio'), 10) || 0;
          var fija = anuncio.getAttribute('data-modo') === 'fija' ? leerFechaFija(anuncio) : null;

          cuentas.push({
            anuncio: anuncio,
            reloj: reloj,
            prefijo: anuncio.querySelector('[data-prefijo]'),
            fija: fija,
            horaReinicio: horaReinicio,
            objetivo: fija || siguienteReinicio(horaReinicio),
            alTerminar: anuncio.getAttribute('data-al-terminar'),
            textoFinal: anuncio.getAttribute('data-texto-final') || '',
            etiquetaDias: anuncio.getAttribute('data-etiqueta-dias') || 'd',
            terminada: false
          });
        });
      }

      function alCambiarVisibilidad() {
        pausas.oculta = document.hidden;
        programar();
      }

      var botonAnterior = raiz.querySelector('[data-anterior]');
      var botonSiguiente = raiz.querySelector('[data-siguiente]');

      if (botonAnterior) {
        botonAnterior.addEventListener('click', function () {
          anterior();
          reiniciarCiclo();
        });
      }

      if (botonSiguiente) {
        botonSiguiente.addEventListener('click', function () {
          siguiente();
          reiniciarCiclo();
        });
      }

      if (pausarHover) {
        raiz.addEventListener('mouseenter', function () {
          pausas.raton = true;
          programar();
        });
        raiz.addEventListener('mouseleave', function () {
          pausas.raton = false;
          programar();
        });
      }

      raiz.addEventListener('focusin', function (evento) {
        if (!esFocoTeclado(evento.target)) return;
        pausas.foco = true;
        programar();
      });

      raiz.addEventListener('focusout', function (evento) {
        if (evento.relatedTarget && raiz.contains(evento.relatedTarget)) return;
        pausas.foco = false;
        programar();
      });

      pista.addEventListener('touchstart', function (evento) {
        var toque = evento.changedTouches[0];
        inicioX = toque.clientX;
        inicioY = toque.clientY;
      }, { passive: true });

      pista.addEventListener('touchend', function (evento) {
        if (inicioX === null) return;

        var toque = evento.changedTouches[0];
        var distanciaX = toque.clientX - inicioX;
        var distanciaY = toque.clientY - inicioY;
        inicioX = null;
        inicioY = null;

        if (Math.abs(distanciaX) < 40 || Math.abs(distanciaX) < Math.abs(distanciaY)) return;
        if (anuncios().length < 2) return;

        if (distanciaX < 0) {
          siguiente();
        } else {
          anterior();
        }
        reiniciarCiclo();
      }, { passive: true });

      document.addEventListener('visibilitychange', alCambiarVisibilidad);

      if (posicionada) {
        medirAltura();
        if ('ResizeObserver' in window) {
          observadorAltura = new ResizeObserver(medirAltura);
          observadorAltura.observe(raiz);
        } else {
          window.addEventListener('resize', medirAltura);
        }
      }

      prepararCuentas();
      if (cuentas.length) {
        actualizarCuentas();
        temporizadorCuentas = setInterval(actualizarCuentas, 1000);
      }
      actualizarEstado();
      reiniciarProgreso();
      programar();
      lanzarDestello();

      return {
        seleccionar: function (bloque) {
          var indice = anuncios().indexOf(bloque);
          if (indice === -1) return;
          pausas.editor = true;
          instantaneo(function () {
            mostrar(indice, false);
          });
          reiniciarCiclo();
        },
        deseleccionar: function () {
          pausas.editor = false;
          programar();
        },
        destruir: function () {
          detener();
          clearInterval(temporizadorCuentas);
          clearTimeout(temporizadorSalida);
          document.removeEventListener('visibilitychange', alCambiarVisibilidad);
          if (observadorAltura) observadorAltura.disconnect();
          window.removeEventListener('resize', medirAltura);
        }
      };
    }

    function iniciarTodas(contexto) {
      var raices = (contexto || document).querySelectorAll('.barra-anuncios');

      Array.prototype.forEach.call(raices, function (raiz) {
        if (raiz.hasAttribute('data-iniciada')) return;
        raiz.setAttribute('data-iniciada', '');

        var id = raiz.getAttribute('data-seccion');
        if (instancias[id]) instancias[id].destruir();

        var instancia = crearInstancia(raiz);
        if (instancia) instancias[id] = instancia;
      });
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });

    document.addEventListener('shopify:section:reorder', function () {
      Array.prototype.forEach.call(document.querySelectorAll('.barra-anuncios'), colocarSobreCabecera);
    });

    document.addEventListener('shopify:section:unload', function (evento) {
      var id = evento.detail && evento.detail.sectionId;
      if (id && instancias[id]) {
        instancias[id].destruir();
        delete instancias[id];
      }
    });

    document.addEventListener('shopify:block:select', function (evento) {
      var id = evento.detail && evento.detail.sectionId;
      if (id && instancias[id]) instancias[id].seleccionar(evento.target);
    });

    document.addEventListener('shopify:block:deselect', function (evento) {
      var id = evento.detail && evento.detail.sectionId;
      if (id && instancias[id]) instancias[id].deseleccionar();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarTodas(document);
      });
    } else {
      iniciarTodas(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecera-colecciones"] && !Shopify.designMode) return;
  try {
    
(function () {
  var CONSULTA_MOVIL = '(max-width: 989px)';
  var CLASE_ACTIVO = 'titulo-galeria-elemento--activo';
  var CLASE_INDICADOR_ACTIVO = 'titulo-galeria-indicador--activo';
  var CLASE_SALTO = 'titulo-galeria-titulo--permitir-salto';
  var instancias = [];

  function GaleriaMovil(seccion) {
    this.seccion = seccion;
    this.galeria = seccion.querySelector('[data-galeria]');
    this.titulo = seccion.querySelector('[data-titulo]');
    this.elementos = this.galeria ? Array.prototype.slice.call(this.galeria.querySelectorAll('[data-elemento]')) : [];
    this.indicadores = Array.prototype.slice.call(seccion.querySelectorAll('[data-indicador]'));
    this.indice = 0;
    this.temporizador = null;
    this.visible = true;
    this.consulta = window.matchMedia(CONSULTA_MOVIL);
    this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

    var segundos = parseFloat(seccion.getAttribute('data-intervalo'));
    this.intervalo = isNaN(segundos) ? 3000 : Math.max(1000, segundos * 1000);
    this.habilitado = seccion.getAttribute('data-carrusel') === 'true' && this.elementos.length > 1;
    this.ajustarTitulo = seccion.getAttribute('data-ajustar-titulo') === 'true';
    var minimo = parseFloat(seccion.getAttribute('data-minimo-titulo'));
    this.minimoTitulo = isNaN(minimo) ? 16 : minimo;

    this.alCambiarConsulta = this.actualizar.bind(this);
    this.alPulsarIndicador = this.gestionarIndicador.bind(this);
    this.alRedimensionar = this.programarAjuste.bind(this);

    this.enlazar();
    this.actualizar();
  }

  GaleriaMovil.prototype.enlazar = function () {
    if (typeof this.consulta.addEventListener === 'function') {
      this.consulta.addEventListener('change', this.alCambiarConsulta);
    } else if (typeof this.consulta.addListener === 'function') {
      this.consulta.addListener(this.alCambiarConsulta);
    }

    this.indicadores.forEach(function (boton) {
      boton.addEventListener('click', this.alPulsarIndicador);
    }, this);

    window.addEventListener('resize', this.alRedimensionar);

    if ('IntersectionObserver' in window) {
      var self = this;
      this.observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          self.visible = entrada.isIntersecting;
          self.evaluarRotacion();
        });
      }, { threshold: 0.15 });
      this.observador.observe(this.seccion);
    }

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      var referencia = this;
      document.fonts.ready.then(function () {
        referencia.escalarTitulo();
      });
    }
  };

  GaleriaMovil.prototype.programarAjuste = function () {
    if (this.pendiente) window.clearTimeout(this.pendiente);
    var self = this;
    this.pendiente = window.setTimeout(function () {
      self.escalarTitulo();
    }, 150);
  };

  GaleriaMovil.prototype.escalarTitulo = function () {
    var titulo = this.titulo;
    if (!titulo || !this.ajustarTitulo) return;

    titulo.style.fontSize = '';
    titulo.classList.remove(CLASE_SALTO);

    if (!this.consulta.matches) return;

    var contenedor = titulo.parentElement;
    if (!contenedor) return;

    var disponible = contenedor.clientWidth;
    var ancho = titulo.scrollWidth;
    if (!disponible || !ancho || ancho <= disponible) return;

    var base = parseFloat(window.getComputedStyle(titulo).fontSize);
    var propuesto = Math.floor(base * (disponible / ancho));
    var definitivo = Math.max(this.minimoTitulo, propuesto);

    titulo.style.fontSize = definitivo + 'px';

    if (titulo.scrollWidth > contenedor.clientWidth) {
      titulo.classList.add(CLASE_SALTO);
    }
  };

  GaleriaMovil.prototype.gestionarIndicador = function (evento) {
    var destino = parseInt(evento.currentTarget.getAttribute('data-indicador'), 10);
    if (isNaN(destino)) return;
    this.mostrar(destino);
    this.detener();
    this.evaluarRotacion();
  };

  GaleriaMovil.prototype.mostrar = function (nuevoIndice) {
    if (!this.elementos.length) return;
    this.indice = (nuevoIndice + this.elementos.length) % this.elementos.length;

    this.elementos.forEach(function (elemento, posicion) {
      elemento.classList.toggle(CLASE_ACTIVO, posicion === this.indice);
    }, this);

    this.indicadores.forEach(function (boton, posicion) {
      boton.classList.toggle(CLASE_INDICADOR_ACTIVO, posicion === this.indice);
    }, this);
  };

  GaleriaMovil.prototype.arrancar = function () {
    if (this.temporizador) return;
    var self = this;
    this.temporizador = window.setInterval(function () {
      self.mostrar(self.indice + 1);
    }, this.intervalo);
  };

  GaleriaMovil.prototype.detener = function () {
    if (!this.temporizador) return;
    window.clearInterval(this.temporizador);
    this.temporizador = null;
  };

  GaleriaMovil.prototype.evaluarRotacion = function () {
    if (!this.habilitado || !this.consulta.matches) {
      this.detener();
      this.mostrar(0);
      return;
    }
    if (this.reducido.matches || !this.visible) {
      this.detener();
      return;
    }
    this.arrancar();
  };

  GaleriaMovil.prototype.actualizar = function () {
    this.evaluarRotacion();
    this.escalarTitulo();
  };

  GaleriaMovil.prototype.destruir = function () {
    this.detener();
    if (this.pendiente) window.clearTimeout(this.pendiente);
    if (this.observador) this.observador.disconnect();
    window.removeEventListener('resize', this.alRedimensionar);
    if (typeof this.consulta.removeEventListener === 'function') {
      this.consulta.removeEventListener('change', this.alCambiarConsulta);
    } else if (typeof this.consulta.removeListener === 'function') {
      this.consulta.removeListener(this.alCambiarConsulta);
    }
  };

  function limpiar(raiz) {
    instancias = instancias.filter(function (instancia) {
      var fuera = raiz ? raiz.contains(instancia.seccion) || raiz === instancia.seccion : !document.body.contains(instancia.seccion);
      if (!fuera) return true;
      instancia.destruir();
      return false;
    });
  }

  function iniciar(contexto) {
    var raiz = contexto || document;
    var secciones = Array.prototype.slice.call(raiz.querySelectorAll('[data-titulo-galeria]'));
    if (raiz.matches && raiz.matches('[data-titulo-galeria]')) secciones.push(raiz);

    secciones.forEach(function (seccion) {
      var existe = instancias.some(function (instancia) {
        return instancia.seccion === seccion;
      });
      if (!existe) instancias.push(new GaleriaMovil(seccion));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar();
    });
  } else {
    iniciar();
  }

  window.addEventListener('load', function () {
    instancias.forEach(function (instancia) {
      instancia.escalarTitulo();
    });
  });

  document.addEventListener('shopify:section:load', function (evento) {
    limpiar(evento.target);
    iniciar(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    limpiar(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-desplegable"] && !Shopify.designMode) return;
  try {
    
(function () {
  var raiz = null;
  var config = {};
  var abierto = false;
  var iniciado = false;
  var finReserva = 0;
  var intervaloReserva = null;
  var textoReserva = '';
  var modoOferta = false;
  var cargando = false;
  var mapaCompare = {};
  var handlesPedidos = {};
  var mapaStock = {};
  var stockPedido = {};
  var operacionCarrito = Promise.resolve();
  var cerrandoTimer = null;
  var overlayEl = null;
  var pendientesCantidad = {};

  function raizTienda() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function esc(valor) {
    return String(valor == null ? '' : valor).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatearDinero(cents) {
    var formato = config.money || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function conSeparadores(numero, precision, miles, decimal) {
      precision = precision == null ? 2 : precision;
      miles = miles == null ? ',' : miles;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(numero) || numero == null) return '0';
      numero = (numero / 100.0).toFixed(precision);
      var partes = numero.split('.');
      var enteros = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles);
      var decimales = partes[1] ? decimal + partes[1] : '';
      return enteros + decimales;
    }

    var coincidencia = formato.match(placeholder);
    if (!coincidencia) return formato;
    var valor = '';
    switch (coincidencia[1]) {
      case 'amount': valor = conSeparadores(cents, 2); break;
      case 'amount_no_decimals': valor = conSeparadores(cents, 0); break;
      case 'amount_with_comma_separator': valor = conSeparadores(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': valor = conSeparadores(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': valor = conSeparadores(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': valor = conSeparadores(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': valor = conSeparadores(cents, 2, "'", '.'); break;
      default: valor = conSeparadores(cents, 2);
    }
    return formato.replace(placeholder, valor);
  }

  function pedir(url, opciones) {
    return fetch(url, opciones).then(function (r) { return r.json(); });
  }

  function obtenerCarrito() {
    return pedir(config.urlCart, { headers: { 'Content-Type': 'application/json' } });
  }

  function asegurarCompare(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve();
    var handles = {};
    cart.items.forEach(function (i) {
      if (mapaCompare[i.variant_id] === undefined && i.handle && !handlesPedidos[i.handle]) {
        handles[i.handle] = true;
      }
    });
    var pendientes = Object.keys(handles);
    if (!pendientes.length) return Promise.resolve();
    return Promise.all(pendientes.map(function (handle) {
      handlesPedidos[handle] = true;
      return pedir(raizTienda() + 'products/' + handle + '.js')
        .then(function (producto) {
          if (producto && producto.variants) {
            producto.variants.forEach(function (v) {
              mapaCompare[v.id] = v.compare_at_price || 0;
            });
          }
        })
        .catch(function () {});
    }));
  }

  function leerStock(contenedor) {
    var nodo = contenedor && contenedor.querySelector('[data-carrito-stock]');
    if (!nodo) return;
    try {
      var datos = JSON.parse(nodo.textContent || '{}');
      Object.keys(datos).forEach(function (id) {
        mapaStock[id] = datos[id] === 1;
      });
    } catch (e) {}
  }

  function asegurarStock(cart) {
    if (config.mostrarStock !== 'true' || !config.seccionId) return Promise.resolve();
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve();
    var faltan = cart.items.some(function (i) {
      return mapaStock[i.variant_id] === undefined && !stockPedido[i.variant_id];
    });
    if (!faltan) return Promise.resolve();
    cart.items.forEach(function (i) { stockPedido[i.variant_id] = true; });
    return fetch(raizTienda() + '?sections=' + encodeURIComponent(config.seccionId))
      .then(function (r) { return r.json(); })
      .then(function (datos) {
        var html = datos && datos[config.seccionId];
        if (!html) return;
        leerStock(new DOMParser().parseFromString(html, 'text/html'));
      })
      .catch(function () {});
  }

  function pintar(cart) {
    if (!cart || !cart.items) {
      return obtenerCarrito().then(function (real) {
        if (real && real.items) return pintar(real);
      });
    }
    return Promise.all([asegurarCompare(cart), asegurarStock(cart)]).then(function () { render(cart); });
  }

  function estaAbierto() {
    return abierto || (raiz && raiz.classList.contains('carrito--abierto'));
  }

  function bloquearScroll(bloquear) {
    if (bloquear) {
      var sw = window.innerWidth - document.documentElement.clientWidth;
      if (sw > 0) document.body.style.paddingRight = sw + 'px';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function asegurarOverlay() {
    if (overlayEl && document.body.contains(overlayEl)) return overlayEl;
    overlayEl = document.createElement('div');
    overlayEl.className = 'carrito-fondo-js';
    overlayEl.style.setProperty('position', 'fixed', 'important');
    overlayEl.style.setProperty('inset', '0', 'important');
    overlayEl.style.setProperty('display', 'block', 'important');
    overlayEl.style.setProperty('z-index', '99999', 'important');
    overlayEl.style.setProperty('background-color', '#000', 'important');
    overlayEl.style.setProperty('opacity', '0', 'important');
    overlayEl.style.setProperty('transition', 'opacity 0.35s ease', 'important');
    overlayEl.style.setProperty('cursor', 'pointer', 'important');
    overlayEl.style.setProperty('pointer-events', 'none', 'important');
    overlayEl.addEventListener('click', cerrar);
    document.body.appendChild(overlayEl);
    return overlayEl;
  }

  function aplicarAhumado() {
    var o = asegurarOverlay();
    var pct = parseFloat(config.overlayPct);
    if (isNaN(pct)) pct = 45;
    var bl = parseFloat(config.overlayBlur);
    if (isNaN(bl)) bl = 4;
    var op = Math.max(0, Math.min(1, pct / 100));
    o.style.setProperty('display', 'block', 'important');
    o.style.setProperty('-webkit-backdrop-filter', 'blur(' + bl + 'px)', 'important');
    o.style.setProperty('backdrop-filter', 'blur(' + bl + 'px)', 'important');
    o.style.setProperty('pointer-events', 'auto', 'important');
    o.style.setProperty('opacity', String(op), 'important');
  }

  function quitarAhumado() {
    if (overlayEl) {
      overlayEl.style.setProperty('opacity', '0', 'important');
      overlayEl.style.setProperty('pointer-events', 'none', 'important');
    }
  }

  function cambiar(key, cantidad) {
    if (cargando) return;
    cargando = true;
    pedir(config.urlChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: cantidad })
    }).then(pintar).catch(function () {}).then(function () { cargando = false; });
  }

  function programarCantidad(key, cantidad, espera) {
    var pendiente = pendientesCantidad[key] || (pendientesCantidad[key] = {});
    pendiente.cantidad = Math.max(0, cantidad);
    clearTimeout(pendiente.temporizador);
    pendiente.temporizador = setTimeout(function () { enviarCantidad(key); }, espera);
  }

  function enviarCantidad(key) {
    var pendiente = pendientesCantidad[key];
    if (!pendiente) return;
    if (cargando) {
      pendiente.temporizador = setTimeout(function () { enviarCantidad(key); }, 150);
      return;
    }
    delete pendientesCantidad[key];
    cambiar(key, pendiente.cantidad);
  }

  function anadir(varianteId, boton) {
    if (cargando) return;
    cargando = true;
    if (boton) boton.disabled = true;
    pedir(config.urlAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(varianteId), quantity: 1 }] })
    }).then(obtenerCarrito).then(pintar).catch(function () {}).then(function () {
      cargando = false;
      if (boton) boton.disabled = false;
    });
  }

  function nombreVariante(item) {
    if (item.options_with_values && item.options_with_values.length) {
      var partes = [];
      item.options_with_values.forEach(function (o) {
        if (o.value && o.value !== 'Default Title') partes.push(o.value);
      });
      return partes.join(' / ');
    }
    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    return '';
  }

  function partirTitulo(titulo) {
    var texto = String(titulo || '');
    var corte = texto.indexOf('|');
    var marca = '';
    var nombre = texto.trim();
    if (corte !== -1) {
      marca = texto.slice(0, corte).trim();
      nombre = texto.slice(corte + 1).trim();
    }
    if (config.nombreFrase === 'true' && nombre) {
      nombre = nombre.toLocaleLowerCase('es');
      nombre = nombre.charAt(0).toLocaleUpperCase('es') + nombre.slice(1);
    }
    return { marca: marca, nombre: nombre };
  }

  function imagenReducida(url) {
    if (!url || url.indexOf('data:') === 0) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=240';
  }

  function plantillaItem(item) {
    var imagen = item.image || (item.featured_image && item.featured_image.url) || '';
    var url = esc(item.url || '#');
    var titulo = esc(item.product_title);
    var partesTitulo = partirTitulo(item.product_title);
    var variante = nombreVariante(item);
    var compare = mapaCompare[item.variant_id] || 0;
    var referencia = Math.max(compare, item.original_price);
    var descuento = referencia > item.final_price;
    var stockBajo = config.mostrarStock === 'true' && mapaStock[item.variant_id] === true;
    var iconoMenos = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8"/></svg>';
    var iconoMas = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M2 6h8M6 2v8"/></svg>';

    var precioHtml = '';
    if (descuento) {
      precioHtml += '<s>' + esc(formatearDinero(referencia)) + '</s>';
    }
    precioHtml += '<span class="carrito-item-precio-final">' + esc(formatearDinero(item.final_price)) + '</span>';

    return '' +
      '<div class="carrito-item" data-item data-key="' + esc(item.key) + '">' +
      '  <a class="carrito-item-imagen" href="' + url + '">' +
      (imagen ? '<img src="' + esc(imagenReducida(imagen)) + '" alt="' + titulo + '" loading="lazy">' : '') +
      '  </a>' +
      '  <div class="carrito-item-info">' +
      '    <div class="carrito-item-fila">' +
      '      <a class="carrito-item-nombres" href="' + url + '">' +
      (partesTitulo.marca ? '<span class="carrito-item-marca">' + esc(partesTitulo.marca) + '</span>' : '') +
      '        <span class="carrito-item-nombre">' + esc(partesTitulo.nombre) + '</span>' +
      '      </a>' +
      '      <button type="button" class="carrito-item-eliminar" data-eliminar aria-label="Eliminar">' +
      '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 6.5h15"/><path d="M9.5 6.5V4.5h5v2"/><path d="M6.5 6.5l1 13h9l1-13"/><path d="M10.5 10v6M13.5 10v6"/></svg>' +
      '      </button>' +
      '    </div>' +
      '    <div class="carrito-item-precio">' + precioHtml + '</div>' +
      (variante ? '<div class="carrito-item-variante">' + esc(variante) + '</div>' : '') +
      (stockBajo ? '<span class="carrito-item-stock"><span class="carrito-item-stock-punto" aria-hidden="true"></span>' + esc(config.stockTexto) + '</span>' : '') +
      '    <div class="carrito-item-cantidad-fila">' +
      '      <div class="carrito-cantidad">' +
      '        <button type="button" class="carrito-cantidad-boton" data-menos aria-label="Restar">' + iconoMenos + '</button>' +
      '        <span class="carrito-cantidad-valor" data-cantidad>' + (pendientesCantidad[item.key] ? pendientesCantidad[item.key].cantidad : item.quantity) + '</span>' +
      '        <button type="button" class="carrito-cantidad-boton" data-mas aria-label="Sumar">' + iconoMas + '</button>' +
      '      </div>' +
      '    </div>' +
      '  </div>' +
      '</div>';
  }

  function pintarConMarcadores(el, texto, valores) {
    el.textContent = '';
    String(texto || '').split(/(\{\w+\})/).forEach(function (trozo) {
      var clave = trozo.match(/^\{(\w+)\}$/);
      if (clave && Object.prototype.hasOwnProperty.call(valores, clave[1])) {
        var fuerte = document.createElement('strong');
        fuerte.textContent = valores[clave[1]];
        el.appendChild(fuerte);
      } else if (trozo) {
        el.appendChild(document.createTextNode(trozo));
      }
    });
  }

  function renderEnvio(cart) {
    if (config.mostrarEnvio !== 'true') return;
    var envio = raiz.querySelector('[data-envio]');
    var texto = raiz.querySelector('[data-envio-texto]');
    var relleno = raiz.querySelector('[data-envio-relleno]');
    var barra = raiz.querySelector('.carrito-envio-barra');
    if (!envio || !texto || !relleno) return;

    var umbral = (parseFloat(config.umbral) || 0) * 100;
    if (umbral <= 0) { envio.hidden = true; return; }
    envio.hidden = false;

    var total = cart.total_price;
    var restante = umbral - total;

    if (restante <= 0) {
      texto.textContent = config.envioConseguido || '';
      texto.style.setProperty('margin-bottom', '0', 'important');
      if (barra) barra.hidden = true;
      relleno.style.setProperty('width', '100%', 'important');
      return;
    }

    if (barra) barra.hidden = false;
    texto.style.removeProperty('margin-bottom');

    texto.textContent = '';
    texto.appendChild(document.createTextNode((config.envioPre || '') + ' '));
    var fuerte = document.createElement('strong');
    fuerte.textContent = formatearDinero(restante);
    texto.appendChild(fuerte);
    texto.appendChild(document.createTextNode(' ' + (config.envioPost || '')));

    var pct = Math.max(2, Math.min(100, (total / umbral) * 100));
    relleno.style.setProperty('width', pct + '%', 'important');
  }

  function renderTotales(cart) {
    var total = raiz.querySelector('[data-total]');
    var original = raiz.querySelector('[data-total-original]');
    var ahorro = raiz.querySelector('[data-ahorro]');
    if (total) total.textContent = formatearDinero(cart.total_price);

    var originalTotal = 0;
    cart.items.forEach(function (i) {
      var compare = mapaCompare[i.variant_id] || 0;
      var referencia = Math.max(compare, i.original_price);
      originalTotal += referencia * i.quantity;
    });

    var diferencia = originalTotal - cart.total_price;

    if (diferencia > 0) {
      if (original) { original.hidden = false; original.textContent = formatearDinero(originalTotal); }
      if (ahorro) { ahorro.hidden = false; ahorro.textContent = '−' + formatearDinero(diferencia); }
    } else {
      if (original) original.hidden = true;
      if (ahorro) ahorro.hidden = true;
    }
  }

  function listaTextos(valor, cantidad, porDefecto) {
    var lista = String(valor || '').split(',').map(function (t) { return t.trim(); });
    if (lista.length !== cantidad) lista = porDefecto.split(',');
    return lista;
  }

  function sumarDias(desde, dias, soloLaborables) {
    var fecha = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate());
    var sumados = 0;
    while (sumados < dias) {
      fecha.setDate(fecha.getDate() + 1);
      if (!soloLaborables || (fecha.getDay() !== 0 && fecha.getDay() !== 6)) sumados++;
    }
    return fecha;
  }

  function renderEntrega() {
    var caja = raiz.querySelector('[data-entrega]');
    var texto = raiz.querySelector('[data-entrega-texto]');
    if (!caja || !texto) return;

    var min = parseInt(config.entregaMin, 10);
    var max = parseInt(config.entregaMax, 10);
    if (isNaN(min)) min = 0;
    if (isNaN(max)) max = min;
    if (max < min) { var cambio = min; min = max; max = cambio; }

    var laborables = config.entregaLaborables === 'true';
    var hoy = new Date();
    var inicio = sumarDias(hoy, min, laborables);
    var fin = sumarDias(hoy, max, laborables);
    var dias = listaTextos(config.entregaDias, 7, 'dom.,lun.,mar.,mié.,jue.,vie.,sáb.');
    var meses = listaTextos(config.entregaMeses, 12, 'ene.,feb.,mar.,abr.,may.,jun.,jul.,ago.,sept.,oct.,nov.,dic.');
    var mismoMes = inicio.getMonth() === fin.getMonth() && inicio.getFullYear() === fin.getFullYear();

    pintarConMarcadores(texto, config.entregaTexto, {
      inicio: dias[inicio.getDay()] + ' ' + inicio.getDate() + (mismoMes ? '' : ' ' + meses[inicio.getMonth()]),
      fin: dias[fin.getDay()] + ' ' + fin.getDate() + ' ' + meses[fin.getMonth()]
    });
    caja.hidden = false;
  }

  function actualizarFlechas() {
    var pista = raiz ? raiz.querySelector('[data-upsell-pista]') : null;
    if (!pista) return;
    var prev = raiz.querySelector('[data-upsell-prev]');
    var next = raiz.querySelector('[data-upsell-next]');
    var maximo = pista.scrollWidth - pista.clientWidth;
    if (prev) prev.classList.toggle('carrito-upsell-flecha--inactiva', pista.scrollLeft <= 1);
    if (next) next.classList.toggle('carrito-upsell-flecha--inactiva', pista.scrollLeft >= maximo - 1);
  }

  function ocultarUpsellEnCesta(cart) {
    var items = raiz.querySelectorAll('[data-upsell-item]');
    if (!items.length) return;
    var ids = {};
    cart.items.forEach(function (i) { ids[i.product_id] = true; });
    var visibles = 0;
    items.forEach(function (el) {
      var pid = parseInt(el.getAttribute('data-producto-id'), 10);
      el.hidden = !!ids[pid];
      if (!el.hidden) visibles++;
    });
    var bloque = raiz.querySelector('[data-upsell]');
    if (bloque) bloque.hidden = visibles === 0;
    actualizarFlechas();
  }

  function actualizarBurbuja(cantidad) {
    var contador = raiz ? raiz.querySelector('[data-contador]') : null;
    if (contador) contador.textContent = cantidad;

    var icono = document.querySelector('#cart-icon-bubble');
    if (!icono) return;

    var burbuja = icono.querySelector('.cart-count-bubble');
    if (cantidad > 0) {
      if (!burbuja) {
        burbuja = document.createElement('div');
        burbuja.className = 'cart-count-bubble';
        var s = document.createElement('span');
        s.setAttribute('aria-hidden', 'true');
        burbuja.appendChild(s);
        icono.appendChild(burbuja);
      }
      var span = burbuja.querySelector('span[aria-hidden]');
      if (span) span.textContent = cantidad < 100 ? cantidad : '';
      burbuja.style.display = '';
    } else if (burbuja) {
      burbuja.style.display = 'none';
    }
  }

  function render(cart) {
    if (!cart || !raiz) return;
    var lleno = raiz.querySelector('[data-lleno]');
    var vacio = raiz.querySelector('[data-vacio]');
    var pie = raiz.querySelector('[data-pie]');
    var lista = raiz.querySelector('[data-lista]');

    actualizarBurbuja(cart.item_count);

    if (cart.item_count > 0) {
      if (lleno) lleno.hidden = false;
      if (vacio) vacio.hidden = true;
      if (pie) pie.hidden = false;

      if (lista) {
        var html = '';
        cart.items.forEach(function (item) { html += plantillaItem(item); });
        lista.innerHTML = html;
      }
      renderEnvio(cart);
      renderTotales(cart);
      renderEntrega();
      ocultarUpsellEnCesta(cart);
      iniciarReserva();
    } else {
      if (lleno) lleno.hidden = true;
      if (vacio) vacio.hidden = false;
      if (pie) pie.hidden = true;
      detenerReserva();
      mostrarCajaReserva(false);
    }
  }

  function fechaFinOferta() {
    var valor = String(config.ofertaFin || '').trim();
    if (!valor) return 0;
    var partes = valor.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    var fecha = null;
    if (partes) {
      fecha = new Date(+partes[1], +partes[2] - 1, +partes[3], partes[4] ? +partes[4] : 23, partes[5] ? +partes[5] : 59, partes[4] ? 0 : 59);
    } else {
      partes = valor.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);
      if (partes) fecha = new Date(+partes[3], +partes[2] - 1, +partes[1], partes[4] ? +partes[4] : 23, partes[5] ? +partes[5] : 59, partes[4] ? 0 : 59);
    }
    return fecha && !isNaN(fecha.getTime()) ? fecha.getTime() : 0;
  }

  function formatoTiempo(ms) {
    var total = Math.floor(ms / 1000);
    var d = Math.floor(total / 86400);
    var h = Math.floor((total % 86400) / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    if (d > 0) return d + 'd ' + dos(h) + ':' + dos(m) + ':' + dos(s);
    if (h > 0) return dos(h) + ':' + dos(m) + ':' + dos(s);
    return dos(m) + ':' + dos(s);
  }

  function mostrarCajaReserva(visible) {
    var caja = raiz ? raiz.querySelector('[data-reserva]') : null;
    if (caja) caja.hidden = !visible;
  }

  function iniciarReserva() {
    if (config.mostrarReserva !== 'true') return;
    var el = raiz.querySelector('[data-reserva-texto]');
    if (!el) return;

    var finOferta = fechaFinOferta();
    if (finOferta) {
      modoOferta = true;
      textoReserva = config.ofertaTexto || '';
      finReserva = finOferta;
    } else {
      modoOferta = false;
      textoReserva = config.reservaTexto || '';

      var min = parseFloat(config.reservaMin) || 10;
      var clave = 'carritoReservaFin';
      var guardado = sessionStorage.getItem(clave);

      if (!guardado || isNaN(Number(guardado)) || Number(guardado) < Date.now()) {
        guardado = String(Date.now() + min * 60000);
        sessionStorage.setItem(clave, guardado);
      }
      finReserva = Number(guardado);
    }

    mostrarCajaReserva(true);
    actualizarReserva();
    clearInterval(intervaloReserva);
    intervaloReserva = setInterval(actualizarReserva, 1000);
  }

  function detenerReserva() {
    clearInterval(intervaloReserva);
  }

  function actualizarReserva() {
    var el = raiz.querySelector('[data-reserva-texto]');
    if (!el) return;
    var restante = Math.max(0, finReserva - Date.now());
    if (modoOferta && restante <= 0) {
      clearInterval(intervaloReserva);
      mostrarCajaReserva(false);
      return;
    }
    pintarConMarcadores(el, textoReserva, { tiempo: formatoTiempo(restante) });
    if (restante <= 0) clearInterval(intervaloReserva);
  }

  function abrir() {
    if (!raiz) return;
    if (cerrandoTimer) { clearTimeout(cerrandoTimer); cerrandoTimer = null; }
    raiz.classList.add('carrito--visible');
    void raiz.offsetWidth;
    raiz.classList.add('carrito--abierto');
    aplicarAhumado();
    abierto = true;
    bloquearScroll(true);
    setTimeout(function () {
      Promise.race([
        operacionCarrito,
        new Promise(function (r) { setTimeout(r, 900); })
      ]).then(function () {
        return obtenerCarrito();
      }).then(pintar).catch(function () {
        obtenerCarrito().then(pintar).catch(function () {});
      });
    }, 380);
  }

  function cerrar() {
    if (!raiz) return;
    raiz.classList.remove('carrito--abierto');
    quitarAhumado();
    abierto = false;
    bloquearScroll(false);
    detenerReserva();
    if (cerrandoTimer) clearTimeout(cerrandoTimer);
    cerrandoTimer = setTimeout(function () {
      raiz.classList.remove('carrito--visible');
      cerrandoTimer = null;
    }, 420);
  }

  function abrirDesdeIcono() {
    if (!raiz || !iniciado) iniciar();
    if (raiz) abrir();
  }

  function marcarCarritoActivo() {
    var root = document.querySelector('[data-carrito]');
    if (root && root.getAttribute('data-activar') === 'true') {
      document.documentElement.classList.add('carrito-activo');
    }
  }

  function interceptarIconoCarrito() {
    if (window.__carritoIconoInterceptado) return;
    window.__carritoIconoInterceptado = true;
    document.addEventListener('click', function (e) {
      var icono = e.target && e.target.closest ? e.target.closest('#cart-icon-bubble, .header__icon--cart, [data-abrir-carrito]') : null;
      if (!icono) return;
      var root = document.querySelector('[data-carrito]');
      if (!root || root.getAttribute('data-activar') !== 'true') return;
      e.preventDefault();
      e.stopPropagation();
      abrirDesdeIcono();
    }, true);
  }

  function neutralizarAperturaTema() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;
    ['cart-drawer', 'cart-notification'].forEach(function (nombre) {
      try {
        window.customElements.whenDefined(nombre).then(function () {
          var C = window.customElements.get(nombre);
          if (C && C.prototype && !C.prototype.__carritoSinApertura) {
            C.prototype.__carritoSinApertura = true;
            if (typeof C.prototype.open === 'function') {
              C.prototype.open = function () {};
            }
          }
        }).catch(function () {});
      } catch (e) {}
    });
  }

  function envolverFetchBurbuja() {
    if (window.__carritoFetchEnv || typeof window.fetch !== 'function') return;
    window.__carritoFetchEnv = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) {}
      var esMutacion = url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/change') !== -1);
      var p = origFetch.apply(this, args);
      if (esMutacion) {
        operacionCarrito = operacionCarrito.then(function () { return p.catch(function () {}); }).catch(function () {});
        p.then(function () {
          obtenerCarrito().then(function (cart) {
            if (!cart) return;
            pintar(cart);
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  function protegerAutoApertura() {
    marcarCarritoActivo();
    neutralizarAperturaTema();
    window.addEventListener('load', neutralizarAperturaTema);
    envolverFetchBurbuja();
  }

  function enlazar() {
    raiz.addEventListener('click', function (e) {
      if (e.target.closest('[data-cerrar]')) { cerrar(); return; }
      if (e.target.closest('.carrito-trustpilot')) return;
      var panel = raiz.querySelector('.carrito-panel');
      if (abierto && panel && !panel.contains(e.target)) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && abierto) cerrar();
    });

    document.addEventListener('carrito:abrir', function () {
      if (config.activar !== 'true') return;
      abrir();
    });

    var lista = raiz.querySelector('[data-lista]');
    if (lista) {
      lista.addEventListener('click', function (e) {
        var item = e.target.closest('[data-item]');
        if (!item) return;
        var key = item.getAttribute('data-key');
        var valorEl = item.querySelector('[data-cantidad]');
        var q = parseInt(valorEl ? valorEl.textContent : '1', 10);
        var nueva = null;
        if (e.target.closest('[data-mas]')) nueva = q + 1;
        else if (e.target.closest('[data-menos]')) nueva = Math.max(0, q - 1);
        if (nueva !== null) {
          if (valorEl) valorEl.textContent = nueva;
          programarCantidad(key, nueva, nueva === 0 ? 0 : 350);
        } else if (e.target.closest('[data-eliminar]')) {
          item.style.setProperty('opacity', '0.4', 'important');
          programarCantidad(key, 0, 0);
        }
      });
    }

    var pista = raiz.querySelector('[data-upsell-pista]');
    if (pista) {
      pista.addEventListener('click', function (e) {
        var boton = e.target.closest('[data-anadir]');
        if (!boton) return;
        var v = boton.getAttribute('data-variante');
        if (v) anadir(v, boton);
      });

      pista.addEventListener('scroll', actualizarFlechas, { passive: true });

      var prev = raiz.querySelector('[data-upsell-prev]');
      var next = raiz.querySelector('[data-upsell-next]');
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -300, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: 300, behavior: 'smooth' }); });
    }

    var desplegables = raiz.querySelector('[data-desplegables]');
    if (desplegables) {
      desplegables.addEventListener('click', function (e) {
        var boton = e.target.closest('[data-desplegable]');
        if (!boton) return;
        var abrirEste = boton.getAttribute('aria-expanded') !== 'true';
        desplegables.querySelectorAll('[data-desplegable]').forEach(function (otro) {
          otro.setAttribute('aria-expanded', 'false');
        });
        if (abrirEste) boton.setAttribute('aria-expanded', 'true');
      });
    }
  }

  function iniciar() {
    var nueva = document.querySelector('[data-carrito]');
    if (!nueva) return;
    if (nueva === raiz && iniciado && nueva.parentNode === document.body) return;
    raiz = nueva;
    iniciado = true;

    if (raiz.parentNode !== document.body) {
      var previos = document.querySelectorAll('body > [data-carrito]');
      previos.forEach(function (el) { if (el !== raiz) { try { el.remove(); } catch (e) {} } });
      document.body.appendChild(raiz);
    }

    var origFondo = raiz.querySelector('.carrito-fondo');
    if (origFondo) origFondo.style.setProperty('display', 'none', 'important');
    asegurarOverlay();

    config = {
      activar: raiz.getAttribute('data-activar'),
      seccionId: raiz.getAttribute('data-seccion-id'),
      urlCart: raiz.getAttribute('data-url-cart'),
      urlChange: raiz.getAttribute('data-url-change'),
      urlAdd: raiz.getAttribute('data-url-add'),
      money: raiz.getAttribute('data-money'),
      umbral: raiz.getAttribute('data-umbral'),
      mostrarEnvio: raiz.getAttribute('data-mostrar-envio'),
      envioPre: raiz.getAttribute('data-envio-pre'),
      envioPost: raiz.getAttribute('data-envio-post'),
      envioConseguido: raiz.getAttribute('data-envio-conseguido'),
      mostrarReserva: raiz.getAttribute('data-mostrar-reserva'),
      reservaMin: raiz.getAttribute('data-reserva-min'),
      reservaTexto: raiz.getAttribute('data-reserva-texto'),
      ofertaFin: raiz.getAttribute('data-oferta-fin'),
      ofertaTexto: raiz.getAttribute('data-oferta-texto'),
      nombreFrase: raiz.getAttribute('data-nombre-frase'),
      mostrarStock: raiz.getAttribute('data-mostrar-stock'),
      stockTexto: raiz.getAttribute('data-stock-texto'),
      entregaMin: raiz.getAttribute('data-entrega-min'),
      entregaMax: raiz.getAttribute('data-entrega-max'),
      entregaLaborables: raiz.getAttribute('data-entrega-laborables'),
      entregaTexto: raiz.getAttribute('data-entrega-texto'),
      entregaDias: raiz.getAttribute('data-entrega-dias'),
      entregaMeses: raiz.getAttribute('data-entrega-meses'),
      overlayPct: raiz.getAttribute('data-overlay-pct'),
      overlayBlur: raiz.getAttribute('data-overlay-blur')
    };
    leerStock(raiz);
    enlazar();
    if (config.activar === 'true') protegerAutoApertura();
    obtenerCarrito().then(function (cart) {
      if (!cart) return;
      pintar(cart);
    }).catch(function () {});
  }

  interceptarIconoCarrito();
  marcarCarritoActivo();
  neutralizarAperturaTema();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-carrito]')) { iniciado = false; iniciar(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-productos"] && !Shopify.designMode) return;
  try {
    
  class PcolCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.seccion = this.closest('.pcol-seccion');
      this.barra = this.seccion ? this.seccion.querySelector('[data-progreso-barra]') : null;
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      if (!this.pista) return;

      this.onScroll = this.actualizar.bind(this);
      this.onResize = () => {
        this.actualizar();
        this.medirTallas();
      };
      this.pista.addEventListener('scroll', this.onScroll, { passive: true });

      this.onClick = this.gestionarClick.bind(this);
      this.addEventListener('click', this.onClick);

      this.onTouch = (evento) => {
        const media = evento.target && evento.target.closest ? evento.target.closest('.pcol-media') : null;
        if (media && this.contains(media)) this.mostrarTallas(media);
      };
      this.addEventListener('touchstart', this.onTouch, { passive: true });
      this.addEventListener('pointerdown', this.onTouch, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.mover(-1));
      if (this.next) this.next.addEventListener('click', () => this.mover(1));

      this.tallasPaneles = Array.from(this.querySelectorAll('.pcol-tallas'));
      this.tallasPaneles.forEach((panel) => {
        const lista = panel.querySelector('[data-tallas-lista]');
        const barra = panel.querySelector('[data-tallas-scroll-barra]');
        if (!lista || !barra) return;
        panel._lista = lista;
        panel._barra = barra;
        panel._onScroll = () => this.actualizarIndicadorTallas(panel);
        lista.addEventListener('scroll', panel._onScroll, { passive: true });
      });

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.onResize);
        this.observador.observe(this.pista);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      this.actualizar();
      this.medirTallas();
    }

    disconnectedCallback() {
      if (this.pista) this.pista.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onClick);
      if (this.onTouch) {
        this.removeEventListener('touchstart', this.onTouch);
        this.removeEventListener('pointerdown', this.onTouch);
      }
      if (this.observador) this.observador.disconnect();
      window.removeEventListener('resize', this.onResize);
      if (this.tallasPaneles) {
        this.tallasPaneles.forEach((panel) => {
          if (panel._lista && panel._onScroll) panel._lista.removeEventListener('scroll', panel._onScroll);
        });
      }
    }

    medirTallas() {
      if (!this.tallasPaneles) return;
      this.tallasPaneles.forEach((panel) => this.actualizarIndicadorTallas(panel));
    }

    actualizarIndicadorTallas(panel) {
      const lista = panel._lista;
      const barra = panel._barra;
      if (!lista || !barra) return;
      const visible = lista.clientWidth || 1;
      const total = lista.scrollWidth || 1;
      if (total - visible > 2) {
        panel.classList.add('pcol-tallas--scroll');
        const prop = Math.min(visible / total, 1);
        const avance = Math.min(Math.max(lista.scrollLeft / total, 0), 1 - prop);
        barra.style.setProperty('width', prop * 100 + '%', 'important');
        barra.style.setProperty('left', avance * 100 + '%', 'important');
      } else {
        panel.classList.remove('pcol-tallas--scroll');
      }
    }

    paso() {
      const item = this.pista.querySelector('.pcol-item');
      const gap = parseInt(getComputedStyle(this.pista).columnGap, 10) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.pista.clientWidth;
    }

    mover(dir) {
      this.pista.scrollBy({ left: dir * this.paso(), behavior: 'smooth' });
    }

    actualizar() {
      const visible = this.pista.clientWidth || 1;
      const total = this.pista.scrollWidth || 1;
      const max = total - visible;

      if (this.barra) {
        if (max <= 2) {
          this.barra.style.setProperty('width', '100%', 'important');
          this.barra.style.setProperty('left', '0%', 'important');
        } else {
          const proporcion = Math.min(visible / total, 1);
          const avance = Math.min(Math.max(this.pista.scrollLeft / total, 0), 1 - proporcion);
          this.barra.style.setProperty('width', proporcion * 100 + '%', 'important');
          this.barra.style.setProperty('left', avance * 100 + '%', 'important');
        }
      }

      if (this.prev) this.prev.toggleAttribute('disabled', this.pista.scrollLeft <= 2);
      if (this.next) this.next.toggleAttribute('disabled', this.pista.scrollLeft >= max - 2);
    }

    gestionarClick(evento) {
      const talla = evento.target.closest('[data-talla]');
      if (talla && this.contains(talla)) {
        evento.preventDefault();
        this.anadirTalla(talla);
        return;
      }

      const flechaImg = evento.target.closest('[data-img-prev], [data-img-next]');
      if (flechaImg && this.contains(flechaImg)) {
        evento.preventDefault();
        const dir = flechaImg.hasAttribute('data-img-next') ? 1 : -1;
        this.cambiarImagen(flechaImg, dir);
        return;
      }

      const color = evento.target.closest('[data-color]');
      if (color && this.contains(color)) {
        evento.preventDefault();
        const grupo = color.closest('.pcol-colores');
        if (grupo) grupo.querySelectorAll('.pcol-color').forEach((c) => c.classList.remove('pcol-color--activo'));
        color.classList.add('pcol-color--activo');
        const tarjeta = color.closest('.pcol-tarjeta');
        const media = tarjeta ? tarjeta.querySelector('.pcol-media') : null;
        const pos = color.getAttribute('data-img-pos');
        if (media && pos) this.activarImagenPorPos(media, pos);
        return;
      }
    }

    activarImagenPorPos(media, pos) {
      const galeria = media.querySelector('[data-galeria]');
      if (!galeria) return;
      const slides = galeria.querySelectorAll('.pcol-galeria-slide');
      let objetivo = null;
      slides.forEach((slide) => {
        if (slide.getAttribute('data-img-pos') === String(pos)) objetivo = slide;
      });
      if (!objetivo) return;
      slides.forEach((slide) => slide.classList.remove('pcol-galeria-slide--activa'));
      objetivo.classList.add('pcol-galeria-slide--activa');
    }

    mostrarTallas(media) {
      if (!media) return;
      this.querySelectorAll('.pcol-media--tallas').forEach((otro) => {
        if (otro !== media) otro.classList.remove('pcol-media--tallas');
      });
      media.classList.add('pcol-media--tallas');
    }

    cambiarImagen(flecha, dir) {
      const media = flecha.closest('.pcol-media');
      if (!media) return;
      this.mostrarTallas(media);
      const galeria = media.querySelector('[data-galeria]');
      if (!galeria) return;
      const slides = galeria.querySelectorAll('.pcol-galeria-slide');
      if (slides.length < 2) return;

      let actual = 0;
      slides.forEach((slide, i) => {
        if (slide.classList.contains('pcol-galeria-slide--activa')) actual = i;
      });

      const siguiente = (actual + dir + slides.length) % slides.length;
      slides[actual].classList.remove('pcol-galeria-slide--activa');
      slides[siguiente].classList.add('pcol-galeria-slide--activa');
    }

    raiz() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async anadirTalla(boton) {
      const variante = boton.dataset.variante;
      if (!variante || boton.getAttribute('aria-busy') === 'true') return;

      boton.setAttribute('aria-busy', 'true');
      this.volarAlCarrito(boton);

      try {
        const respuesta = await fetch(this.raiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] })
        });

        const datos = await respuesta.json();
        if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || 'error');

        await this.actualizarBurbuja();
        document.dispatchEvent(new CustomEvent('pcol:carrito-actualizado', { detail: datos }));

        boton.classList.add('pcol-talla--anadida');
        clearTimeout(boton.temporizador);
        boton.temporizador = setTimeout(() => boton.classList.remove('pcol-talla--anadida'), 1100);
      } catch (e) {
        boton.classList.add('pcol-talla--error');
        clearTimeout(boton.temporizador);
        boton.temporizador = setTimeout(() => boton.classList.remove('pcol-talla--error'), 1100);
      } finally {
        boton.removeAttribute('aria-busy');
      }
    }

    volarAlCarrito(origen) {
      if (this.dataset.animacion === 'false') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const carrito = document.getElementById('cart-icon-bubble');
      if (!carrito || !origen) return;

      const o = origen.getBoundingClientRect();
      const c = carrito.getBoundingClientRect();
      if (!o.width || !c.width) return;

      const x0 = o.left + o.width / 2;
      const y0 = o.top + o.height / 2;
      const x1 = c.left + c.width / 2;
      const y1 = c.top + c.height / 2;
      const dx = x1 - x0;
      const dy = y1 - y0;
      const ang = Math.atan2(dy, dx) * 180 / Math.PI;
      const color = this.dataset.estrellaColor || '#FFC83D';

      const estrella = document.createElement('div');
      estrella.className = 'pcol-estrella';
      estrella.style.left = x0 + 'px';
      estrella.style.top = y0 + 'px';
      estrella.style.transform = 'translate(0px, 0px) rotate(' + ang + 'deg)';
      estrella.innerHTML =
        '<span class="pcol-estrella-cola"></span><span class="pcol-estrella-nucleo"></span>';
      document.body.appendChild(estrella);

      const nucleo = estrella.querySelector('.pcol-estrella-nucleo');
      const cola = estrella.querySelector('.pcol-estrella-cola');
      if (nucleo) {
        nucleo.style.background = 'radial-gradient(circle, #ffffff 0%, ' + color + ' 55%, ' + color + ' 100%)';
        nucleo.style.boxShadow = '0 0 8px 2px ' + color + ', 0 0 18px 6px ' + color + ', 0 0 3px 1px rgba(0, 0, 0, 0.28)';
      }
      if (cola) {
        cola.style.background = 'linear-gradient(to left, ' + color + ', transparent)';
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          estrella.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + ang + 'deg) scale(0.3)';
          estrella.style.opacity = '0.15';
        });
      });

      window.setTimeout(() => {
        estrella.remove();
        carrito.classList.add('pcol-golpe');
        window.setTimeout(() => carrito.classList.remove('pcol-golpe'), 350);
      }, 430);
    }

    async actualizarBurbuja() {
      try {
        const respuesta = await fetch(this.raiz() + 'cart.js', { headers: { Accept: 'application/json' } });
        const carrito = await respuesta.json();
        const cuenta = carrito.item_count;

        const contenedor = document.getElementById('cart-icon-bubble');
        if (!contenedor) return;

        let burbuja = contenedor.querySelector('.cart-count-bubble');
        if (cuenta > 0) {
          if (!burbuja) {
            burbuja = document.createElement('div');
            burbuja.className = 'cart-count-bubble';
            contenedor.appendChild(burbuja);
          }
          burbuja.innerHTML = '<span aria-hidden="true">' + (cuenta < 100 ? cuenta : '') + '</span>';
        } else if (burbuja) {
          burbuja.remove();
        }
      } catch (e) {}
    }
  }

  if (!customElements.get('pcol-carrusel')) {
    customElements.define('pcol-carrusel', PcolCarrusel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contacto-lujo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animar(raiz) {
      var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var editor = window.Shopify && window.Shopify.designMode;
      if (reducir || editor || !('IntersectionObserver' in window)) return;
      var elementos = raiz.querySelectorAll('[data-aparecer]');
      if (!elementos.length) return;
      raiz.classList.add('contacto-lujo--animar');
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('is-visible');
          observador.unobserve(entrada.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      Array.prototype.forEach.call(elementos, function (el) { observador.observe(el); });
    }

    function atencion(raiz) {
      var caja = raiz.querySelector('[data-atencion]');
      if (!caja) return;
      var estado = caja.querySelector('[data-atencion-estado]');
      var apertura = parseFloat(caja.getAttribute('data-apertura'));
      var cierre = parseFloat(caja.getAttribute('data-cierre'));
      var rango = (caja.getAttribute('data-dias') || '1-5').split('-');
      var primerDia = parseInt(rango[0], 10);
      var ultimoDia = parseInt(rango[1], 10);
      var dias = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

      function actualizar() {
        var dia = null;
        var hora = null;
        var minuto = 0;
        try {
          var partes = new Intl.DateTimeFormat('en-US', {
            timeZone: caja.getAttribute('data-zona') || 'Europe/Madrid',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: 'h23'
          }).formatToParts(new Date());
          partes.forEach(function (parte) {
            if (parte.type === 'weekday') dia = dias[parte.value];
            if (parte.type === 'hour') hora = parseInt(parte.value, 10) % 24;
            if (parte.type === 'minute') minuto = parseInt(parte.value, 10);
          });
        } catch (error) {
          return;
        }
        if (dia === null || dia === undefined || hora === null || isNaN(hora)) return;
        var momento = hora + minuto / 60;
        var abierto = dia >= primerDia && dia <= ultimoDia && momento >= apertura && momento < cierre;
        caja.setAttribute('data-abierto', abierto ? 'true' : 'false');
        if (estado) {
          estado.textContent = caja.getAttribute(abierto ? 'data-texto-abierto' : 'data-texto-cerrado') || '';
          estado.hidden = !estado.textContent;
        }
      }

      actualizar();
      setInterval(actualizar, 60000);
    }

    function copiarRespaldo(valor) {
      var area = document.createElement('textarea');
      area.value = valor;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '0';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var correcto = false;
      try { correcto = document.execCommand('copy'); } catch (error) {}
      document.body.removeChild(area);
      return correcto;
    }

    function copiar(raiz) {
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-copiar]'), function (boton) {
        var texto = boton.querySelector('[data-copiar-texto]');
        boton.addEventListener('click', function (evento) {
          evento.preventDefault();
          evento.stopPropagation();
          var valor = boton.getAttribute('data-copiar') || '';
          var hecho = function () {
            boton.classList.add('is-copiado');
            if (texto) texto.textContent = boton.getAttribute('data-texto-copiado') || '';
            clearTimeout(boton.temporizador);
            boton.temporizador = setTimeout(function () {
              boton.classList.remove('is-copiado');
              if (texto) texto.textContent = boton.getAttribute('data-texto-copiar') || '';
            }, 2000);
          };
          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(valor).then(hecho).catch(function () {
              if (copiarRespaldo(valor)) hecho();
            });
          } else if (copiarRespaldo(valor)) {
            hecho();
          }
        });
      });
    }

    function asunto(raiz) {
      var formulario = raiz.querySelector('form');
      var pista = raiz.querySelector('[data-pista-asunto]');
      if (!formulario || !pista) return;
      var objetivo = (pista.getAttribute('data-opcion') || '').trim().toLowerCase();
      if (!objetivo) return;

      function valorActual() {
        var radio = formulario.querySelector('input[name="contact[Asunto]"]:checked');
        if (radio) return radio.value;
        var selector = formulario.querySelector('select[name="contact[Asunto]"]');
        return selector ? selector.value : '';
      }

      function actualizar() {
        pista.hidden = valorActual().trim().toLowerCase() !== objetivo;
      }

      formulario.addEventListener('change', actualizar);
      actualizar();
    }

    function envio(raiz) {
      var formulario = raiz.querySelector('form');
      var boton = raiz.querySelector('[data-enviar]');
      if (!formulario || !boton) return;
      var texto = boton.querySelector('[data-enviar-texto]');
      var original = texto ? texto.textContent : '';

      formulario.addEventListener('submit', function () {
        boton.classList.add('is-enviando');
        boton.setAttribute('aria-busy', 'true');
        var enviando = boton.getAttribute('data-texto-enviando');
        if (texto && enviando) texto.textContent = enviando;
      });

      window.addEventListener('pageshow', function (evento) {
        if (!evento.persisted) return;
        boton.classList.remove('is-enviando');
        boton.removeAttribute('aria-busy');
        if (texto) texto.textContent = original;
      });
    }

    function iniciar(raiz) {
      if (!raiz || raiz.__contactoListo) return;
      raiz.__contactoListo = true;
      animar(raiz);
      atencion(raiz);
      copiar(raiz);
      asunto(raiz);
      envio(raiz);
    }

    function iniciarTodas() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-contacto-lujo]'), iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodas);
    } else {
      iniciarTodas();
    }

    document.addEventListener('shopify:section:load', function (evento) {
      var raiz = evento.target ? evento.target.querySelector('[data-contacto-lujo]') : null;
      if (raiz) iniciar(raiz);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contador-heder"] && !Shopify.designMode) return;
  try {
    
  class BcatrasContador extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.diasEl = this.querySelector('[data-dias]');
      this.horasEl = this.querySelector('[data-horas]');
      this.minutosEl = this.querySelector('[data-minutos]');
      this.segundosEl = this.querySelector('[data-segundos]');
      this.cuentaEl = this.querySelector('[data-cuenta]');
      this.contenidoEl = this.querySelector('[data-contenido]');
      this.mensajeEl = this.querySelector('[data-mensaje]');

      this.tipo = this.dataset.tipo;
      this.alFinalizar = this.dataset.alFinalizar;
      this.mostrarDias = this.dataset.mostrarDias === 'true';
      this.objetivo = this.calcularObjetivo();

      this.actualizar();
      this.intervalo = setInterval(this.actualizar.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.intervalo);
    }

    calcularObjetivo() {
      if (this.tipo === 'regresiva') {
        const clave = 'bcatras-fin-' + this.dataset.seccion;
        const minutos = parseInt(this.dataset.duracion, 10) || 0;
        let fin = null;

        try {
          fin = window.localStorage.getItem(clave);
        } catch (e) {
          fin = null;
        }

        if (!fin) {
          fin = Date.now() + minutos * 60000;
          try {
            window.localStorage.setItem(clave, fin);
          } catch (e) {}
        }

        return parseInt(fin, 10);
      }

      const fecha = this.dataset.fecha;
      const hora = this.dataset.hora || '00:00';

      if (!fecha) return NaN;

      return new Date(fecha + 'T' + hora).getTime();
    }

    rellenar(valor) {
      return valor < 10 ? '0' + valor : '' + valor;
    }

    actualizar() {
      if (isNaN(this.objetivo)) return;

      const restante = this.objetivo - Date.now();

      if (restante <= 0) {
        this.finalizar();
        return;
      }

      const totalSegundos = Math.floor(restante / 1000);
      let dias = Math.floor(totalSegundos / 86400);
      let horas = Math.floor((totalSegundos % 86400) / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundos = totalSegundos % 60;

      if (!this.mostrarDias) {
        horas = horas + dias * 24;
        dias = 0;
      }

      if (this.diasEl) this.diasEl.textContent = this.rellenar(dias);
      if (this.horasEl) this.horasEl.textContent = this.rellenar(horas);
      if (this.minutosEl) this.minutosEl.textContent = this.rellenar(minutos);
      if (this.segundosEl) this.segundosEl.textContent = this.rellenar(segundos);
    }

    finalizar() {
      clearInterval(this.intervalo);

      if (this.diasEl) this.diasEl.textContent = '00';
      if (this.horasEl) this.horasEl.textContent = '00';
      if (this.minutosEl) this.minutosEl.textContent = '00';
      if (this.segundosEl) this.segundosEl.textContent = '00';

      if (this.alFinalizar === 'ocultar') {
        const seccion = this.closest('.bcatras-seccion');
        if (seccion) seccion.style.display = 'none';
      } else if (this.alFinalizar === 'mensaje') {
        if (this.cuentaEl) this.cuentaEl.setAttribute('hidden', '');
        if (this.contenidoEl) this.contenidoEl.setAttribute('hidden', '');
        if (this.mensajeEl) this.mensajeEl.removeAttribute('hidden');
      }
    }
  }

  if (!customElements.get('bcatras-contador')) {
    customElements.define('bcatras-contador', BcatrasContador);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cucaracha"] && !Shopify.designMode) return;
  try {
    
  class CarvalDeslizable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.thumb = this.querySelector('[data-thumb]');

      if (!this.pista || !this.thumb) return;

      this.onScroll = this.actualizar.bind(this);
      this.pista.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.onScroll);
        this.observador.observe(this.pista);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      this.actualizar();
    }

    disconnectedCallback() {
      if (this.pista) this.pista.removeEventListener('scroll', this.onScroll);
      if (this.observador) this.observador.disconnect();
      window.removeEventListener('resize', this.onScroll);
    }

    actualizar() {
      const desplazable = this.pista.scrollWidth - this.pista.clientWidth;
      const ratio = this.pista.scrollWidth > 0 ? this.pista.clientWidth / this.pista.scrollWidth : 1;
      const progreso = desplazable > 0 ? this.pista.scrollLeft / desplazable : 0;
      const anchoThumb = Math.max(Math.min(ratio * 100, 100), 12);

      this.thumb.style.setProperty('width', anchoThumb + '%', 'important');
      this.thumb.style.setProperty('left', progreso * (100 - anchoThumb) + '%', 'important');
    }
  }

  if (!customElements.get('carval-deslizable')) {
    customElements.define('carval-deslizable', CarvalDeslizable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["desplegable-contacto"] && !Shopify.designMode) return;
  try {
    
(function () {
  var iniciarDesplegables = function (contexto) {
    var cajas = (contexto || document).querySelectorAll('[data-desplegable-info]');

    cajas.forEach(function (caja) {
      if (caja.dataset.iniciado === 'true') return;
      caja.dataset.iniciado = 'true';

      var boton = caja.querySelector('[data-desplegable-info-boton]');
      var panel = caja.querySelector('[data-desplegable-info-panel]');
      if (!boton || !panel) return;

      var animando = false;

      var abrir = function () {
        panel.hidden = false;
        caja.dataset.abierto = 'true';
        boton.setAttribute('aria-expanded', 'true');
        panel.style.height = '0px';
        var alturaFinal = panel.scrollHeight;
        animando = true;
        requestAnimationFrame(function () {
          panel.style.height = alturaFinal + 'px';
        });
      };

      var cerrar = function () {
        caja.dataset.abierto = 'false';
        boton.setAttribute('aria-expanded', 'false');
        panel.style.height = panel.scrollHeight + 'px';
        animando = true;
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
      };

      panel.addEventListener('transitionend', function (evento) {
        if (evento.propertyName !== 'height') return;
        animando = false;
        if (caja.dataset.abierto === 'true') {
          panel.style.height = 'auto';
        } else {
          panel.hidden = true;
          panel.style.height = '';
        }
      });

      boton.addEventListener('click', function () {
        if (animando) return;
        if (caja.dataset.abierto === 'true') {
          cerrar();
        } else {
          abrir();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciarDesplegables(document);
    });
  } else {
    iniciarDesplegables(document);
  }

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarDesplegables(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galeria-instagram"] && !Shopify.designMode) return;
  try {
    
  class InstaCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.thumb = this.querySelector('[data-thumb]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      if (!this.pista) return;

      this.onScroll = this.actualizar.bind(this);
      this.pista.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.mover(-1));
      if (this.next) this.next.addEventListener('click', () => this.mover(1));

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.onScroll);
        this.observador.observe(this.pista);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      this.actualizar();
    }

    disconnectedCallback() {
      if (this.pista) this.pista.removeEventListener('scroll', this.onScroll);
      if (this.observador) this.observador.disconnect();
      window.removeEventListener('resize', this.onScroll);
    }

    paso() {
      const item = this.pista.querySelector('.insta-item');
      const gap = parseInt(getComputedStyle(this.pista).columnGap, 10) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.pista.clientWidth;
    }

    mover(dir) {
      this.pista.scrollBy({ left: dir * this.paso(), behavior: 'smooth' });
    }

    actualizar() {
      if (!this.thumb) return;

      const desplazable = this.pista.scrollWidth - this.pista.clientWidth;
      const ratio = this.pista.scrollWidth > 0 ? this.pista.clientWidth / this.pista.scrollWidth : 1;
      const progreso = desplazable > 0 ? this.pista.scrollLeft / desplazable : 0;
      const anchoThumb = Math.max(Math.min(ratio * 100, 100), 12);

      this.thumb.style.setProperty('width', anchoThumb + '%', 'important');
      this.thumb.style.setProperty('left', progreso * (100 - anchoThumb) + '%', 'important');
    }
  }

  if (!customElements.get('insta-carrusel')) {
    customElements.define('insta-carrusel', InstaCarrusel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeightHandler);
      window.addEventListener('load', this.setHeaderHeightHandler);
      window.addEventListener('resize', this.setHeaderHeightHandler);

      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.setHeaderHeightHandler);
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.buscador = this.querySelector('mia-buscador');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('load', this.setHeaderHeightHandler);
      window.removeEventListener('resize', this.setHeaderHeightHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.buscador && this.buscador.abierto) return;

      if (scrollTop <= 2) {
        this.header.classList.remove('scrolled-past-header');
        if (!this.headerIsAlwaysSticky) {
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        }
        this.setHeaderHeight();
        clearTimeout(this._miaAltoTop);
        this._miaAltoTop = setTimeout(this.setHeaderHeightHandler, 420);
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      const buscador = this.buscador || this.header.querySelector('mia-buscador');
      if (buscador && typeof buscador.cerrar === 'function') buscador.cerrar(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class MiaBuscador extends HTMLElement {
    connectedCallback() {
      if (this._conectado) return;
      this._conectado = true;

      this.raiz = document.documentElement;
      this.seccion = this.closest('.shopify-section') || document;
      this.envoltura = this.closest('.header-wrapper') || this.parentElement;
      this.marco = this.querySelector('[data-mia-bus-marco]');
      this.hoja = this.querySelector('[data-mia-bus-hoja]');
      this.velo = this.querySelector('[data-mia-bus-velo]');
      this.formulario = this.querySelector('[data-mia-bus-formulario]');
      this.input = this.querySelector('[data-mia-bus-input]');
      this.botonBorrar = this.querySelector('[data-mia-bus-borrar]');
      this.desplazable = this.querySelector('[data-mia-bus-desplazable]');
      this.inicio = this.querySelector('[data-mia-bus-inicio]');
      this.resultados = this.querySelector('[data-mia-bus-resultados]');
      this.vacio = this.querySelector('[data-mia-bus-vacio]');
      this.termino = this.querySelector('[data-mia-bus-termino]');
      this.sugerencias = this.querySelector('[data-mia-bus-sugerencias]');
      this.pestanas = this.querySelector('[data-mia-bus-pestanas]');
      this.numProductos = this.querySelector('[data-mia-bus-num-productos]');
      this.numColecciones = this.querySelector('[data-mia-bus-num-colecciones]');
      this.rejilla = this.querySelector('[data-mia-bus-rejilla]');
      this.rejillaColecciones = this.querySelector('[data-mia-bus-rejilla-colecciones]');
      this.verTodo = this.querySelector('[data-mia-bus-ver-todo]');
      this.verTodoTexto = this.querySelector('[data-mia-bus-ver-todo-texto]');
      this.populares = this.querySelector('[data-mia-bus-populares]');
      this.pista = this.querySelector('[data-mia-bus-destacados]');
      this.flechas = this.querySelector('[data-mia-bus-flechas]');
      this.menu = this.seccion.querySelector('header-drawer details');
      this.disparadores = Array.from(this.seccion.querySelectorAll('[data-mia-bus-abrir]'));

      if (!this.marco || !this.hoja || !this.input) return;

      this.abierto = false;
      this.cache = new Map();
      this.pestanaActiva = 'productos';
      this.textoVerTodo = this.verTodoTexto ? this.verTodoTexto.textContent.trim() : '';
      this.duracion = parseInt(this.dataset.duracion, 10) || 520;
      this.duracionCierre = Math.round(this.duracion * 0.62);
      this.consultaMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onDisparador = this.alternar.bind(this);
      this.onPrecalentar = this.precalentar.bind(this);
      this.onClick = this.gestionarClick.bind(this);
      this.onInput = this.alEscribir.bind(this);
      this.onSubmit = this.alEnviar.bind(this);
      this.onTecla = this.gestionarTecla.bind(this);
      this.onResize = this.programarMedida.bind(this);
      this.onPointerOver = this.alPasar.bind(this);
      this.onTouch = this.alTocar.bind(this);
      this.onFocusIn = this.alEnfocar.bind(this);
      this.onPista = this.programarFlechas.bind(this);
      this.onMenu = this.alCambiarMenu.bind(this);
      this.onIconosCabecera = this.alPulsarIconoCabecera.bind(this);

      this.disparadores.forEach((boton) => {
        boton.addEventListener('click', this.onDisparador);
        boton.addEventListener('pointerenter', this.onPrecalentar, { passive: true });
        boton.addEventListener('touchstart', this.onPrecalentar, { passive: true });
        boton.addEventListener('focus', this.onPrecalentar);
      });

      this.addEventListener('click', this.onClick);
      this.addEventListener('pointerover', this.onPointerOver, { passive: true });
      this.addEventListener('touchstart', this.onTouch, { passive: true });
      this.addEventListener('focusin', this.onFocusIn);
      this.input.addEventListener('input', this.onInput);
      if (this.formulario) this.formulario.addEventListener('submit', this.onSubmit);
      if (this.pista) this.pista.addEventListener('scroll', this.onPista, { passive: true });
      if (this.menu) this.menu.addEventListener('toggle', this.onMenu);
      this.seccion.addEventListener('click', this.onIconosCabecera);

      if (this.modoEditor() && window.__miaBusAbiertoEnEditor) {
        requestAnimationFrame(() => {
          this.classList.add('mia-bus--instantaneo');
          this.abrir();
          setTimeout(() => this.classList.remove('mia-bus--instantaneo'), 60);
        });
      }
    }

    modoEditor() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    disconnectedCallback() {
      if (!this._conectado) return;
      this._conectado = false;
      (this.disparadores || []).forEach((boton) => {
        boton.removeEventListener('click', this.onDisparador);
        boton.removeEventListener('pointerenter', this.onPrecalentar);
        boton.removeEventListener('touchstart', this.onPrecalentar);
        boton.removeEventListener('focus', this.onPrecalentar);
      });
      if (this.menu) this.menu.removeEventListener('toggle', this.onMenu);
      if (this.seccion) this.seccion.removeEventListener('click', this.onIconosCabecera);
      this.quitarEscuchasGlobales();
      clearTimeout(this.tCierre);
      clearTimeout(this.tBusqueda);
      if (this.ctrl) this.ctrl.abort();
      if (this.abierto || this.raiz.classList.contains('mia-buscador-abierto')) {
        this.raiz.classList.remove('mia-buscador-abierto', 'mia-buscador-pegado');
      }
      this.abierto = false;
    }

    reducido() {
      return this.consultaMovimiento && this.consultaMovimiento.matches;
    }

    alternar(evento) {
      if (evento) evento.preventDefault();
      if (this.abierto) {
        this.cerrar(true);
      } else {
        this.abrir();
      }
    }

    precalentar() {
      if (this._precalentado || !this.pista) return;
      this._precalentado = true;
      this.pista.querySelectorAll('.mia-bus-slide--activa img[loading="lazy"]').forEach((img, i) => {
        if (i < 8) img.loading = 'eager';
      });
    }

    abrir() {
      if (this.abierto) return;
      this.abierto = true;
      if (this.modoEditor()) window.__miaBusAbiertoEnEditor = true;
      clearTimeout(this.tCierre);
      this.cerrarMenu();
      this.medir();

      this.marco.hidden = false;
      this.velo.hidden = false;
      this.raiz.classList.add('mia-buscador-abierto');
      this.raiz.classList.toggle('mia-buscador-pegado', !!this.pegado);
      this.disparadores.forEach((boton) => boton.setAttribute('aria-expanded', 'true'));

      if (!this.input.value.trim()) {
        this.mostrarVista('inicio');
        this.mezclarPopulares();
        if (this.pista) this.pista.scrollLeft = 0;
        if (this.desplazable) this.desplazable.scrollTop = 0;
      }
      this.precalentar();

      this.classList.add('mia-bus--animando');
      void this.hoja.offsetHeight;
      this.classList.add('mia-bus--abierto');

      const sinTeclado = this.dataset.autofocoMovil === 'false' && window.matchMedia('(max-width: 749px)').matches;
      const destinoFoco = sinTeclado ? this.hoja : this.input;
      try {
        destinoFoco.focus({ preventScroll: true });
      } catch (e) {
        destinoFoco.focus();
      }

      document.addEventListener('keydown', this.onTecla);
      window.addEventListener('resize', this.onResize);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this.onResize);

      clearTimeout(this.tAnimacion);
      this.tAnimacion = setTimeout(() => this.classList.remove('mia-bus--animando'), this.reducido() ? 220 : this.duracion + 60);
      requestAnimationFrame(() => this.actualizarFlechas());
    }

    cerrar(devolverFoco) {
      if (!this.abierto) return;
      this.abierto = false;
      if (this.modoEditor()) window.__miaBusAbiertoEnEditor = false;
      this.quitarEscuchasGlobales();
      clearTimeout(this.tAnimacion);
      this.classList.add('mia-bus--animando');
      this.classList.remove('mia-bus--abierto');
      this.disparadores.forEach((boton) => boton.setAttribute('aria-expanded', 'false'));

      const activo = document.activeElement;
      if (activo && this.contains(activo) && typeof activo.blur === 'function') activo.blur();

      clearTimeout(this.tCierre);
      this.tCierre = setTimeout(() => {
        this.marco.hidden = true;
        this.velo.hidden = true;
        this.classList.remove('mia-bus--animando');
        this.raiz.classList.remove('mia-buscador-abierto', 'mia-buscador-pegado');
        this.querySelectorAll('.mia-bus-visual--tallas').forEach((m) => m.classList.remove('mia-bus-visual--tallas'));
        if (this.input.value) {
          this.input.value = '';
          this.alEscribir();
        }
      }, this.reducido() ? 220 : this.duracionCierre + 60);

      if (devolverFoco && this.disparadores[0]) {
        try {
          this.disparadores[0].focus({ preventScroll: true });
        } catch (e) {
          this.disparadores[0].focus();
        }
      }
    }

    quitarEscuchasGlobales() {
      document.removeEventListener('keydown', this.onTecla);
      window.removeEventListener('resize', this.onResize);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.onResize);
    }

    cerrarMenu() {
      if (!this.menu || !this.menu.open) return;
      const boton = this.menu.querySelector('.drawer-nuevo-cerrar');
      if (boton) {
        boton.click();
      } else {
        this.menu.open = false;
      }
    }

    alCambiarMenu() {
      if (this.menu && this.menu.open && this.abierto) this.cerrar(false);
    }

    alPulsarIconoCabecera(evento) {
      if (!this.abierto) return;
      if (evento.target.closest('.header__icon--cart, .header__icon--account, .header__heading-link')) this.cerrar(false);
    }

    programarMedida() {
      if (this._rafMedida) return;
      this._rafMedida = requestAnimationFrame(() => {
        this._rafMedida = null;
        if (!this.abierto) return;
        this.medir();
        this.raiz.classList.toggle('mia-buscador-pegado', !!this.pegado);
        this.actualizarFlechas();
      });
    }

    medir() {
      const envoltura = this.envoltura;
      if (!envoltura) return;
      const flotante = this.dataset.modo === 'flotante';
      const barra = flotante ? envoltura.querySelector('.header') || envoltura : envoltura;
      const re = envoltura.getBoundingClientRect();
      const rb = barra.getBoundingClientRect();
      const movil = window.matchMedia('(max-width: 749px)').matches;
      const estilo = window.getComputedStyle(barra);
      const radioBarra = this.raiz.classList.contains('mia-buscador-pegado')
        ? 0
        : Math.min(parseFloat(estilo.borderBottomLeftRadius) || 0, rb.height / 2);
      const margenMovil = parseFloat(this.dataset.margenMovil) || 0;
      const margen = movil ? margenMovil : Math.max(margenMovil, 24);
      const anchoMax = parseFloat(this.dataset.ancho) || 1180;
      let union = parseFloat(this.dataset.union) || 0;
      let ancho;

      this.pegado = false;
      if (flotante && movil) {
        ancho = rb.width;
        union = 0;
        this.pegado = true;
      } else {
        ancho = Math.max(Math.min(anchoMax, rb.width - radioBarra * 2 - margen * 2), 0);
        union = Math.max(0, Math.min(union, (rb.width - ancho) / 2 - radioBarra));
      }

      const izquierda = rb.left - re.left + (rb.width - ancho) / 2;
      const arriba = rb.bottom - re.top;
      const vista = window.visualViewport;
      const altoVista = vista ? vista.height + vista.offsetTop : window.innerHeight;
      const margenInferior = parseFloat(this.dataset.margenInferior) || 0;
      const libre = movil ? Math.min(margenInferior, 12) : margenInferior;
      const altoMax = Math.max(altoVista - rb.bottom - libre, 240);

      this.style.setProperty('--mia-bus-top', arriba + 'px');
      this.style.setProperty('--mia-bus-izq', izquierda + 'px');
      this.style.setProperty('--mia-bus-ancho', ancho + 'px');
      this.style.setProperty('--mia-bus-union', union + 'px');
      this.style.setProperty('--mia-bus-alto-max', altoMax + 'px');
      this.style.setProperty('--mia-bus-velo-top', Math.max(rb.bottom, 0) + 'px');
      this.classList.toggle('mia-bus--completo', ancho >= rb.width - 1);
    }

    mezclarPopulares() {
      if (!this.populares) return;
      const chips = Array.from(this.populares.children);
      if (!chips.length) return;
      const visibles = parseInt(this.dataset.numPopulares, 10) || chips.length;
      for (let i = chips.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temporal = chips[i];
        chips[i] = chips[j];
        chips[j] = temporal;
      }
      chips.forEach((chip, i) => {
        chip.hidden = i >= visibles;
        this.populares.appendChild(chip);
      });
    }

    mostrarVista(vista) {
      const enInicio = vista === 'inicio';
      const enVacio = vista === 'vacio';
      if (this.inicio) this.inicio.hidden = !(enInicio || enVacio);
      if (this.resultados) this.resultados.hidden = vista !== 'resultados';
      if (this.vacio) this.vacio.hidden = !enVacio;
      this.vista = vista;
      if (enInicio || enVacio) requestAnimationFrame(() => this.actualizarFlechas());
    }

    alEscribir() {
      const valor = this.input.value;
      const consulta = valor.trim();
      if (this.botonBorrar) this.botonBorrar.hidden = valor.length === 0;
      clearTimeout(this.tBusqueda);

      if (!consulta) {
        if (this.ctrl) this.ctrl.abort();
        this.consultaActual = '';
        this.cargando(false);
        this.mostrarVista('inicio');
        return;
      }

      const clave = consulta.toLowerCase();
      if (this.cache.has(clave)) {
        this.cargando(false);
        this.pintar(consulta, this.cache.get(clave));
        return;
      }

      this.cargando(true);
      this.tBusqueda = setTimeout(() => this.buscar(consulta), 180);
    }

    buscarAhora(consulta) {
      clearTimeout(this.tBusqueda);
      const clave = consulta.toLowerCase();
      if (this.cache.has(clave)) {
        this.cargando(false);
        this.pintar(consulta, this.cache.get(clave));
        return;
      }
      this.cargando(true);
      this.buscar(consulta);
    }

    async buscar(consulta) {
      if (this.ctrl) this.ctrl.abort();
      const ctrl = new AbortController();
      this.ctrl = ctrl;

      const parametros = new URLSearchParams();
      parametros.set('q', consulta);
      parametros.set('resources[type]', 'product,collection,query');
      parametros.set('resources[limit]', '10');
      parametros.set('resources[limit_scope]', 'each');
      parametros.set('resources[options][unavailable_products]', 'last');
      parametros.set('section_id', this.dataset.seccion);

      try {
        const respuesta = await fetch(this.dataset.urlSugerencias + '?' + parametros.toString(), {
          signal: ctrl.signal,
          credentials: 'same-origin'
        });
        if (!respuesta.ok) throw new Error(String(respuesta.status));
        const html = await respuesta.text();
        const datos = this.leerRespuesta(html);
        this.guardarCache(consulta.toLowerCase(), datos);
        if (this.input.value.trim().toLowerCase() === consulta.toLowerCase()) {
          this.cargando(false);
          this.pintar(consulta, datos);
        }
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        if (this.input.value.trim().toLowerCase() === consulta.toLowerCase()) {
          this.cargando(false);
          this.pintar(consulta, { productos: '', nProductos: 0, colecciones: '', nColecciones: 0, consultas: [], fuentes: [] });
        }
      }
    }

    guardarCache(clave, datos) {
      this.cache.set(clave, datos);
      if (this.cache.size > 40) this.cache.delete(this.cache.keys().next().value);
    }

    leerRespuesta(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nodo = doc.querySelector('[data-mia-bus-respuesta]');
      const vacio = { productos: '', nProductos: 0, colecciones: '', nColecciones: 0, consultas: [], fuentes: [] };
      if (!nodo) return vacio;
      const productos = nodo.querySelector('[data-mia-bus-respuesta-productos]');
      const colecciones = nodo.querySelector('[data-mia-bus-respuesta-colecciones]');
      const fuentes = [];
      const tarjetas = productos ? productos.querySelectorAll('[data-mia-bus-tarjeta]') : [];
      const cols = colecciones ? colecciones.querySelectorAll('[data-mia-bus-coleccion]') : [];
      tarjetas.forEach((t) => {
        if (t.dataset.titulo) fuentes.push(t.dataset.titulo);
        if (t.dataset.tipo) fuentes.push(t.dataset.tipo);
      });
      cols.forEach((c) => {
        if (c.dataset.titulo) fuentes.push(c.dataset.titulo);
      });
      return {
        productos: productos ? productos.innerHTML : '',
        nProductos: tarjetas.length,
        colecciones: colecciones ? colecciones.innerHTML : '',
        nColecciones: cols.length,
        consultas: Array.from(nodo.querySelectorAll('[data-mia-bus-consulta]')).map((n) => n.getAttribute('data-mia-bus-consulta')),
        fuentes
      };
    }

    cargando(activo) {
      this.classList.toggle('mia-bus--cargando', !!activo);
    }

    pintar(consulta, datos) {
      const cambio = consulta.toLowerCase() !== (this.consultaActual || '').toLowerCase();
      this.consultaActual = consulta;
      const sinNada = datos.nProductos === 0 && datos.nColecciones === 0;

      if (this.termino) this.termino.textContent = '“' + consulta + '”';

      if (sinNada) {
        this.mostrarVista('vacio');
        if (this.desplazable && cambio) this.desplazable.scrollTop = 0;
        return;
      }

      this.pintarSugerencias(consulta, datos);

      if (this.numProductos) this.numProductos.textContent = datos.nProductos ? '(' + datos.nProductos + ')' : '';
      if (this.numColecciones) this.numColecciones.textContent = datos.nColecciones ? '(' + datos.nColecciones + ')' : '';
      const pestanaProductos = this.querySelector('[data-mia-bus-pestana="productos"]');
      const pestanaColecciones = this.querySelector('[data-mia-bus-pestana="colecciones"]');
      if (pestanaProductos) pestanaProductos.hidden = datos.nProductos === 0;
      if (pestanaColecciones) pestanaColecciones.hidden = datos.nColecciones === 0;

      let pestana = this.pestanaActiva;
      if (cambio) pestana = 'productos';
      if (pestana === 'productos' && datos.nProductos === 0) pestana = 'colecciones';
      if (pestana === 'colecciones' && datos.nColecciones === 0) pestana = 'productos';

      this.rejilla.innerHTML = datos.productos;
      this.rejillaColecciones.innerHTML = datos.colecciones;
      this.activarPestana(pestana);

      if (this.verTodo) {
        const url = this.dataset.urlBusqueda + '?q=' + encodeURIComponent(consulta) + '&options%5Bprefix%5D=last';
        this.verTodo.setAttribute('href', url);
      }
      if (this.verTodoTexto) this.verTodoTexto.textContent = this.textoVerTodo + ' “' + consulta + '”';

      this.mostrarVista('resultados');
      if (this.desplazable && cambio) this.desplazable.scrollTop = 0;
    }

    activarPestana(nombre) {
      this.pestanaActiva = nombre;
      this.querySelectorAll('[data-mia-bus-pestana]').forEach((boton) => {
        boton.setAttribute('aria-selected', boton.getAttribute('data-mia-bus-pestana') === nombre ? 'true' : 'false');
      });
      this.rejilla.hidden = nombre !== 'productos';
      this.rejillaColecciones.hidden = nombre !== 'colecciones';
    }

    normalizar(texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
    }

    limpiarPalabra(palabra) {
      return palabra.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '');
    }

    generarSugerencias(consulta, fuentes, consultas) {
      const maximo = parseInt(this.dataset.numSugerencias, 10);
      if (!maximo) return [];
      const base = consulta.toLowerCase().replace(/\s+/g, ' ').trim();
      const tokens = this.normalizar(base).split(' ').filter(Boolean);
      if (!tokens.length) return [];
      const vacias = new Set(['de', 'del', 'la', 'el', 'los', 'las', 'con', 'y', 'e', 'o', 'u', 'en', 'a', 'al', 'para', 'por', 'sin', 'un', 'una', 'su', 'sus', 'tu']);
      const mapa = new Map();

      const sumar = (texto, puntos) => {
        const clave = this.normalizar(texto);
        const previo = mapa.get(clave);
        if (previo) {
          previo.puntos += puntos;
        } else {
          mapa.set(clave, { texto, puntos, palabras: texto.split(' ').length });
        }
      };

      (consultas || []).forEach((texto, i) => {
        const limpio = String(texto || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (limpio && this.normalizar(limpio).startsWith(this.normalizar(base))) sumar(limpio, 50 - i);
      });

      (fuentes || []).forEach((fuente) => {
        String(fuente || '')
          .split(/[|·•\/,()]+|\s[-–—]\s/)
          .forEach((segmento) => {
            const palabras = segmento
              .toLowerCase()
              .split(/\s+/)
              .map((p) => this.limpiarPalabra(p))
              .filter(Boolean);
            const normales = palabras.map((p) => this.normalizar(p));
            for (let i = 0; i < palabras.length; i++) {
              let encaja = true;
              for (let t = 0; t < tokens.length; t++) {
                const palabra = normales[i + t];
                if (palabra === undefined) {
                  encaja = false;
                  break;
                }
                const ultimo = t === tokens.length - 1;
                if (ultimo ? !palabra.startsWith(tokens[t]) : palabra !== tokens[t]) {
                  encaja = false;
                  break;
                }
              }
              if (!encaja) continue;
              const inicioSegmento = i === 0 ? 1 : 0;
              let extra = 0;
              for (let fin = i + tokens.length; fin <= palabras.length && extra < 3; fin++) {
                const ultima = normales[fin - 1];
                if (vacias.has(ultima) && fin - 1 >= i + tokens.length) continue;
                const frase = palabras.slice(i, fin).join(' ');
                sumar(frase, (extra === 0 ? 3 : 1) + inicioSegmento);
                extra++;
              }
            }
          });
      });

      return Array.from(mapa.values())
        .sort((a, b) => b.puntos - a.puntos || a.palabras - b.palabras || a.texto.length - b.texto.length)
        .slice(0, maximo)
        .map((s) => s.texto);
    }

    pintarSugerencias(consulta, datos) {
      if (!this.sugerencias) return;
      const lista = this.generarSugerencias(consulta, datos.fuentes, datos.consultas);
      this.sugerencias.textContent = '';
      const base = consulta.toLowerCase().replace(/\s+/g, ' ').trim();
      const baseNormal = this.normalizar(base);
      let activa = lista.findIndex((s) => this.normalizar(s) === baseNormal);
      if (activa < 0) activa = 0;
      lista.forEach((texto, i) => {
        const boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'mia-bus-sugerencia' + (i === activa ? ' mia-bus-sugerencia--activa' : '');
        boton.setAttribute('data-mia-bus-sugerencia', texto);
        const largo = this.normalizar(texto).startsWith(baseNormal) ? base.length : 0;
        const parteBase = document.createElement('span');
        parteBase.className = 'mia-bus-sugerencia-base';
        parteBase.textContent = texto.slice(0, largo);
        const parteResto = document.createElement('strong');
        parteResto.className = 'mia-bus-sugerencia-resto';
        parteResto.textContent = texto.slice(largo);
        boton.appendChild(parteBase);
        boton.appendChild(parteResto);
        this.sugerencias.appendChild(boton);
      });
      this.sugerencias.hidden = lista.length === 0;
      this.sugerencias.scrollLeft = 0;
    }

    alEnviar(evento) {
      if (!this.input.value.trim()) evento.preventDefault();
    }

    gestionarTecla(evento) {
      if (!this.abierto) return;
      if (evento.key === 'Escape' || evento.key === 'Esc') {
        evento.preventDefault();
        this.cerrar(true);
        return;
      }
      if (evento.key !== 'Tab') return;
      const enfocables = Array.from(
        this.hoja.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => !el.closest('[hidden]') && el.getClientRects().length > 0);
      if (!enfocables.length) return;
      const primero = enfocables[0];
      const ultimo = enfocables[enfocables.length - 1];
      const activo = document.activeElement;
      if (evento.shiftKey && (activo === primero || !this.hoja.contains(activo))) {
        evento.preventDefault();
        ultimo.focus();
      } else if (!evento.shiftKey && (activo === ultimo || !this.hoja.contains(activo))) {
        evento.preventDefault();
        primero.focus();
      }
    }

    gestionarClick(evento) {
      const objetivo = evento.target;
      if (!(objetivo instanceof Element)) return;

      if (objetivo.closest('[data-mia-bus-cerrar]')) {
        evento.preventDefault();
        this.cerrar(!objetivo.closest('[data-mia-bus-velo]'));
        return;
      }

      if (objetivo.closest('[data-mia-bus-borrar]')) {
        evento.preventDefault();
        this.input.value = '';
        this.alEscribir();
        this.input.focus();
        return;
      }

      const sugerencia = objetivo.closest('[data-mia-bus-sugerencia]');
      if (sugerencia) {
        evento.preventDefault();
        const texto = sugerencia.getAttribute('data-mia-bus-sugerencia');
        this.input.value = texto;
        if (this.botonBorrar) this.botonBorrar.hidden = false;
        this.buscarAhora(texto);
        return;
      }

      const pestana = objetivo.closest('[data-mia-bus-pestana]');
      if (pestana) {
        evento.preventDefault();
        this.activarPestana(pestana.getAttribute('data-mia-bus-pestana'));
        return;
      }

      const flechaPista = objetivo.closest('[data-mia-bus-pista]');
      if (flechaPista) {
        evento.preventDefault();
        this.moverPista(parseInt(flechaPista.getAttribute('data-mia-bus-pista'), 10) || 1);
        return;
      }

      const tarjeta = objetivo.closest('[data-mia-bus-tarjeta]');
      if (!tarjeta) return;

      const color = objetivo.closest('[data-mia-bus-color]');
      if (color) {
        evento.preventDefault();
        this.seleccionarColor(tarjeta, color);
        return;
      }

      const flecha = objetivo.closest('[data-mia-bus-flecha]');
      if (flecha) {
        evento.preventDefault();
        this.cambiarImagen(tarjeta, parseInt(flecha.getAttribute('data-mia-bus-flecha'), 10) || 1);
        return;
      }

      const talla = objetivo.closest('[data-mia-bus-talla]');
      if (talla) {
        evento.preventDefault();
        this.anadirTalla(tarjeta, talla);
      }
    }

    moverPista(direccion) {
      const pista = this.pista;
      if (!pista) return;
      const tarjeta = pista.querySelector('[data-mia-bus-tarjeta]');
      const hueco = parseFloat(window.getComputedStyle(pista).columnGap) || 0;
      const paso = tarjeta ? tarjeta.getBoundingClientRect().width + hueco : pista.clientWidth * 0.8;
      const visibles = Math.max(1, Math.floor((pista.clientWidth + hueco + 2) / paso));
      pista.scrollBy({ left: direccion * paso * visibles, behavior: this.reducido() ? 'auto' : 'smooth' });
    }

    programarFlechas() {
      if (this._rafFlechas) return;
      this._rafFlechas = requestAnimationFrame(() => {
        this._rafFlechas = null;
        this.actualizarFlechas();
      });
    }

    actualizarFlechas() {
      if (!this.pista || !this.flechas) return;
      const maximo = this.pista.scrollWidth - this.pista.clientWidth;
      const anterior = this.flechas.querySelector('[data-mia-bus-pista="-1"]');
      const siguiente = this.flechas.querySelector('[data-mia-bus-pista="1"]');
      this.flechas.classList.toggle('mia-bus-flechas-pista--ocultas', maximo <= 2);
      if (anterior) anterior.disabled = this.pista.scrollLeft <= 2;
      if (siguiente) siguiente.disabled = this.pista.scrollLeft >= maximo - 2;
    }

    datosTarjeta(tarjeta) {
      if (!tarjeta._miaBus) {
        let variantes = [];
        const script = tarjeta.querySelector('[data-mia-bus-variantes]');
        if (script) {
          try {
            variantes = JSON.parse(script.textContent);
          } catch (e) {
            variantes = [];
          }
        }
        const activo = tarjeta.querySelector('.mia-bus-color--activo');
        tarjeta._miaBus = {
          variantes,
          pc: (parseInt(tarjeta.dataset.posColor, 10) || 0) - 1,
          pt: (parseInt(tarjeta.dataset.posTalla, 10) || 0) - 1,
          color: activo ? activo.getAttribute('data-mia-bus-color') : null,
          preparada: false
        };
      }
      return tarjeta._miaBus;
    }

    prepararTarjeta(tarjeta) {
      const datos = this.datosTarjeta(tarjeta);
      if (datos.preparada) return datos;
      datos.preparada = true;
      this.cargarGaleria(tarjeta);
      this.actualizarTallas(tarjeta);
      return datos;
    }

    cargarGaleria(tarjeta) {
      tarjeta.querySelectorAll('img[data-mia-bus-src]').forEach((img) => {
        const srcset = img.getAttribute('data-mia-bus-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-mia-bus-src'));
        img.removeAttribute('data-mia-bus-src');
        img.removeAttribute('data-mia-bus-srcset');
      });
    }

    alPasar(evento) {
      if (evento.pointerType === 'touch') return;
      const tarjeta = evento.target instanceof Element ? evento.target.closest('[data-mia-bus-tarjeta]') : null;
      if (tarjeta) this.prepararTarjeta(tarjeta);
    }

    alTocar(evento) {
      const objetivo = evento.target instanceof Element ? evento.target : null;
      const tarjeta = objetivo ? objetivo.closest('[data-mia-bus-tarjeta]') : null;
      if (!tarjeta) return;
      this.prepararTarjeta(tarjeta);
      const visual = objetivo.closest('.mia-bus-visual');
      if (visual) this.mostrarTallas(visual);
    }

    alEnfocar(evento) {
      const tarjeta = evento.target instanceof Element ? evento.target.closest('[data-mia-bus-tarjeta]') : null;
      if (tarjeta) this.prepararTarjeta(tarjeta);
    }

    mostrarTallas(visual) {
      this.querySelectorAll('.mia-bus-visual--tallas').forEach((otra) => {
        if (otra !== visual) otra.classList.remove('mia-bus-visual--tallas');
      });
      visual.classList.add('mia-bus-visual--tallas');
    }

    activarImagen(tarjeta, posicion) {
      const slides = tarjeta.querySelectorAll('.mia-bus-slide');
      let objetivo = null;
      slides.forEach((slide) => {
        if (slide.getAttribute('data-pos') === String(posicion)) objetivo = slide;
      });
      if (!objetivo) return;
      slides.forEach((slide) => slide.classList.toggle('mia-bus-slide--activa', slide === objetivo));
    }

    cambiarImagen(tarjeta, direccion) {
      this.prepararTarjeta(tarjeta);
      const visual = tarjeta.querySelector('.mia-bus-visual');
      if (visual && window.matchMedia('(hover: none)').matches) this.mostrarTallas(visual);
      const slides = Array.from(tarjeta.querySelectorAll('.mia-bus-slide'));
      if (slides.length < 2) return;
      let actual = slides.findIndex((slide) => slide.classList.contains('mia-bus-slide--activa'));
      if (actual < 0) actual = 0;
      const siguiente = (actual + direccion + slides.length) % slides.length;
      slides[actual].classList.remove('mia-bus-slide--activa');
      slides[siguiente].classList.add('mia-bus-slide--activa');
    }

    seleccionarColor(tarjeta, boton) {
      const datos = this.prepararTarjeta(tarjeta);
      const valor = boton.getAttribute('data-mia-bus-color');
      datos.color = valor;
      tarjeta.querySelectorAll('[data-mia-bus-color]').forEach((b) => {
        const activo = b === boton;
        b.classList.toggle('mia-bus-color--activo', activo);
        b.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      const delColor = datos.pc >= 0 ? datos.variantes.filter((v) => v.o[datos.pc] === valor) : datos.variantes;
      const variante = delColor.find((v) => v.d) || delColor[0];
      const posicion = (variante && variante.i) || boton.getAttribute('data-pos');
      if (posicion) this.activarImagen(tarjeta, posicion);
      if (variante) this.aplicarVariante(tarjeta, variante);
      this.actualizarTallas(tarjeta);
    }

    textoAhorro(variante) {
      const texto = this.dataset.ahorroTexto ? this.dataset.ahorroTexto + ' ' : '';
      return texto + (this.dataset.ahorroTipo === 'porcentaje' ? variante.ap + '%' : variante.a);
    }

    aplicarVariante(tarjeta, variante) {
      const oferta = !!variante.c;
      tarjeta.querySelectorAll('[data-mia-bus-enlace]').forEach((enlace) => enlace.setAttribute('href', variante.u));
      const precio = tarjeta.querySelector('[data-mia-bus-precio]');
      if (precio) precio.textContent = variante.p;
      const tachado = tarjeta.querySelector('[data-mia-bus-tachado]');
      if (tachado) {
        tachado.textContent = oferta ? variante.c : '';
        tachado.hidden = !oferta;
      }
      const ahorro = tarjeta.querySelector('[data-mia-bus-ahorro]');
      if (ahorro) {
        ahorro.textContent = oferta ? this.textoAhorro(variante) : ' ';
        ahorro.classList.toggle('mia-bus-ahorro--vacio', !oferta);
      }
      const badge = tarjeta.querySelector('[data-mia-bus-badge]');
      if (badge && tarjeta.hasAttribute('data-badge-solo-oferta')) badge.hidden = !oferta;
    }

    actualizarTallas(tarjeta) {
      const datos = this.datosTarjeta(tarjeta);
      if (datos.pt < 0) return;
      tarjeta.querySelectorAll('[data-mia-bus-talla]').forEach((boton) => {
        const talla = boton.getAttribute('data-mia-bus-talla');
        const variante = datos.variantes.find(
          (v) => v.d && v.o[datos.pt] === talla && (datos.pc < 0 || datos.color === null || v.o[datos.pc] === datos.color)
        );
        boton.disabled = !variante;
        boton.classList.toggle('mia-bus-talla--agotada', !variante);
        boton.setAttribute('data-variante', variante ? String(variante.id) : '');
      });
    }

    async anadirTalla(tarjeta, boton) {
      this.prepararTarjeta(tarjeta);
      const variante = boton.getAttribute('data-variante');
      if (!variante || boton.disabled || boton.getAttribute('aria-busy') === 'true') return;
      boton.setAttribute('aria-busy', 'true');
      this.volarAlCarrito(boton);

      try {
        const respuesta = await fetch((this.dataset.urlCarrito || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variante), quantity: 1 }],
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const datos = await respuesta.json();
        if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || 'error');
        this.actualizarBurbuja(datos);
        this.notificarCarrito(datos);
        this.marcarTalla(boton, 'mia-bus-talla--anadida');
      } catch (error) {
        this.marcarTalla(boton, 'mia-bus-talla--error');
      } finally {
        boton.removeAttribute('aria-busy');
      }
    }

    marcarTalla(boton, clase) {
      boton.classList.add(clase);
      clearTimeout(boton._miaTemporizador);
      boton._miaTemporizador = setTimeout(() => boton.classList.remove(clase), 1100);
    }

    actualizarBurbuja(datos) {
      if (!datos || !datos.sections || !datos.sections['cart-icon-bubble']) return;
      const destino = document.getElementById('cart-icon-bubble');
      if (!destino) return;
      const doc = new DOMParser().parseFromString(datos.sections['cart-icon-bubble'], 'text/html');
      const seccion = doc.querySelector('.shopify-section');
      destino.innerHTML = seccion ? seccion.innerHTML : doc.body.innerHTML;
    }

    notificarCarrito(datos) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mia-buscador', cartData: datos });
        }
      } catch (e) {
        return;
      }
    }

    volarAlCarrito(origen) {
      if (this.reducido()) return;
      const carrito = document.getElementById('cart-icon-bubble');
      if (!carrito || !origen) return;
      const o = origen.getBoundingClientRect();
      const c = carrito.getBoundingClientRect();
      if (!o.width || !c.width) return;
      const x0 = o.left + o.width / 2;
      const y0 = o.top + o.height / 2;
      const dx = c.left + c.width / 2 - x0;
      const dy = c.top + c.height / 2 - y0;
      const angulo = (Math.atan2(dy, dx) * 180) / Math.PI;
      const estrella = document.createElement('div');
      estrella.className = 'mia-bus-estrella';
      estrella.style.left = x0 + 'px';
      estrella.style.top = y0 + 'px';
      estrella.style.transform = 'translate(0px, 0px) rotate(' + angulo + 'deg)';
      estrella.innerHTML = '<span class="mia-bus-estrella-cola"></span><span class="mia-bus-estrella-nucleo"></span>';
      document.body.appendChild(estrella);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          estrella.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + angulo + 'deg) scale(0.3)';
          estrella.style.opacity = '0.15';
        });
      });
      setTimeout(() => {
        estrella.remove();
        carrito.classList.add('mia-bus-golpe');
        setTimeout(() => carrito.classList.remove('mia-bus-golpe'), 380);
      }, 440);
    }
  }

  if (!customElements.get('mia-buscador')) {
    customElements.define('mia-buscador', MiaBuscador);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["informacion-tienda"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function revelar(el) {
      el.classList.add('info-tienda--visible');
    }

    function iniciar(raiz) {
      var contenedor = raiz && raiz.querySelectorAll ? raiz : document;
      var elementos = contenedor.querySelectorAll('.info-tienda[data-anim="true"]:not([data-anim-listo])');

      elementos.forEach(function (el) {
        el.setAttribute('data-anim-listo', '');

        if (!('IntersectionObserver' in window)) {
          revelar(el);
          return;
        }

        var observador = new IntersectionObserver(
          function (entradas, obs) {
            entradas.forEach(function (entrada) {
              if (entrada.isIntersecting) {
                revelar(entrada.target);
                obs.unobserve(entrada.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
        );

        observador.observe(el);
      });
    }

    if (document.readyState !== 'loading') {
      iniciar(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        iniciar(document);
      });
    }

    document.addEventListener('shopify:section:load', function (e) {
      iniciar(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class PcolgridLista extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.onClick = this.gestionarClick.bind(this);
      this.addEventListener('click', this.onClick);

      this.onTouch = (evento) => {
        const media = evento.target && evento.target.closest ? evento.target.closest('.pcolgrid-media') : null;
        if (media && this.contains(media)) this.mostrarTallas(media);
      };
      this.addEventListener('touchstart', this.onTouch, { passive: true });
      this.addEventListener('pointerdown', this.onTouch, { passive: true });

      this.onResize = () => this.medirTallas();
      window.addEventListener('resize', this.onResize);

      this.tallasPaneles = Array.from(this.querySelectorAll('.pcolgrid-tallas'));
      this.tallasPaneles.forEach((panel) => {
        const lista = panel.querySelector('[data-tallas-lista]');
        const barra = panel.querySelector('[data-tallas-scroll-barra]');
        if (!lista || !barra) return;
        panel._lista = lista;
        panel._barra = barra;
        panel._onScroll = () => this.actualizarIndicadorTallas(panel);
        lista.addEventListener('scroll', panel._onScroll, { passive: true });
      });

      this.medirTallas();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.onTouch) {
        this.removeEventListener('touchstart', this.onTouch);
        this.removeEventListener('pointerdown', this.onTouch);
      }
      window.removeEventListener('resize', this.onResize);
      if (this.tallasPaneles) {
        this.tallasPaneles.forEach((panel) => {
          if (panel._lista && panel._onScroll) panel._lista.removeEventListener('scroll', panel._onScroll);
        });
      }
    }

    medirTallas() {
      if (!this.tallasPaneles) return;
      this.tallasPaneles.forEach((panel) => this.actualizarIndicadorTallas(panel));
    }

    actualizarIndicadorTallas(panel) {
      const lista = panel._lista;
      const barra = panel._barra;
      if (!lista || !barra) return;
      const visible = lista.clientWidth || 1;
      const total = lista.scrollWidth || 1;
      if (total - visible > 2) {
        panel.classList.add('pcolgrid-tallas--scroll');
        const prop = Math.min(visible / total, 1);
        const avance = Math.min(Math.max(lista.scrollLeft / total, 0), 1 - prop);
        barra.style.setProperty('width', prop * 100 + '%', 'important');
        barra.style.setProperty('left', avance * 100 + '%', 'important');
      } else {
        panel.classList.remove('pcolgrid-tallas--scroll');
      }
    }

    gestionarClick(evento) {
      const talla = evento.target.closest('[data-talla]');
      if (talla && this.contains(talla)) {
        evento.preventDefault();
        this.anadirTalla(talla);
        return;
      }

      const flechaImg = evento.target.closest('[data-img-prev], [data-img-next]');
      if (flechaImg && this.contains(flechaImg)) {
        evento.preventDefault();
        const dir = flechaImg.hasAttribute('data-img-next') ? 1 : -1;
        this.cambiarImagen(flechaImg, dir);
        return;
      }

      const color = evento.target.closest('[data-color]');
      if (color && this.contains(color)) {
        evento.preventDefault();
        const grupo = color.closest('.pcolgrid-colores');
        if (grupo) grupo.querySelectorAll('.pcolgrid-color').forEach((c) => c.classList.remove('pcolgrid-color--activo'));
        color.classList.add('pcolgrid-color--activo');
        const tarjeta = color.closest('.pcolgrid-tarjeta');
        const media = tarjeta ? tarjeta.querySelector('.pcolgrid-media') : null;
        const pos = color.getAttribute('data-img-pos');
        if (media && pos) this.activarImagenPorPos(media, pos);
        return;
      }
    }

    activarImagenPorPos(media, pos) {
      const galeria = media.querySelector('[data-galeria]');
      if (!galeria) return;
      const slides = galeria.querySelectorAll('.pcolgrid-galeria-slide');
      let objetivo = null;
      slides.forEach((slide) => {
        if (slide.getAttribute('data-img-pos') === String(pos)) objetivo = slide;
      });
      if (!objetivo) return;
      slides.forEach((slide) => slide.classList.remove('pcolgrid-galeria-slide--activa'));
      objetivo.classList.add('pcolgrid-galeria-slide--activa');
    }

    mostrarTallas(media) {
      if (!media) return;
      this.querySelectorAll('.pcolgrid-media--tallas').forEach((otro) => {
        if (otro !== media) otro.classList.remove('pcolgrid-media--tallas');
      });
      media.classList.add('pcolgrid-media--tallas');
    }

    cambiarImagen(flecha, dir) {
      const media = flecha.closest('.pcolgrid-media');
      if (!media) return;
      this.mostrarTallas(media);
      const galeria = media.querySelector('[data-galeria]');
      if (!galeria) return;
      const slides = galeria.querySelectorAll('.pcolgrid-galeria-slide');
      if (slides.length < 2) return;

      let actual = 0;
      slides.forEach((slide, i) => {
        if (slide.classList.contains('pcolgrid-galeria-slide--activa')) actual = i;
      });

      const siguiente = (actual + dir + slides.length) % slides.length;
      slides[actual].classList.remove('pcolgrid-galeria-slide--activa');
      slides[siguiente].classList.add('pcolgrid-galeria-slide--activa');
    }

    raiz() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    extraerSeccion(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const seccion = doc.querySelector('.shopify-section');
      return seccion ? seccion.innerHTML : html;
    }

    actualizarBurbuja(datos) {
      if (!datos || !datos.sections) return;
      const html = datos.sections['cart-icon-bubble'];
      if (!html) return;
      const destino = document.getElementById('cart-icon-bubble');
      if (destino) destino.innerHTML = this.extraerSeccion(html);
    }

    notificar(datos) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pcolgrid-lista', cartData: datos });
        }
      } catch (e) {
        void e;
      }
    }

    async anadirTalla(boton) {
      const variante = boton.dataset.variante;
      if (!variante || boton.getAttribute('aria-busy') === 'true') return;

      boton.setAttribute('aria-busy', 'true');
      this.volarAlCarrito(boton);

      try {
        const respuesta = await fetch(this.raiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variante), quantity: 1 }],
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });

        const datos = await respuesta.json();
        if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || 'error');

        this.actualizarBurbuja(datos);
        this.notificar(datos);

        boton.classList.add('pcolgrid-talla--anadida');
        clearTimeout(boton.temporizador);
        boton.temporizador = setTimeout(() => boton.classList.remove('pcolgrid-talla--anadida'), 1100);
      } catch (e) {
        boton.classList.add('pcolgrid-talla--error');
        clearTimeout(boton.temporizador);
        boton.temporizador = setTimeout(() => boton.classList.remove('pcolgrid-talla--error'), 1100);
      } finally {
        boton.removeAttribute('aria-busy');
      }
    }

    volarAlCarrito(origen) {
      if (this.dataset.animacion === 'false') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const carrito = document.getElementById('cart-icon-bubble');
      if (!carrito || !origen) return;

      const o = origen.getBoundingClientRect();
      const c = carrito.getBoundingClientRect();
      if (!o.width || !c.width) return;

      const x0 = o.left + o.width / 2;
      const y0 = o.top + o.height / 2;
      const x1 = c.left + c.width / 2;
      const y1 = c.top + c.height / 2;
      const dx = x1 - x0;
      const dy = y1 - y0;
      const ang = Math.atan2(dy, dx) * 180 / Math.PI;
      const color = this.dataset.estrellaColor || '#FFFFFF';

      const estrella = document.createElement('div');
      estrella.className = 'pcolgrid-estrella';
      estrella.style.left = x0 + 'px';
      estrella.style.top = y0 + 'px';
      estrella.style.transform = 'translate(0px, 0px) rotate(' + ang + 'deg)';
      estrella.innerHTML =
        '<span class="pcolgrid-estrella-cola"></span><span class="pcolgrid-estrella-nucleo"></span>';
      document.body.appendChild(estrella);

      const nucleo = estrella.querySelector('.pcolgrid-estrella-nucleo');
      const cola = estrella.querySelector('.pcolgrid-estrella-cola');
      if (nucleo) {
        nucleo.style.background = 'radial-gradient(circle, #ffffff 0%, ' + color + ' 55%, ' + color + ' 100%)';
        nucleo.style.boxShadow = '0 0 8px 2px ' + color + ', 0 0 18px 6px ' + color + ', 0 0 3px 1px rgba(0, 0, 0, 0.28)';
      }
      if (cola) {
        cola.style.background = 'linear-gradient(to left, ' + color + ', transparent)';
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          estrella.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + ang + 'deg) scale(0.3)';
          estrella.style.opacity = '0.15';
        });
      });

      window.setTimeout(() => {
        estrella.remove();
        carrito.classList.add('pcolgrid-golpe');
        window.setTimeout(() => carrito.classList.remove('pcolgrid-golpe'), 350);
      }, 430);
    }
  }

  if (!customElements.get('pcolgrid-lista')) {
    customElements.define('pcolgrid-lista', PcolgridLista);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var info = null;
    var zoomPct = 200;
    var zoomAncho = 2000;
    var zoomItem = null;
    var zoomEventosListos = false;
    var raf = window.requestAnimationFrame || function (cb) { return window.setTimeout(cb, 16); };

    function setImp(el, prop, val) { el.style.setProperty(prop, val, 'important'); }

    function getColorMap(root) {
      var script = root.querySelector('script[id^="mia-color-map-"]');
      if (!script) return null;
      try { return JSON.parse(script.textContent); } catch (e) { return null; }
    }

    function applyColorImages(root) {
      var map = getColorMap(root);
      if (!map || !map.length) return;
      var inputs = root.querySelectorAll('.product-form__input--swatch .swatch-input__input');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var entry = null;
        for (var j = 0; j < map.length; j++) {
          if (map[j].valor === input.value) { entry = map[j]; break; }
        }
        if (!entry) continue;
        var label = input.nextElementSibling;
        if (!label) continue;
        var sw = label.querySelector('.swatch');
        if (!sw) continue;
        sw.style.backgroundImage = 'url("' + entry.img + '")';
        sw.style.backgroundSize = 'cover';
        sw.style.backgroundPosition = 'center';
      }
    }

    function normaliza(s) { return (s == null ? '' : String(s)).toLowerCase().trim(); }

    function esEscritorio() {
      return window.matchMedia ? window.matchMedia('(min-width: 990px)').matches : window.innerWidth >= 990;
    }

    function hiRes(url, ancho) {
      var w = ancho || 1600;
      if (!url) return url;
      if (url.indexOf('data:') === 0) return url;
      if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    var galeria, principal, puntos, carrusel, oculto;
    var lightbox, lightboxImg, lightboxArea, lightboxContador;
    var itemsOriginales = [];
    var visiblesActuales = [];
    var mainId = null;
    var scrollRaf = null;
    var touchX = null;
    var touchY = null;
    var touchMoved = false;

    var lastX = -1, lastY = -1, tienePunto = false;
    var zoomRaf = null;

    function colorSeleccionado(root) {
      var map = getColorMap(root);
      if (!map || !map.length) return '';
      var i, j;
      var radios = root.querySelectorAll('input[type="radio"]');
      for (i = 0; i < radios.length; i++) {
        if (!radios[i].checked) continue;
        for (j = 0; j < map.length; j++) { if (map[j].valor === radios[i].value) return radios[i].value; }
      }
      var selects = root.querySelectorAll('select');
      for (i = 0; i < selects.length; i++) {
        for (j = 0; j < map.length; j++) { if (map[j].valor === selects[i].value) return selects[i].value; }
      }
      return '';
    }

    function itemsActivos(root) {
      var color = normaliza(colorSeleccionado(root));
      if (!color) return itemsOriginales.slice();
      var res = [];
      for (var i = 0; i < itemsOriginales.length; i++) {
        var dc = normaliza(itemsOriginales[i].getAttribute('data-color'));
        if (!dc || dc.indexOf(color) > -1) res.push(itemsOriginales[i]);
      }
      return res.length ? res : itemsOriginales.slice();
    }

    var lbScale = 1, lbTx = 0, lbTy = 0;
    var lbLista = [];
    var lbIndice = 0;
    var lbAnimTimer = null;

    function lbCaja() {
      if (lightboxArea) {
        var r = lightboxArea.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return r;
      }
      return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
    }

    function lbClamp() {
      if (!lightboxImg) return;
      var caja = lbCaja();
      var vw = caja.width, vh = caja.height;
      var bw = lightboxImg.offsetWidth * lbScale;
      var bh = lightboxImg.offsetHeight * lbScale;
      var mx = Math.max(0, (bw - vw) / 2);
      var my = Math.max(0, (bh - vh) / 2);
      if (lbTx > mx) lbTx = mx; else if (lbTx < -mx) lbTx = -mx;
      if (lbTy > my) lbTy = my; else if (lbTy < -my) lbTy = -my;
    }

    function lbApply() {
      if (!lightboxImg) return;
      lbClamp();
      lightboxImg.style.transform = 'translate(' + lbTx.toFixed(1) + 'px,' + lbTy.toFixed(1) + 'px) scale(' + lbScale.toFixed(3) + ')';
    }

    function lbReset() {
      lbScale = 1; lbTx = 0; lbTy = 0;
      if (lightboxImg) lightboxImg.style.transform = 'translate(0px,0px) scale(1)';
    }

    function lbAnim(on) {
      if (!lightboxImg) return;
      if (lbAnimTimer) { clearTimeout(lbAnimTimer); lbAnimTimer = null; }
      if (on) {
        lightboxImg.classList.add('is-anim');
        lbAnimTimer = setTimeout(function () {
          lbAnimTimer = null;
          lightboxImg.classList.remove('is-anim');
        }, 260);
      } else {
        lightboxImg.classList.remove('is-anim');
      }
    }

    function lbMostrar(i) {
      if (!lightboxImg || !lbLista.length) return;
      if (i < 0) i = 0;
      if (i > lbLista.length - 1) i = lbLista.length - 1;
      lbIndice = i;
      lbAnim(false);
      lbReset();
      var dato = lbLista[i];
      lightboxImg.removeAttribute('src');
      lightboxImg.alt = dato.alt || '';
      lightboxImg.src = dato.src;
      if (lbLista.length > 1) {
        lightboxContador.textContent = (i + 1) + ' / ' + lbLista.length;
        lightboxContador.hidden = false;
      } else {
        lightboxContador.hidden = true;
      }
    }

    function cerrarLightbox() {
      if (!lightbox || !lightbox.classList.contains('is-abierto')) return;
      lightbox.classList.remove('is-abierto');
      lbAnim(false);
      lbReset();
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      var dato = lbLista[lbIndice];
      if (dato && dato.id && dato.id !== mainId) {
        mainId = dato.id;
        marcarActivo(mainId);
        irASlide(mainId, false);
      }
    }

    function crearLightbox() {
      if (lightbox && document.contains(lightbox)) return;
      lightbox = document.createElement('div');
      lightbox.className = 'mia-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      var cerrar = document.createElement('button');
      cerrar.type = 'button';
      cerrar.className = 'mia-lightbox__cerrar';
      cerrar.setAttribute('aria-label', 'Cerrar');
      cerrar.innerHTML = '&times;';
      lightboxContador = document.createElement('div');
      lightboxContador.className = 'mia-lightbox__contador';
      lightboxContador.hidden = true;
      lightboxArea = document.createElement('div');
      lightboxArea.className = 'mia-lightbox__area';
      lightboxImg = document.createElement('img');
      lightboxImg.className = 'mia-lightbox__img';
      lightboxImg.alt = '';
      lightboxImg.draggable = false;
      lightboxArea.appendChild(lightboxImg);
      lightbox.appendChild(cerrar);
      lightbox.appendChild(lightboxContador);
      lightbox.appendChild(lightboxArea);
      document.body.appendChild(lightbox);

      cerrar.addEventListener('click', function (e) { e.stopPropagation(); cerrarLightbox(); });

      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-abierto')) return;
        if (e.key === 'Escape') cerrarLightbox();
        else if (e.key === 'ArrowRight') lbMostrar(lbIndice + 1);
        else if (e.key === 'ArrowLeft') lbMostrar(lbIndice - 1);
      });

      lightboxArea.addEventListener('click', function (e) {
        if (e.target === lightboxArea) cerrarLightbox();
      });

      lightboxImg.addEventListener('load', function () {
        if (lbScale > 1) lbApply();
      });

      window.addEventListener('resize', function () {
        if (lightbox.classList.contains('is-abierto')) lbApply();
      });

      var bloquearGesto = function (e) {
        if (lightbox.classList.contains('is-abierto') && e.cancelable) e.preventDefault();
      };
      document.addEventListener('gesturestart', bloquearGesto, { passive: false });
      document.addEventListener('gesturechange', bloquearGesto, { passive: false });
      document.addEventListener('gestureend', bloquearGesto, { passive: false });

      var centro = function () {
        var caja = lbCaja();
        return { x: caja.left + caja.width / 2, y: caja.top + caja.height / 2 };
      };
      var distancia = function (a, b) {
        var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      };

      var modo = null;
      var iniX = 0, iniY = 0, finX = 0, finY = 0, movido = false, iniTx = 0, iniTy = 0;
      var prevDist = 0, prevMx = 0, prevMy = 0;
      var ultimoTap = 0, ultimoTapX = 0, ultimoTapY = 0;
      var sobreImg = false;
      var deslizando = false;
      var bloqueoSwipe = false;
      var frame = null;

      function pintar() {
        if (frame) return;
        frame = raf(function () {
          frame = null;
          lbApply();
        });
      }

      function empezarPan(t) {
        modo = 'pan';
        iniX = finX = t.clientX;
        iniY = finY = t.clientY;
        iniTx = lbTx;
        iniTy = lbTy;
      }

      function empezarPinch(a, b) {
        if (deslizando) { deslizando = false; lbReset(); }
        modo = 'pinch';
        movido = true;
        prevDist = distancia(a, b);
        prevMx = (a.clientX + b.clientX) / 2;
        prevMy = (a.clientY + b.clientY) / 2;
      }

      function dobleTap(px, py) {
        var o = centro();
        var destino = lbScale > 1.2 ? 1 : 2.5;
        var lx = (px - o.x - lbTx) / lbScale;
        var ly = (py - o.y - lbTy) / lbScale;
        lbAnim(true);
        lbScale = destino;
        if (destino === 1) {
          lbTx = 0; lbTy = 0;
        } else {
          lbTx = (px - o.x) - destino * lx;
          lbTy = (py - o.y) - destino * ly;
        }
        lbApply();
      }

      lightboxArea.addEventListener('touchstart', function (e) {
        lbAnim(false);
        lightboxImg.classList.add('is-gesto');
        if (e.touches.length === 1) {
          empezarPan(e.touches[0]);
          movido = false;
          deslizando = false;
          bloqueoSwipe = false;
          sobreImg = (e.target === lightboxImg);
        } else if (e.touches.length >= 2) {
          empezarPinch(e.touches[0], e.touches[1]);
        }
        if (e.cancelable) e.preventDefault();
      }, { passive: false });

      lightboxArea.addEventListener('touchmove', function (e) {
        if (modo === 'pinch' && e.touches.length >= 2) {
          var d = distancia(e.touches[0], e.touches[1]);
          var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
          var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
          if (prevDist > 0 && d > 0) {
            var s = lbScale * (d / prevDist);
            if (s < 1) s = 1; else if (s > 5) s = 5;
            var k = s / lbScale;
            var o = centro();
            lbTx = (mx - o.x) - k * (prevMx - o.x - lbTx);
            lbTy = (my - o.y) - k * (prevMy - o.y - lbTy);
            lbScale = s;
            lbClamp();
            pintar();
          }
          prevDist = d;
          prevMx = mx;
          prevMy = my;
        } else if (modo === 'pan' && e.touches.length === 1) {
          var px = e.touches[0].clientX;
          var py = e.touches[0].clientY;
          var pasoX = px - finX;
          var pasoY = py - finY;
          finX = px;
          finY = py;
          var dx = finX - iniX;
          var dy = finY - iniY;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) movido = true;
          if (lbScale > 1.01) {
            lbTx += pasoX;
            lbTy += pasoY;
            lbClamp();
            pintar();
          } else if (!bloqueoSwipe && lbLista.length > 1 && (deslizando || (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)))) {
            deslizando = true;
            var tope = (dx > 0 && lbIndice === 0) || (dx < 0 && lbIndice === lbLista.length - 1);
            var desp = tope ? dx * 0.3 : dx;
            lightboxImg.style.transform = 'translate(' + desp.toFixed(1) + 'px,0px) scale(1)';
          }
        }
        if (e.cancelable) e.preventDefault();
      }, { passive: false });

      function finToque(e) {
        if (e.touches.length === 1) {
          if (modo === 'pinch') {
            empezarPan(e.touches[0]);
            movido = true;
            bloqueoSwipe = true;
          }
          if (e.cancelable) e.preventDefault();
          return;
        }
        if (e.touches.length > 1) {
          empezarPinch(e.touches[0], e.touches[1]);
          if (e.cancelable) e.preventDefault();
          return;
        }
        setTimeout(function () {
          if (!modo && lightboxImg) lightboxImg.classList.remove('is-gesto');
        }, 320);
        if (modo === 'pan' && deslizando) {
          deslizando = false;
          var dx = finX - iniX;
          if (dx < -60 && lbIndice < lbLista.length - 1) {
            lbMostrar(lbIndice + 1);
          } else if (dx > 60 && lbIndice > 0) {
            lbMostrar(lbIndice - 1);
          } else {
            lbAnim(true);
            lbReset();
          }
        } else if (modo === 'pan' && !movido && e.type === 'touchend') {
          var ahora = Date.now();
          if (!sobreImg && lbScale <= 1.01) {
            cerrarLightbox();
          } else if (ahora - ultimoTap < 300 && Math.abs(iniX - ultimoTapX) < 40 && Math.abs(iniY - ultimoTapY) < 40) {
            ultimoTap = 0;
            dobleTap(iniX, iniY);
          } else {
            ultimoTap = ahora; ultimoTapX = iniX; ultimoTapY = iniY;
          }
        } else if (lbScale <= 1.02) {
          if (lbScale !== 1 || lbTx !== 0 || lbTy !== 0) {
            lbAnim(true);
            lbReset();
          }
        } else {
          lbApply();
        }
        modo = null;
        if (e.cancelable) e.preventDefault();
      }

      lightboxArea.addEventListener('touchend', finToque, { passive: false });
      lightboxArea.addEventListener('touchcancel', finToque, { passive: false });
    }

    function abrirLightbox(lista, indice) {
      if (!lista || !lista.length) return;
      crearLightbox();
      lbLista = lista;
      lightbox.classList.add('is-abierto');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      lbMostrar(indice || 0);
    }

    function capaZoom(item) {
      var capa = item.querySelector('.mia-galeria__zoom');
      if (capa) return capa;
      var img = item.querySelector('img.mia-galeria__img');
      if (!img) return null;
      var base = img.getAttribute('src') || img.src;
      if (!base) return null;
      var tam = Math.max(zoomPct, 120);
      capa = document.createElement('div');
      capa.className = 'mia-galeria__zoom';
      capa.setAttribute('aria-hidden', 'true');
      setImp(capa, 'background-image', 'url("' + hiRes(base, zoomAncho) + '"), url("' + base + '")');
      setImp(capa, 'background-size', tam + '% ' + tam + '%');
      item.appendChild(capa);
      return capa;
    }

    function ocultarZoom() {
      if (!zoomItem) return;
      var capa = zoomItem.querySelector('.mia-galeria__zoom');
      if (capa) capa.classList.remove('is-visible');
      zoomItem = null;
    }

    function itemBajoPunto() {
      if (!tienePunto || lastX < 0 || lastY < 0) return null;
      var el = document.elementFromPoint(lastX, lastY);
      if (!el || !el.closest) return null;
      return el.closest('.mia-galeria__carrusel .mia-galeria__item');
    }

    function scheduleZoom() {
      if (!esEscritorio()) { ocultarZoom(); return; }
      if (zoomRaf) return;
      zoomRaf = raf(function () { zoomRaf = null; renderZoom(); });
    }

    function renderZoom() {
      if (!esEscritorio()) { ocultarZoom(); return; }
      var item = itemBajoPunto();
      if (!item) { ocultarZoom(); return; }
      if (zoomItem && zoomItem !== item) ocultarZoom();
      var capa = capaZoom(item);
      if (!capa) { ocultarZoom(); return; }
      var r = item.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) { ocultarZoom(); return; }
      var px = (lastX - r.left) / r.width * 100;
      var py = (lastY - r.top) / r.height * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      setImp(capa, 'background-position', px.toFixed(2) + '% ' + py.toFixed(2) + '%');
      capa.classList.add('is-visible');
      zoomItem = item;
    }

    function precargarZoom() {
      if (!carrusel || !esEscritorio()) return;
      var imgs = carrusel.querySelectorAll('img.mia-galeria__img');
      for (var i = 0; i < imgs.length; i++) {
        var s = hiRes(imgs[i].getAttribute('src') || imgs[i].src, zoomAncho);
        if (!s) continue;
        var pre = new Image();
        pre.decoding = 'async';
        pre.src = s;
      }
    }

    function initZoomEventos() {
      if (zoomEventosListos) return;
      zoomEventosListos = true;
      var onMove = function (e) {
        lastX = e.clientX; lastY = e.clientY; tienePunto = true;
        scheduleZoom();
      };
      document.addEventListener('mousemove', onMove, { passive: true, capture: true });
      document.addEventListener('pointermove', onMove, { passive: true, capture: true });
      window.addEventListener('scroll', scheduleZoom, { passive: true, capture: true });
      window.addEventListener('resize', scheduleZoom, { passive: true });
      document.addEventListener('mouseleave', function () { tienePunto = false; ocultarZoom(); });
      window.addEventListener('blur', function () { tienePunto = false; ocultarZoom(); });
    }

    function slidesPrincipal() {
      return principal ? principal.querySelectorAll('.mia-galeria__item') : [];
    }

    function indiceDeId(id) {
      var slides = slidesPrincipal();
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === id) return i;
      }
      return 0;
    }

    function indiceVisible() {
      var slides = slidesPrincipal();
      if (!slides.length) return 0;
      var max = principal.scrollWidth - principal.clientWidth;
      var pos = principal.scrollLeft;
      if (max > 0 && pos >= max - 2) return slides.length - 1;
      var mejor = 0, dist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - pos);
        if (d < dist) { dist = d; mejor = i; }
      }
      return mejor;
    }

    function marcarActivo(id) {
      if (!puntos) return;
      var idx = indiceDeId(id);
      var botones = puntos.querySelectorAll('.mia-galeria__punto');
      for (var i = 0; i < botones.length; i++) {
        if (i === idx) {
          botones[i].classList.add('is-active');
          botones[i].setAttribute('aria-current', 'true');
        } else {
          botones[i].classList.remove('is-active');
          botones[i].removeAttribute('aria-current');
        }
      }
    }

    function irASlide(id, smooth) {
      if (!principal) return;
      var slides = slidesPrincipal();
      if (!slides.length) return;
      var idx = indiceDeId(id);
      var max = Math.max(0, principal.scrollWidth - principal.clientWidth);
      var left = Math.min(slides[idx].offsetLeft, max);
      if (smooth && principal.scrollTo) {
        try { principal.scrollTo({ left: left, behavior: 'smooth' }); }
        catch (e) { principal.scrollLeft = left; }
      } else {
        principal.scrollLeft = left;
      }
    }

    function construirGaleria(root) {
      galeria = root.querySelector('.mia-galeria');
      if (!galeria || galeria.__miaMontada) return;
      itemsOriginales = Array.prototype.slice.call(galeria.querySelectorAll('.mia-galeria__item'));
      if (!itemsOriginales.length) return;
      galeria.__miaMontada = true;

      principal = document.createElement('div');
      principal.className = 'mia-galeria__principal';
      principal.setAttribute('aria-roledescription', 'carrusel');
      puntos = document.createElement('div');
      puntos.className = 'mia-galeria__puntos';
      carrusel = document.createElement('div');
      carrusel.className = 'mia-galeria__carrusel';
      oculto = document.createElement('div');
      oculto.className = 'mia-galeria__oculto';
      oculto.style.display = 'none';

      galeria.innerHTML = '';
      galeria.appendChild(principal);
      galeria.appendChild(puntos);
      galeria.appendChild(carrusel);
      galeria.appendChild(oculto);

      for (var i = 0; i < itemsOriginales.length; i++) oculto.appendChild(itemsOriginales[i]);

      reconstruir(root);

      puntos.addEventListener('click', function (e) {
        var boton = e.target && e.target.closest ? e.target.closest('.mia-galeria__punto') : null;
        if (!boton) return;
        var idx = parseInt(boton.getAttribute('data-indice'), 10) || 0;
        var slides = slidesPrincipal();
        if (!slides[idx]) return;
        setMain(slides[idx].getAttribute('data-media-id'));
      });

      principal.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = raf(function () {
          scrollRaf = null;
          var slides = slidesPrincipal();
          var slide = slides[indiceVisible()];
          if (!slide) return;
          var id = slide.getAttribute('data-media-id');
          if (id && id !== mainId) { mainId = id; marcarActivo(id); }
        });
      }, { passive: true });

      principal.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
        touchMoved = false;
      }, { passive: true });

      principal.addEventListener('touchmove', function (e) {
        if (touchX === null || !e.touches || !e.touches.length) return;
        if (Math.abs(e.touches[0].clientX - touchX) > 8 || Math.abs(e.touches[0].clientY - touchY) > 8) touchMoved = true;
      }, { passive: true });

      principal.addEventListener('click', function (e) {
        if (touchMoved) { touchMoved = false; return; }
        var item = e.target && e.target.closest ? e.target.closest('.mia-galeria__item') : null;
        if (!item || !item.querySelector('img')) return;
        var slides = slidesPrincipal();
        var lista = [];
        var indice = 0;
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          if (!img) continue;
          if (slides[i] === item) indice = lista.length;
          lista.push({
            src: hiRes(img.currentSrc || img.src),
            alt: img.alt,
            id: slides[i].getAttribute('data-media-id')
          });
        }
        abrirLightbox(lista, indice);
      });

      window.addEventListener('resize', function () {
        if (!esEscritorio()) irASlide(mainId, false);
      });
    }

    function reconstruir(root) {
      if (!principal || !carrusel || !oculto) return;
      visiblesActuales = itemsActivos(root);
      mainId = visiblesActuales.length ? visiblesActuales[0].getAttribute('data-media-id') : null;
      colocar();
    }

    function colocar() {
      if (!principal || !carrusel || !oculto) return;
      var i;
      for (i = 0; i < itemsOriginales.length; i++) oculto.appendChild(itemsOriginales[i]);
      carrusel.innerHTML = '';
      principal.innerHTML = '';
      puntos.innerHTML = '';
      for (i = 0; i < visiblesActuales.length; i++) carrusel.appendChild(visiblesActuales[i]);
      var existe = false;
      for (i = 0; i < visiblesActuales.length; i++) {
        if (visiblesActuales[i].getAttribute('data-media-id') === mainId) { existe = true; break; }
      }
      if (!existe && visiblesActuales.length) mainId = visiblesActuales[0].getAttribute('data-media-id');
      var total = visiblesActuales.length;
      for (i = 0; i < total; i++) {
        var clon = visiblesActuales[i].cloneNode(true);
        clon.classList.remove('is-active');
        clon.setAttribute('role', 'group');
        clon.setAttribute('aria-label', (i + 1) + ' / ' + total);
        var capaClon = clon.querySelector('.mia-galeria__zoom');
        if (capaClon) clon.removeChild(capaClon);
        var imgClon = clon.querySelector('img');
        if (imgClon) {
          imgClon.draggable = false;
          if (i === 0) imgClon.setAttribute('loading', 'eager');
        }
        principal.appendChild(clon);
      }
      if (total > 1) {
        puntos.hidden = false;
        for (i = 0; i < total; i++) {
          var boton = document.createElement('button');
          boton.type = 'button';
          boton.className = 'mia-galeria__punto';
          boton.setAttribute('data-indice', i);
          boton.setAttribute('aria-label', 'Ver imagen ' + (i + 1) + ' de ' + total);
          puntos.appendChild(boton);
        }
      } else {
        puntos.hidden = true;
      }
      marcarActivo(mainId);
      irASlide(mainId, false);
      ocultarZoom();
      precargarZoom();
    }

    function setMain(id) {
      if (!id) return;
      mainId = id;
      marcarActivo(id);
      irASlide(id, true);
    }

    function init() {
      info = document.querySelector('.mia-producto');
      if (!info) return;
      var zAttr = parseFloat(info.getAttribute('data-mia-zoom'));
      if (zAttr && zAttr > 0) zoomPct = zAttr;
      try { construirGaleria(info); } catch (e) {}
      try { applyColorImages(info); } catch (e) {}
      if (!info.__miaInited) {
        info.__miaInited = true;
        info.addEventListener('change', function (e) {
          if (e.target && (e.target.matches('input[type="radio"]') || e.target.matches('select'))) {
            try { applyColorImages(info); } catch (e2) {}
            try { reconstruir(info); } catch (e2) {}
          }
        });
        try {
          var obs = new MutationObserver(function () { applyColorImages(info); });
          obs.observe(info, { childList: true, subtree: true });
        } catch (e) {}
      }
    }

    function boot() {
      var intentos = 0;
      (function reintento() {
        init();
        intentos++;
        if (!document.querySelector('.mia-galeria__principal') && intentos < 50) {
          setTimeout(reintento, 100);
        }
      })();
    }

    initZoomEventos();

    if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
    window.addEventListener('load', init);
    document.addEventListener('shopify:section:load', init);
  })();

  (function () {
    if (window.__miaAbrirDrawerAlAnadir) return;
    window.__miaAbrirDrawerAlAnadir = true;

    function abrirDrawer() {
      if (!document.querySelector('[data-carrito]')) return;
      var tmp = document.createElement('button');
      tmp.type = 'button';
      tmp.setAttribute('data-abrir-carrito', '');
      tmp.style.display = 'none';
      document.body.appendChild(tmp);
      tmp.click();
      if (tmp.parentNode) tmp.parentNode.removeChild(tmp);
    }

    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = '';
        try { url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || ''; } catch (e) {}
        var esAdd = url && url.indexOf('/cart/add') !== -1;
        var p = origFetch.apply(this, arguments);
        if (esAdd && window.__miaPagoDirecto) {
          var destino = window.__miaPagoDirecto;
          window.__miaPagoDirecto = null;
          return p.then(function (r) {
            if (r && r.ok) {
              window.__miaVolverDelPago = true;
              window.location.href = destino;
              return new Promise(function () {});
            }
            return r;
          });
        }
        if (esAdd) {
          p.then(function () { setTimeout(abrirDrawer, 80); }).catch(function () {});
        }
        return p;
      };
    }

    window.addEventListener('pageshow', function (e) {
      if (!window.__miaVolverDelPago) return;
      window.__miaVolverDelPago = false;
      if (e.persisted) window.location.reload();
    });

    function drawerActivo() {
      var raizC = document.querySelector('[data-carrito]');
      return raizC && raizC.getAttribute('data-activar') === 'true';
    }

    document.addEventListener('click', function (e) {
      if (!drawerActivo()) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var enlace = t.closest('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"], a[href$="/cart/"]');
      if (!enlace) return;
      e.preventDefault();
      e.stopPropagation();
      abrirDrawer();
    }, true);
  })();

  (function () {
    if (window.__miaPagoDirectoListo) return;
    window.__miaPagoDirectoListo = true;
    var temporizador = null;

    window.addEventListener('click', function (e) {
      var enlace = e.target && e.target.closest ? e.target.closest('[data-mia-pago-directo]') : null;
      if (!enlace) return;
      var form = document.getElementById(enlace.getAttribute('data-mia-pago-directo'));
      var boton = form ? form.querySelector('button[type="submit"][name="add"]') : null;
      if (!boton || boton.disabled || boton.getAttribute('aria-disabled') === 'true' || typeof window.fetch !== 'function') return;
      e.preventDefault();
      e.stopPropagation();
      window.__miaPagoDirecto = enlace.getAttribute('href');
      if (temporizador) clearTimeout(temporizador);
      temporizador = setTimeout(function () { window.__miaPagoDirecto = null; }, 8000);
      boton.click();
    }, true);
  })();

  (function () {
    if (window.__miaTextoAnadir) return;
    window.__miaTextoAnadir = true;
    var idioma = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (idioma.indexOf('es') !== 0) return;

    function aplicar() {
      if (window.variantStrings) window.variantStrings.addToCart = 'Añadir al carrito';
    }

    aplicar();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aplicar);
    window.addEventListener('load', aplicar);
  })();

  (function () {
    if (window.__miaTrustpilotLink) return;
    window.__miaTrustpilotLink = true;

    var TP_URL = 'https://help.trustpilot.com/s/article/How-do-reviews-get-on-Trustpilot?language=en_US';

    function buscar(root) {
      var el = null;
      try {
        el = root.querySelector('.mia-trustpilot-link, .trustpilot-widget, [class*="trustpilot"], [class*="Trustpilot"], [class*="trustbox"], [data-trustpilot]');
      } catch (e) {}
      if (el) return el;
      var nodos = root.querySelectorAll('img, svg, iframe, a');
      for (var i = 0; i < nodos.length; i++) {
        var n = nodos[i];
        var t = ((n.getAttribute('src') || '') + ' ' + (n.getAttribute('href') || '') + ' ' + (n.getAttribute('alt') || '') + ' ' + (n.getAttribute('class') || '') + ' ' + (n.getAttribute('id') || '') + ' ' + (n.getAttribute('aria-label') || '') + ' ' + (n.getAttribute('title') || '')).toLowerCase();
        if (t.indexOf('trustpilot') > -1) return n;
      }
      return null;
    }

    function aplicar(root) {
      if (!root) return false;
      var stars = buscar(root);
      if (!stars || stars.__miaTP) return false;
      stars.__miaTP = true;

      var enlace = stars.closest ? stars.closest('a') : null;
      if (enlace) {
        enlace.setAttribute('href', TP_URL);
        enlace.setAttribute('target', '_blank');
        enlace.setAttribute('rel', 'noopener noreferrer');
        return true;
      }

      if (stars.tagName === 'IFRAME') {
        var cont = stars.parentElement || stars;
        var cs = window.getComputedStyle(cont);
        if (cs.position === 'static') cont.style.position = 'relative';
        var ov = document.createElement('a');
        ov.href = TP_URL;
        ov.target = '_blank';
        ov.rel = 'noopener noreferrer';
        ov.setAttribute('aria-label', 'Reseñas en Trustpilot');
        ov.style.cssText = 'position:absolute;inset:0;z-index:9;display:block;cursor:pointer;';
        cont.appendChild(ov);
        return true;
      }

      stars.style.cursor = 'pointer';
      stars.setAttribute('role', 'link');
      if (!stars.hasAttribute('tabindex')) stars.setAttribute('tabindex', '0');
      var ir = function () { window.open(TP_URL, '_blank', 'noopener'); };
      stars.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ir(); });
      stars.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ir(); }
      });
      return true;
    }

    function paso() {
      if (window.__miaTPdone) return true;
      var root = document.querySelector('.mia-producto');
      var ok = (root && aplicar(root)) || aplicar(document);
      if (ok) window.__miaTPdone = true;
      return ok;
    }

    function init() {
      var intentos = 0;
      (function reintento() {
        var ok = false;
        try { ok = paso(); } catch (e) {}
        intentos++;
        if (!ok && intentos < 40) setTimeout(reintento, 150);
      })();
    }

    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
    window.addEventListener('load', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  class MiaBusqueda extends HTMLElement {
    connectedCallback() {
      if (this._conectado) return;
      this._conectado = true;

      this.formulario = this.querySelector('[data-busp-formulario]');
      this.input = this.querySelector('[data-busp-input]');
      this.botonBorrar = this.querySelector('[data-busp-borrar]');
      this.dinamico = this.querySelector('[data-busp-dinamico]');
      if (!this.formulario || !this.input || !this.dinamico) return;

      this.cache = new Map();
      this.urlBusqueda = this.dataset.urlBusqueda || '/search';
      this.consultaMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.filtrosAbiertos = this.dataset.filtrosAbiertos === 'true' && window.matchMedia('(min-width: 750px)').matches;
      this.ultimaConsulta = this.input.value.trim();
      this.pestanaActiva = 'productos';

      this.onInput = this.alEscribir.bind(this);
      this.onSubmit = this.alEnviar.bind(this);
      this.onClick = this.gestionarClick.bind(this);
      this.onChange = this.gestionarCambio.bind(this);
      this.onTecla = this.gestionarTecla.bind(this);
      this.onPopstate = this.alVolver.bind(this);
      this.onScroll = this.alDesplazar.bind(this);
      this.onPointerOver = this.alPasar.bind(this);
      this.onTouch = this.alTocar.bind(this);
      this.onFocusIn = this.alEnfocar.bind(this);

      this.input.addEventListener('input', this.onInput);
      this.formulario.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onTecla);
      this.onEnviarFiltros = (evento) => {
        if (evento.target instanceof Element && evento.target.matches('[data-busp-filtros-form]')) {
          evento.preventDefault();
          this.aplicarFiltros(true);
        }
      };
      this.addEventListener('submit', this.onEnviarFiltros);
      this.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
      this.addEventListener('pointerover', this.onPointerOver, { passive: true });
      this.addEventListener('touchstart', this.onTouch, { passive: true });
      this.addEventListener('focusin', this.onFocusIn);
      window.addEventListener('popstate', this.onPopstate);

      this.prepararVista();
    }

    disconnectedCallback() {
      if (!this._conectado) return;
      this._conectado = false;
      window.removeEventListener('popstate', this.onPopstate);
      clearTimeout(this.tEscribir);
      clearTimeout(this.tFiltros);
      if (this.ctrl) this.ctrl.abort();
    }

    reducido() {
      return this.consultaMovimiento && this.consultaMovimiento.matches;
    }

    prepararVista() {
      this.aplicarEstadoFiltros();
      this.mezclarPopulares();
      this.pintarSugerencias();
      if (this.querySelector('[data-busp-pestana="' + this.pestanaActiva + '"]')) {
        this.activarPestana(this.pestanaActiva);
      } else {
        this.activarPestana('productos');
      }
      requestAnimationFrame(() => this.actualizarFlechas());
    }

    alEscribir() {
      const valor = this.input.value;
      if (this.botonBorrar) this.botonBorrar.hidden = valor.length === 0;
      clearTimeout(this.tEscribir);
      const consulta = valor.trim();
      if (consulta === this.ultimaConsulta) return;
      this.tEscribir = setTimeout(() => this.buscarTexto(consulta, 'replace'), parseInt(this.dataset.espera, 10) || 380);
    }

    alEnviar(evento) {
      evento.preventDefault();
      clearTimeout(this.tEscribir);
      const consulta = this.input.value.trim();
      this.buscarTexto(consulta, 'push');
      if (window.matchMedia('(hover: none)').matches) this.input.blur();
    }

    buscarTexto(consulta, modo) {
      this.ultimaConsulta = consulta;
      this.pestanaActiva = 'productos';
      const parametros = new URLSearchParams();
      if (consulta) {
        parametros.set('q', consulta);
        parametros.set('options[prefix]', 'last');
        const orden = this.querySelector('[data-busp-orden]');
        if (orden && orden.value) parametros.set('sort_by', orden.value);
      }
      this.actualizar(parametros, modo);
    }

    recogerParametros() {
      const parametros = new URLSearchParams();
      const consulta = this.input.value.trim();
      if (consulta) parametros.set('q', consulta);
      parametros.set('options[prefix]', 'last');
      const orden = this.querySelector('[data-busp-orden]');
      if (orden && orden.value) parametros.set('sort_by', orden.value);
      this.querySelectorAll('[data-busp-filtro]:checked').forEach((entrada) => parametros.append(entrada.name, entrada.value));
      this.querySelectorAll('[data-busp-precio]').forEach((entrada) => {
        const valor = entrada.value.trim().replace(',', '.');
        if (valor !== '' && !isNaN(parseFloat(valor))) parametros.append(entrada.name, String(parseFloat(valor)));
      });
      return parametros;
    }

    aplicarFiltros(inmediato) {
      clearTimeout(this.tFiltros);
      const ejecutar = () => {
        this.ultimaConsulta = this.input.value.trim();
        this.actualizar(this.recogerParametros(), 'push');
      };
      if (inmediato) {
        ejecutar();
      } else {
        this.tFiltros = setTimeout(ejecutar, 260);
      }
    }

    async actualizar(parametros, modo) {
      const consulta = parametros.toString();
      const urlPagina = this.urlBusqueda + (consulta ? '?' + consulta : '');
      const urlSeccion = this.urlBusqueda + '?' + (consulta ? consulta + '&' : '') + 'section_id=' + encodeURIComponent(this.dataset.seccion);

      if (this.ctrl) this.ctrl.abort();
      const ctrl = new AbortController();
      this.ctrl = ctrl;
      this.classList.add('mia-busp--cargando');

      try {
        let html = this.cache.get(urlSeccion);
        if (!html) {
          const respuesta = await fetch(urlSeccion, { signal: ctrl.signal, credentials: 'same-origin' });
          if (!respuesta.ok) throw new Error(String(respuesta.status));
          html = await respuesta.text();
          this.guardarCache(urlSeccion, html);
        }
        if (ctrl.signal.aborted) return;
        this.pintar(html);
        try {
          if (modo === 'push') window.history.pushState({ miaBusqueda: true }, '', urlPagina);
          if (modo === 'replace') window.history.replaceState({ miaBusqueda: true }, '', urlPagina);
        } catch (e) {
          void e;
        }
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = urlPagina;
      } finally {
        if (this.ctrl === ctrl) this.classList.remove('mia-busp--cargando');
      }
    }

    guardarCache(clave, html) {
      this.cache.set(clave, html);
      if (this.cache.size > 30) this.cache.delete(this.cache.keys().next().value);
    }

    pintar(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nuevo = doc.querySelector('[data-busp-dinamico]');
      if (!nuevo) throw new Error('sin contenido');
      this.dinamico.innerHTML = nuevo.innerHTML;
      if (!this.reducido()) {
        this.dinamico.classList.remove('mia-busp-dinamico--entrando');
        void this.dinamico.offsetWidth;
        this.dinamico.classList.add('mia-busp-dinamico--entrando');
      }
      this.prepararVista();
    }

    alVolver() {
      const parametros = new URLSearchParams(window.location.search);
      const consulta = parametros.get('q') || '';
      this.input.value = consulta;
      if (this.botonBorrar) this.botonBorrar.hidden = consulta.length === 0;
      this.ultimaConsulta = consulta.trim();
      this.actualizar(parametros, null);
    }

    gestionarTecla(evento) {
      const precio = evento.target instanceof Element ? evento.target.closest('[data-busp-precio]') : null;
      if (precio && evento.key === 'Enter') {
        evento.preventDefault();
        this.aplicarFiltros(true);
      }
    }

    gestionarCambio(evento) {
      const objetivo = evento.target;
      if (!(objetivo instanceof Element)) return;
      if (objetivo.matches('[data-busp-filtro]')) {
        const opcion = objetivo.closest('.mia-busp-opcion');
        if (opcion) opcion.classList.toggle('mia-busp-opcion--activa', objetivo.checked);
        this.aplicarFiltros(false);
        return;
      }
      if (objetivo.matches('[data-busp-orden]')) {
        this.aplicarFiltros(true);
        return;
      }
      if (objetivo.matches('[data-busp-precio]')) {
        this.aplicarFiltros(false);
      }
    }

    gestionarClick(evento) {
      const objetivo = evento.target;
      if (!(objetivo instanceof Element)) return;

      if (objetivo.closest('[data-busp-borrar]')) {
        evento.preventDefault();
        this.input.value = '';
        if (this.botonBorrar) this.botonBorrar.hidden = true;
        clearTimeout(this.tEscribir);
        this.buscarTexto('', 'push');
        this.input.focus();
        return;
      }

      const sugerencia = objetivo.closest('[data-busp-sugerencia]');
      if (sugerencia) {
        evento.preventDefault();
        const texto = sugerencia.getAttribute('data-busp-sugerencia');
        this.input.value = texto;
        if (this.botonBorrar) this.botonBorrar.hidden = false;
        clearTimeout(this.tEscribir);
        this.buscarTexto(texto, 'push');
        return;
      }

      const pestana = objetivo.closest('[data-busp-pestana]');
      if (pestana) {
        evento.preventDefault();
        this.activarPestana(pestana.getAttribute('data-busp-pestana'));
        return;
      }

      if (objetivo.closest('[data-busp-alternar-filtros]')) {
        evento.preventDefault();
        this.filtrosAbiertos = !this.filtrosAbiertos;
        this.aplicarEstadoFiltros();
        return;
      }

      const enlaceFiltro = objetivo.closest('[data-busp-url]');
      if (enlaceFiltro) {
        evento.preventDefault();
        const url = new URL(enlaceFiltro.getAttribute('href'), window.location.origin);
        const consulta = url.searchParams.get('q') || '';
        this.input.value = consulta;
        if (this.botonBorrar) this.botonBorrar.hidden = consulta.length === 0;
        this.ultimaConsulta = consulta.trim();
        this.actualizar(url.searchParams, 'push');
        return;
      }

      const cargar = objetivo.closest('[data-busp-cargar]');
      if (cargar) {
        evento.preventDefault();
        this.cargarMas(cargar);
        return;
      }

      const flechaPista = objetivo.closest('[data-busp-pista]');
      if (flechaPista) {
        evento.preventDefault();
        this.moverPista(parseInt(flechaPista.getAttribute('data-busp-pista'), 10) || 1);
        return;
      }

      const tarjeta = objetivo.closest('[data-mia-busp-tarjeta]');
      if (!tarjeta) return;

      const color = objetivo.closest('[data-mia-busp-color]');
      if (color) {
        evento.preventDefault();
        this.seleccionarColor(tarjeta, color);
        return;
      }

      const flecha = objetivo.closest('[data-mia-busp-flecha]');
      if (flecha) {
        evento.preventDefault();
        this.cambiarImagen(tarjeta, parseInt(flecha.getAttribute('data-mia-busp-flecha'), 10) || 1);
        return;
      }

      const talla = objetivo.closest('[data-mia-busp-talla]');
      if (talla) {
        evento.preventDefault();
        this.anadirTalla(tarjeta, talla);
      }
    }

    aplicarEstadoFiltros() {
      const panel = this.querySelector('[data-busp-filtros]');
      const boton = this.querySelector('[data-busp-alternar-filtros]');
      if (panel) panel.classList.toggle('mia-busp-filtros--abierto', !!this.filtrosAbiertos);
      if (boton) boton.setAttribute('aria-expanded', this.filtrosAbiertos ? 'true' : 'false');
    }

    activarPestana(nombre) {
      this.pestanaActiva = nombre;
      this.querySelectorAll('[data-busp-pestana]').forEach((boton) => {
        boton.setAttribute('aria-selected', boton.getAttribute('data-busp-pestana') === nombre ? 'true' : 'false');
      });
      this.querySelectorAll('[data-busp-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-busp-panel') !== nombre;
      });
    }

    async cargarMas(enlace) {
      if (enlace.getAttribute('aria-busy') === 'true') return;
      enlace.setAttribute('aria-busy', 'true');
      const url = new URL(enlace.getAttribute('href'), window.location.origin);
      url.searchParams.set('section_id', this.dataset.seccion);
      try {
        const respuesta = await fetch(url.pathname + url.search, { credentials: 'same-origin' });
        if (!respuesta.ok) throw new Error(String(respuesta.status));
        const doc = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
        const nuevas = doc.querySelector('[data-busp-rejilla]');
        const rejilla = this.querySelector('[data-busp-rejilla]');
        if (nuevas && rejilla) {
          const fragmento = document.createDocumentFragment();
          Array.from(nuevas.children).forEach((nodo) => {
            if (!this.reducido()) nodo.classList.add('mia-busp-aparece');
            fragmento.appendChild(nodo);
          });
          rejilla.appendChild(fragmento);
        }
        const paginacion = doc.querySelector('[data-busp-paginacion]');
        const actual = this.querySelector('[data-busp-paginacion]');
        if (paginacion && actual) actual.replaceWith(paginacion);
        this.pintarSugerencias();
      } catch (error) {
        window.location.href = enlace.getAttribute('href');
      } finally {
        enlace.removeAttribute('aria-busy');
      }
    }

    mezclarPopulares() {
      const contenedor = this.querySelector('[data-busp-populares]');
      if (!contenedor) return;
      const chips = Array.from(contenedor.children);
      if (!chips.length) return;
      const visibles = parseInt(this.dataset.numPopulares, 10) || chips.length;
      for (let i = chips.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temporal = chips[i];
        chips[i] = chips[j];
        chips[j] = temporal;
      }
      chips.forEach((chip, i) => {
        chip.hidden = i >= visibles;
        contenedor.appendChild(chip);
      });
    }

    normalizar(texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '');
    }

    limpiarPalabra(palabra) {
      return palabra.replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, '');
    }

    generarSugerencias(consulta, fuentes) {
      const maximo = parseInt(this.dataset.numSugerencias, 10);
      if (!maximo) return [];
      const base = consulta.toLowerCase().replace(/\s+/g, ' ').trim();
      const tokens = this.normalizar(base).split(' ').filter(Boolean);
      if (!tokens.length) return [];
      const vacias = new Set(['de', 'del', 'la', 'el', 'los', 'las', 'con', 'y', 'e', 'o', 'u', 'en', 'a', 'al', 'para', 'por', 'sin', 'un', 'una', 'su', 'sus', 'tu']);
      const mapa = new Map();

      const sumar = (texto, puntos) => {
        const clave = this.normalizar(texto);
        const previo = mapa.get(clave);
        if (previo) {
          previo.puntos += puntos;
        } else {
          mapa.set(clave, { texto, puntos, palabras: texto.split(' ').length });
        }
      };

      fuentes.forEach((fuente) => {
        String(fuente || '')
          .split(/[|·•\/,()]+|\s[-–—]\s/)
          .forEach((segmento) => {
            const palabras = segmento
              .toLowerCase()
              .split(/\s+/)
              .map((p) => this.limpiarPalabra(p))
              .filter(Boolean);
            const normales = palabras.map((p) => this.normalizar(p));
            for (let i = 0; i < palabras.length; i++) {
              let encaja = true;
              for (let t = 0; t < tokens.length; t++) {
                const palabra = normales[i + t];
                if (palabra === undefined) {
                  encaja = false;
                  break;
                }
                const ultimo = t === tokens.length - 1;
                if (ultimo ? !palabra.startsWith(tokens[t]) : palabra !== tokens[t]) {
                  encaja = false;
                  break;
                }
              }
              if (!encaja) continue;
              const inicioSegmento = i === 0 ? 1 : 0;
              let extra = 0;
              for (let fin = i + tokens.length; fin <= palabras.length && extra < 3; fin++) {
                const ultima = normales[fin - 1];
                if (vacias.has(ultima) && fin - 1 >= i + tokens.length) continue;
                sumar(palabras.slice(i, fin).join(' '), (extra === 0 ? 3 : 1) + inicioSegmento);
                extra++;
              }
            }
          });
      });

      return Array.from(mapa.values())
        .sort((a, b) => b.puntos - a.puntos || a.palabras - b.palabras || a.texto.length - b.texto.length)
        .slice(0, maximo)
        .map((s) => s.texto);
    }

    pintarSugerencias() {
      const contenedor = this.querySelector('[data-busp-sugerencias]');
      if (!contenedor) return;
      const consulta = this.input.value.trim();
      const fuentes = [];
      this.querySelectorAll('[data-mia-busp-tarjeta], [data-mia-busp-texto], [data-busp-coleccion]').forEach((nodo) => {
        if (nodo.dataset.titulo) fuentes.push(nodo.dataset.titulo);
        if (nodo.dataset.tipo) fuentes.push(nodo.dataset.tipo);
      });
      const lista = consulta ? this.generarSugerencias(consulta, fuentes) : [];
      contenedor.textContent = '';
      const base = consulta.toLowerCase().replace(/\s+/g, ' ').trim();
      const baseNormal = this.normalizar(base);
      let activa = lista.findIndex((s) => this.normalizar(s) === baseNormal);
      if (activa < 0) activa = 0;
      lista.forEach((texto, i) => {
        const boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'mia-busp-sugerencia' + (i === activa ? ' mia-busp-sugerencia--activa' : '');
        boton.setAttribute('data-busp-sugerencia', texto);
        const largo = this.normalizar(texto).startsWith(baseNormal) ? base.length : 0;
        const parteBase = document.createElement('span');
        parteBase.className = 'mia-busp-sugerencia-base';
        parteBase.textContent = texto.slice(0, largo);
        const parteResto = document.createElement('strong');
        parteResto.className = 'mia-busp-sugerencia-resto';
        parteResto.textContent = texto.slice(largo);
        boton.appendChild(parteBase);
        boton.appendChild(parteResto);
        contenedor.appendChild(boton);
      });
      contenedor.hidden = lista.length === 0;
    }

    alDesplazar(evento) {
      if (evento.target instanceof Element && evento.target.matches('[data-busp-destacados]')) {
        if (this._rafFlechas) return;
        this._rafFlechas = requestAnimationFrame(() => {
          this._rafFlechas = null;
          this.actualizarFlechas();
        });
      }
    }

    moverPista(direccion) {
      const pista = this.querySelector('[data-busp-destacados]');
      if (!pista) return;
      const tarjeta = pista.querySelector('[data-mia-busp-tarjeta]');
      const hueco = parseFloat(window.getComputedStyle(pista).columnGap) || 0;
      const paso = tarjeta ? tarjeta.getBoundingClientRect().width + hueco : pista.clientWidth * 0.8;
      const visibles = Math.max(1, Math.floor((pista.clientWidth + hueco + 2) / paso));
      pista.scrollBy({ left: direccion * paso * visibles, behavior: this.reducido() ? 'auto' : 'smooth' });
    }

    actualizarFlechas() {
      const pista = this.querySelector('[data-busp-destacados]');
      const flechas = this.querySelector('[data-busp-flechas]');
      if (!pista || !flechas) return;
      const maximo = pista.scrollWidth - pista.clientWidth;
      const anterior = flechas.querySelector('[data-busp-pista="-1"]');
      const siguiente = flechas.querySelector('[data-busp-pista="1"]');
      flechas.classList.toggle('mia-busp-flechas-pista--ocultas', maximo <= 2);
      if (anterior) anterior.disabled = pista.scrollLeft <= 2;
      if (siguiente) siguiente.disabled = pista.scrollLeft >= maximo - 2;
    }

    datosTarjeta(tarjeta) {
      if (!tarjeta._miaBusp) {
        let variantes = [];
        const script = tarjeta.querySelector('[data-mia-busp-variantes]');
        if (script) {
          try {
            variantes = JSON.parse(script.textContent);
          } catch (e) {
            variantes = [];
          }
        }
        const activo = tarjeta.querySelector('.mia-busp-color--activo');
        tarjeta._miaBusp = {
          variantes,
          pc: (parseInt(tarjeta.dataset.posColor, 10) || 0) - 1,
          pt: (parseInt(tarjeta.dataset.posTalla, 10) || 0) - 1,
          color: activo ? activo.getAttribute('data-mia-busp-color') : null,
          preparada: false
        };
      }
      return tarjeta._miaBusp;
    }

    prepararTarjeta(tarjeta) {
      const datos = this.datosTarjeta(tarjeta);
      if (datos.preparada) return datos;
      datos.preparada = true;
      this.cargarGaleria(tarjeta);
      this.actualizarTallas(tarjeta);
      return datos;
    }

    cargarGaleria(tarjeta) {
      tarjeta.querySelectorAll('img[data-mia-busp-src]').forEach((img) => {
        const srcset = img.getAttribute('data-mia-busp-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-mia-busp-src'));
        img.removeAttribute('data-mia-busp-src');
        img.removeAttribute('data-mia-busp-srcset');
      });
    }

    alPasar(evento) {
      if (evento.pointerType === 'touch') return;
      const tarjeta = evento.target instanceof Element ? evento.target.closest('[data-mia-busp-tarjeta]') : null;
      if (tarjeta) this.prepararTarjeta(tarjeta);
    }

    alTocar(evento) {
      const objetivo = evento.target instanceof Element ? evento.target : null;
      const tarjeta = objetivo ? objetivo.closest('[data-mia-busp-tarjeta]') : null;
      if (!tarjeta) return;
      this.prepararTarjeta(tarjeta);
      const visual = objetivo.closest('.mia-busp-visual');
      if (visual) this.mostrarTallas(visual);
    }

    alEnfocar(evento) {
      const tarjeta = evento.target instanceof Element ? evento.target.closest('[data-mia-busp-tarjeta]') : null;
      if (tarjeta) this.prepararTarjeta(tarjeta);
    }

    mostrarTallas(visual) {
      this.querySelectorAll('.mia-busp-visual--tallas').forEach((otra) => {
        if (otra !== visual) otra.classList.remove('mia-busp-visual--tallas');
      });
      visual.classList.add('mia-busp-visual--tallas');
    }

    activarImagen(tarjeta, posicion) {
      const slides = tarjeta.querySelectorAll('.mia-busp-slide');
      let objetivo = null;
      slides.forEach((slide) => {
        if (slide.getAttribute('data-pos') === String(posicion)) objetivo = slide;
      });
      if (!objetivo) return;
      slides.forEach((slide) => slide.classList.toggle('mia-busp-slide--activa', slide === objetivo));
    }

    cambiarImagen(tarjeta, direccion) {
      this.prepararTarjeta(tarjeta);
      const visual = tarjeta.querySelector('.mia-busp-visual');
      if (visual && window.matchMedia('(hover: none)').matches) this.mostrarTallas(visual);
      const slides = Array.from(tarjeta.querySelectorAll('.mia-busp-slide'));
      if (slides.length < 2) return;
      let actual = slides.findIndex((slide) => slide.classList.contains('mia-busp-slide--activa'));
      if (actual < 0) actual = 0;
      const siguiente = (actual + direccion + slides.length) % slides.length;
      slides[actual].classList.remove('mia-busp-slide--activa');
      slides[siguiente].classList.add('mia-busp-slide--activa');
    }

    seleccionarColor(tarjeta, boton) {
      const datos = this.prepararTarjeta(tarjeta);
      const valor = boton.getAttribute('data-mia-busp-color');
      datos.color = valor;
      tarjeta.querySelectorAll('[data-mia-busp-color]').forEach((b) => {
        const activo = b === boton;
        b.classList.toggle('mia-busp-color--activo', activo);
        b.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      const delColor = datos.pc >= 0 ? datos.variantes.filter((v) => v.o[datos.pc] === valor) : datos.variantes;
      const variante = delColor.find((v) => v.d) || delColor[0];
      const posicion = (variante && variante.i) || boton.getAttribute('data-pos');
      if (posicion) this.activarImagen(tarjeta, posicion);
      if (variante) this.aplicarVariante(tarjeta, variante);
      this.actualizarTallas(tarjeta);
    }

    textoAhorro(variante) {
      const texto = this.dataset.ahorroTexto ? this.dataset.ahorroTexto + ' ' : '';
      return texto + (this.dataset.ahorroTipo === 'porcentaje' ? variante.ap + '%' : variante.a);
    }

    aplicarVariante(tarjeta, variante) {
      const oferta = !!variante.c;
      tarjeta.querySelectorAll('[data-mia-busp-enlace]').forEach((enlace) => enlace.setAttribute('href', variante.u));
      const precio = tarjeta.querySelector('[data-mia-busp-precio]');
      if (precio) precio.textContent = variante.p;
      const tachado = tarjeta.querySelector('[data-mia-busp-tachado]');
      if (tachado) {
        tachado.textContent = oferta ? variante.c : '';
        tachado.hidden = !oferta;
      }
      const ahorro = tarjeta.querySelector('[data-mia-busp-ahorro]');
      if (ahorro) {
        ahorro.textContent = oferta ? this.textoAhorro(variante) : ' ';
        ahorro.classList.toggle('mia-busp-ahorro--vacio', !oferta);
      }
      const badge = tarjeta.querySelector('[data-mia-busp-badge]');
      if (badge && tarjeta.hasAttribute('data-badge-solo-oferta')) badge.hidden = !oferta;
    }

    actualizarTallas(tarjeta) {
      const datos = this.datosTarjeta(tarjeta);
      if (datos.pt < 0) return;
      tarjeta.querySelectorAll('[data-mia-busp-talla]').forEach((boton) => {
        const talla = boton.getAttribute('data-mia-busp-talla');
        const variante = datos.variantes.find(
          (v) => v.d && v.o[datos.pt] === talla && (datos.pc < 0 || datos.color === null || v.o[datos.pc] === datos.color)
        );
        boton.disabled = !variante;
        boton.classList.toggle('mia-busp-talla--agotada', !variante);
        boton.setAttribute('data-variante', variante ? String(variante.id) : '');
      });
    }

    async anadirTalla(tarjeta, boton) {
      this.prepararTarjeta(tarjeta);
      const variante = boton.getAttribute('data-variante');
      if (!variante || boton.disabled || boton.getAttribute('aria-busy') === 'true') return;
      boton.setAttribute('aria-busy', 'true');
      this.volarAlCarrito(boton);

      try {
        const respuesta = await fetch((this.dataset.urlCarrito || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variante), quantity: 1 }],
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const datos = await respuesta.json();
        if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || 'error');
        this.actualizarBurbuja(datos);
        this.notificarCarrito(datos);
        this.marcarTalla(boton, 'mia-busp-talla--anadida');
      } catch (error) {
        this.marcarTalla(boton, 'mia-busp-talla--error');
      } finally {
        boton.removeAttribute('aria-busy');
      }
    }

    marcarTalla(boton, clase) {
      boton.classList.add(clase);
      clearTimeout(boton._miaBuspTemporizador);
      boton._miaBuspTemporizador = setTimeout(() => boton.classList.remove(clase), 1100);
    }

    actualizarBurbuja(datos) {
      if (!datos || !datos.sections || !datos.sections['cart-icon-bubble']) return;
      const destino = document.getElementById('cart-icon-bubble');
      if (!destino) return;
      const doc = new DOMParser().parseFromString(datos.sections['cart-icon-bubble'], 'text/html');
      const seccion = doc.querySelector('.shopify-section');
      destino.innerHTML = seccion ? seccion.innerHTML : doc.body.innerHTML;
    }

    notificarCarrito(datos) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mia-busqueda', cartData: datos });
        }
      } catch (e) {
        return;
      }
    }

    volarAlCarrito(origen) {
      if (this.reducido()) return;
      const carrito = document.getElementById('cart-icon-bubble');
      if (!carrito || !origen) return;
      const o = origen.getBoundingClientRect();
      const c = carrito.getBoundingClientRect();
      if (!o.width || !c.width) return;
      const x0 = o.left + o.width / 2;
      const y0 = o.top + o.height / 2;
      const dx = c.left + c.width / 2 - x0;
      const dy = c.top + c.height / 2 - y0;
      const angulo = (Math.atan2(dy, dx) * 180) / Math.PI;
      const estrella = document.createElement('div');
      estrella.className = 'mia-busp-estrella';
      estrella.style.left = x0 + 'px';
      estrella.style.top = y0 + 'px';
      estrella.style.transform = 'translate(0px, 0px) rotate(' + angulo + 'deg)';
      estrella.innerHTML = '<span class="mia-busp-estrella-cola"></span><span class="mia-busp-estrella-nucleo"></span>';
      document.body.appendChild(estrella);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          estrella.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + angulo + 'deg) scale(0.3)';
          estrella.style.opacity = '0.15';
        });
      });
      setTimeout(() => {
        estrella.remove();
        carrito.classList.add('mia-busp-golpe');
        setTimeout(() => carrito.classList.remove('mia-busp-golpe'), 380);
      }, 440);
    }
  }

  if (!customElements.get('mia-busqueda')) {
    customElements.define('mia-busqueda', MiaBusqueda);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-colecciones"] && !Shopify.designMode) return;
  try {
    
  class SliderMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.pista) return;

      this.onScroll = this.actualizar.bind(this);
      this.onResize = this.actualizar.bind(this);
      this.pista.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.mover(-1));
      if (this.next) this.next.addEventListener('click', () => this.mover(1));

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.onResize);
        this.observador.observe(this.pista);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      this.actualizar();

      if (this.dataset.activoPrimero === 'true') {
        requestAnimationFrame(() => this.mostrarActivo());
      }
    }

    disconnectedCallback() {
      if (this.pista) this.pista.removeEventListener('scroll', this.onScroll);
      if (this.observador) this.observador.disconnect();
      window.removeEventListener('resize', this.onResize);
    }

    mover(dir) {
      this.pista.scrollBy({ left: dir * (this.pista.clientWidth * 0.7), behavior: 'smooth' });
    }

    mostrarActivo() {
      if (!this.pista) return;
      var activo = this.pista.querySelector('.slidermenu-item--activo');
      if (!activo) return;
      var delta = activo.getBoundingClientRect().left - this.pista.getBoundingClientRect().left;
      if (delta !== 0) this.pista.scrollLeft += delta;
      this.actualizar();
    }

    actualizar() {
      var max = this.pista.scrollWidth - this.pista.clientWidth;
      if (this.prev) this.prev.toggleAttribute('disabled', this.pista.scrollLeft <= 2);
      if (this.next) this.next.toggleAttribute('disabled', this.pista.scrollLeft >= max - 2);
    }
  }

  if (!customElements.get('slider-menu')) {
    customElements.define('slider-menu', SliderMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pestana-descuento-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instancias = {};
    var abiertasAntesDeRecargar = {};
    var aperturaAutomaticaReservada = false;
    var CLAVE_PENDIENTE = 'mia-descuento:pendiente';
    var CLAVE_SUSCRITA = 'mia-descuento:suscrita';
    var EMAIL_VALIDO = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var CLASES_BLOQUEO = /(^|\s)(overflow-hidden(-mobile|-tablet|-desktop)?|ef-menu-abierto|ef-carrito-abierto)(\s|$)/;
    var SELECTOR_ENFOCABLES = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var movimientoReducido = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var punteroFino = window.matchMedia ? window.matchMedia('(pointer: fine)') : { matches: true };

    function obtenerAlmacen(tipo) {
      try {
        var almacen = window[tipo];
        var prueba = '__mia_descuento__';
        almacen.setItem(prueba, '1');
        almacen.removeItem(prueba);
        return almacen;
      } catch (error) {
        return null;
      }
    }

    var almacenLocal = obtenerAlmacen('localStorage');
    var almacenSesion = obtenerAlmacen('sessionStorage');

    function leer(almacen, clave) {
      if (!almacen) return null;
      try {
        return almacen.getItem(clave);
      } catch (error) {
        return null;
      }
    }

    function escribir(almacen, clave, valor) {
      if (!almacen) return;
      try {
        almacen.setItem(clave, valor);
      } catch (error) {}
    }

    function borrar(almacen, clave) {
      if (!almacen) return;
      try {
        almacen.removeItem(clave);
      } catch (error) {}
    }

    function esVisible(elemento) {
      return !!elemento && elemento.getClientRects().length > 0 && window.getComputedStyle(elemento).visibility !== 'hidden';
    }

    function MiaDescuento(raiz) {
      this.raiz = raiz;
      this.id = raiz.getAttribute('data-seccion');
      this.cfg = {};
      try {
        this.cfg = JSON.parse(raiz.querySelector('[data-mia-configuracion]').textContent);
      } catch (error) {}
      this.cfg.mensajes = this.cfg.mensajes || {};
      this.prefijo = 'mia-descuento:' + (this.cfg.campana || 'general') + ':';
      this.pestana = raiz.querySelector('[data-mia-pestana]');
      this.pestanaInterna = raiz.querySelector('[data-mia-pestana-interna]');
      this.dialogo = raiz.querySelector('[data-mia-dialogo]');
      this.formulario = raiz.querySelector('form');
      this.email = raiz.querySelector('[data-mia-email]');
      this.errorEmail = raiz.querySelector('[data-mia-error-email]');
      this.consentimiento = raiz.querySelector('[data-mia-consentimiento]');
      this.errorConsentimiento = raiz.querySelector('[data-mia-error-consentimiento]');
      this.boton = raiz.querySelector('[data-mia-enviar]');
      this.textoBoton = raiz.querySelector('[data-mia-texto-boton]');
      this.textoBotonOriginal = this.textoBoton ? this.textoBoton.textContent : '';
      this.avisoServidor = raiz.querySelector('[data-mia-aviso-servidor]');
      this.vistaFormulario = raiz.querySelector('[data-mia-vista="formulario"]');
      this.vistaExito = raiz.querySelector('[data-mia-vista="exito"]');
      this.abierto = false;
      this.enviando = false;
      this.suscritaEnEstaVisita = false;
      this.temporizadores = [];
      this.manejadores = [];
      this.temporizadorCierre = null;
      this.ultimoFoco = null;
      this.iniciar();
    }

    MiaDescuento.prototype.escuchar = function (objetivo, evento, funcion, opciones) {
      if (!objetivo) return;
      objetivo.addEventListener(evento, funcion, opciones || false);
      this.manejadores.push([objetivo, evento, funcion, opciones || false]);
    };

    MiaDescuento.prototype.programar = function (funcion, espera) {
      var temporizador = setTimeout(funcion, espera);
      this.temporizadores.push(temporizador);
      return temporizador;
    };

    MiaDescuento.prototype.iniciar = function () {
      var self = this;
      var hijos = Array.prototype.slice.call(document.body.children);
      hijos.forEach(function (hijo) {
        if (hijo !== self.raiz && hijo.classList && hijo.classList.contains('mia-descuento') && hijo.getAttribute('data-seccion') === self.id) {
          hijo.parentNode.removeChild(hijo);
        }
      });
      document.body.appendChild(this.raiz);

      this.escuchar(this.pestana, 'click', function () {
        if (self.abierto) {
          self.cerrar('usuario');
        } else {
          self.mostrarVista(self.cfg.modoDiseno && self.cfg.previsualizarExito ? 'exito' : 'formulario');
          self.abrir({});
        }
      });

      this.escuchar(this.pestanaInterna, 'click', function () {
        self.cerrar('usuario');
      });

      Array.prototype.forEach.call(this.raiz.querySelectorAll('[data-mia-cerrar]'), function (elemento) {
        self.escuchar(elemento, 'click', function () {
          self.cerrar('usuario');
        });
      });

      this.escuchar(this.dialogo, 'cancel', function (evento) {
        evento.preventDefault();
        self.cerrar('usuario');
      });

      this.escuchar(this.dialogo, 'close', function () {
        if (self.abierto) self.cerrar('usuario', true);
      });

      this.escuchar(document, 'keydown', function (evento) {
        self.gestionarTeclado(evento);
      });

      this.escuchar(this.formulario, 'submit', function (evento) {
        self.enviar(evento);
      });

      this.escuchar(this.email, 'input', function () {
        self.limpiarError(self.email, self.errorEmail);
      });

      this.escuchar(this.consentimiento, 'change', function () {
        self.limpiarError(self.consentimiento, self.errorConsentimiento);
      });

      this.escuchar(this.raiz.querySelector('[data-mia-copiar]'), 'click', function (evento) {
        self.copiarCodigo(evento.currentTarget);
      });

      this.escuchar(window, 'pageshow', function (evento) {
        if (evento.persisted) self.restaurarBoton();
      });

      this.procesarEstadoServidor();
      this.prepararPestana();
      this.programarAperturaAutomatica();

      if (this.cfg.modoDiseno && abiertasAntesDeRecargar[this.id]) {
        delete abiertasAntesDeRecargar[this.id];
        this.mostrarVista(this.cfg.previsualizarExito ? 'exito' : 'formulario');
        this.abrir({ sinAnimacion: true, sinFoco: true });
      }
    };

    MiaDescuento.prototype.puedeGuardarPreferencias = function () {
      if (!this.cfg.respetarPrivacidad) return true;
      var privacidad = window.Shopify && window.Shopify.customerPrivacy;
      if (privacidad && typeof privacidad.preferencesProcessingAllowed === 'function') {
        try {
          return privacidad.preferencesProcessingAllowed() !== false;
        } catch (error) {
          return false;
        }
      }
      return true;
    };

    MiaDescuento.prototype.estaSuscrita = function () {
      return !!this.cfg.clienteSuscrito || this.suscritaEnEstaVisita || leer(almacenLocal, CLAVE_SUSCRITA) === '1';
    };

    MiaDescuento.prototype.cierreReciente = function () {
      var marca = parseInt(leer(almacenLocal, this.prefijo + 'cierre'), 10);
      if (!marca) return false;
      var dias = Number(this.cfg.diasRecordar) || 0;
      return Date.now() - marca < dias * 86400000;
    };

    MiaDescuento.prototype.prepararPestana = function () {
      var self = this;
      var cfg = this.cfg;
      var bloquear = false;

      if (!cfg.modoDiseno) {
        if (cfg.ocultarSuscritas && this.estaSuscrita()) bloquear = true;
        if (cfg.recordarCierre && cfg.accionRecordar === 'ocultar_pestana' && this.cierreReciente()) bloquear = true;
      }

      this.raiz.classList.toggle('mia-descuento--pestana-bloqueada', bloquear);

      if (!this.raiz.classList.contains('mia-descuento--pestana-pendiente')) return;

      var mostrar = function () {
        self.raiz.classList.remove('mia-descuento--pestana-pendiente');
      };

      if (cfg.estadoInicial === 'desplazamiento') {
        var umbral = Number(cfg.desplazamiento) || 0;
        var comprobar = function () {
          if ((window.pageYOffset || document.documentElement.scrollTop || 0) >= umbral) {
            mostrar();
            window.removeEventListener('scroll', comprobar);
          }
        };
        this.escuchar(window, 'scroll', comprobar, { passive: true });
        comprobar();
      } else if (cfg.estadoInicial === 'retraso') {
        this.programar(mostrar, (Number(cfg.retrasoPestana) || 0) * 1000);
      } else {
        mostrar();
      }
    };

    MiaDescuento.prototype.pestanaDisponible = function () {
      return !!this.pestana && window.getComputedStyle(this.pestana).display !== 'none' && !this.raiz.classList.contains('mia-descuento--pestana-bloqueada');
    };

    MiaDescuento.prototype.programarAperturaAutomatica = function () {
      var self = this;
      var cfg = this.cfg;
      if (!cfg.abrirAuto || cfg.modoDiseno || aperturaAutomaticaReservada) return;
      if (this.estaSuscrita()) return;
      if (cfg.recordarCierre && this.cierreReciente()) return;
      if (leer(almacenSesion, this.prefijo + 'auto') === '1') return;
      aperturaAutomaticaReservada = true;

      this.programar(function () {
        if (self.abierto || !self.pestanaDisponible()) return;
        if (document.querySelector('dialog[open]')) return;
        if (CLASES_BLOQUEO.test(document.body.className)) return;
        escribir(almacenSesion, self.prefijo + 'auto', '1');
        self.mostrarVista('formulario');
        self.abrir({});
      }, (Number(cfg.retrasoAuto) || 0) * 1000);
    };

    MiaDescuento.prototype.duracion = function () {
      if (movimientoReducido.matches) return 0;
      return Number(this.cfg.duracion) || 0;
    };

    MiaDescuento.prototype.mostrarVista = function (nombre) {
      var exito = nombre === 'exito' && this.vistaExito;
      if (this.vistaFormulario) this.vistaFormulario.hidden = !!exito;
      if (this.vistaExito) this.vistaExito.hidden = !exito;
      var titulo = (exito ? this.vistaExito : this.vistaFormulario);
      titulo = titulo ? titulo.querySelector('.mia-descuento__titulo') : null;
      if (titulo && this.dialogo) this.dialogo.setAttribute('aria-labelledby', titulo.id);
      if (this.dialogo) {
        if (exito) {
          this.dialogo.removeAttribute('aria-describedby');
        } else {
          var legal = this.raiz.querySelector('.mia-descuento__legal');
          if (legal) this.dialogo.setAttribute('aria-describedby', legal.id);
        }
      }
    };

    MiaDescuento.prototype.abrir = function (opciones) {
      var self = this;
      var dialogo = this.dialogo;
      opciones = opciones || {};
      if (this.abierto || !dialogo) return;

      clearTimeout(this.temporizadorCierre);
      this.ultimoFoco = document.activeElement;
      this.raiz.classList.add('mia-descuento--abierta');

      var modal = false;
      if (typeof dialogo.showModal === 'function') {
        try {
          if (dialogo.open) dialogo.close();
          dialogo.showModal();
          modal = true;
        } catch (error) {}
      }
      if (!modal) {
        dialogo.setAttribute('open', '');
        this.raiz.classList.add('mia-descuento--sin-modal');
      }

      this.abierto = true;
      document.documentElement.classList.add('mia-descuento-bloqueo');
      this.actualizarExpandido(true);

      if (opciones.sinAnimacion || !this.duracion()) {
        dialogo.classList.add('mia-descuento__dialogo--visible');
      } else {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (self.abierto) dialogo.classList.add('mia-descuento__dialogo--visible');
          });
        });
      }

      if (!opciones.sinFoco) this.enfocarInicial(opciones.enfocar);
    };

    MiaDescuento.prototype.enfocarInicial = function (elemento) {
      var objetivo = elemento;
      if (!objetivo) {
        if (this.vistaExito && !this.vistaExito.hidden) {
          objetivo = this.vistaExito.querySelector('.mia-descuento__titulo');
        } else if (punteroFino.matches && this.email) {
          objetivo = this.email;
        } else if (this.vistaFormulario) {
          objetivo = this.vistaFormulario.querySelector('.mia-descuento__titulo');
        }
      }
      if (!objetivo) return;
      try {
        objetivo.focus({ preventScroll: !elemento });
      } catch (error) {
        objetivo.focus();
      }
      if (elemento && elemento.scrollIntoView) elemento.scrollIntoView({ block: 'center' });
    };

    MiaDescuento.prototype.otraAbierta = function () {
      var self = this;
      return Object.keys(instancias).some(function (clave) {
        return instancias[clave] !== self && instancias[clave].abierto;
      });
    };

    MiaDescuento.prototype.cerrar = function (motivo, inmediato) {
      var self = this;
      var dialogo = this.dialogo;
      if (!this.abierto || !dialogo) return;
      this.abierto = false;
      dialogo.classList.remove('mia-descuento__dialogo--visible');

      var finalizar = function () {
        if (dialogo.open && typeof dialogo.close === 'function') {
          try {
            dialogo.close();
          } catch (error) {
            dialogo.removeAttribute('open');
          }
        } else {
          dialogo.removeAttribute('open');
        }
        self.raiz.classList.remove('mia-descuento--abierta', 'mia-descuento--sin-modal');
        if (!self.otraAbierta()) document.documentElement.classList.remove('mia-descuento-bloqueo');
        self.actualizarExpandido(false);
        if (motivo !== 'editor' && motivo !== 'destruir') self.devolverFoco();
      };

      var duracion = inmediato ? 0 : this.duracion();
      if (duracion) {
        this.temporizadorCierre = setTimeout(finalizar, duracion);
      } else {
        finalizar();
      }

      if (motivo === 'usuario') this.registrarCierre();
      if (this.suscritaEnEstaVisita && this.cfg.ocultarSuscritas && !this.cfg.modoDiseno) {
        this.raiz.classList.add('mia-descuento--pestana-bloqueada');
      }
    };

    MiaDescuento.prototype.devolverFoco = function () {
      var objetivo = null;
      if (esVisible(this.pestana) && !this.raiz.classList.contains('mia-descuento--pestana-bloqueada')) {
        objetivo = this.pestana;
      } else if (this.ultimoFoco && document.contains(this.ultimoFoco) && this.ultimoFoco !== document.body) {
        objetivo = this.ultimoFoco;
      }
      if (!objetivo) return;
      var enfocar = function () {
        try {
          objetivo.focus({ preventScroll: true });
        } catch (error) {
          objetivo.focus();
        }
      };
      enfocar();
      if (objetivo === this.pestana && document.activeElement !== objetivo) setTimeout(enfocar, 400);
    };

    MiaDescuento.prototype.actualizarExpandido = function (abierto) {
      if (this.pestana) this.pestana.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    };

    MiaDescuento.prototype.registrarCierre = function () {
      if (!this.cfg.recordarCierre || this.cfg.modoDiseno || this.suscritaEnEstaVisita) return;
      if (!this.puedeGuardarPreferencias()) return;
      escribir(almacenLocal, this.prefijo + 'cierre', String(Date.now()));
    };

    MiaDescuento.prototype.gestionarTeclado = function (evento) {
      if (!this.abierto) return;
      var sinModal = this.raiz.classList.contains('mia-descuento--sin-modal');

      if ((evento.key === 'Escape' || evento.key === 'Esc') && sinModal) {
        evento.preventDefault();
        this.cerrar('usuario');
        return;
      }

      if (evento.key !== 'Tab') return;

      var enfocables = Array.prototype.filter.call(this.dialogo.querySelectorAll(SELECTOR_ENFOCABLES), function (elemento) {
        return esVisible(elemento);
      });
      if (!enfocables.length) return;

      var primero = enfocables[0];
      var ultimo = enfocables[enfocables.length - 1];
      var activo = document.activeElement;
      var dentro = this.dialogo.contains(activo);

      if (evento.shiftKey && (activo === primero || !dentro)) {
        evento.preventDefault();
        ultimo.focus();
      } else if (!evento.shiftKey && (activo === ultimo || !dentro)) {
        evento.preventDefault();
        primero.focus();
      }
    };

    MiaDescuento.prototype.mostrarError = function (campo, nodo, mensaje) {
      if (nodo) {
        nodo.textContent = mensaje;
        nodo.hidden = false;
      }
      if (campo) campo.setAttribute('aria-invalid', 'true');
    };

    MiaDescuento.prototype.limpiarError = function (campo, nodo) {
      if (nodo) {
        nodo.textContent = '';
        nodo.hidden = true;
      }
      if (campo) campo.removeAttribute('aria-invalid');
    };

    MiaDescuento.prototype.enviar = function (evento) {
      var mensajes = this.cfg.mensajes;

      if (this.enviando) {
        evento.preventDefault();
        return;
      }

      if (this.avisoServidor) this.avisoServidor.hidden = true;
      this.limpiarError(this.email, this.errorEmail);
      this.limpiarError(this.consentimiento, this.errorConsentimiento);

      var valor = this.email ? this.email.value.trim() : '';
      if (this.email) this.email.value = valor;

      if (!valor) {
        evento.preventDefault();
        this.mostrarError(this.email, this.errorEmail, mensajes.vacio || '');
        this.email.focus();
        return;
      }

      if (!EMAIL_VALIDO.test(valor)) {
        evento.preventDefault();
        this.mostrarError(this.email, this.errorEmail, mensajes.formato || '');
        this.email.focus();
        return;
      }

      if (this.consentimiento && !this.consentimiento.checked) {
        evento.preventDefault();
        this.mostrarError(this.consentimiento, this.errorConsentimiento, mensajes.consentimiento || '');
        this.consentimiento.focus();
        return;
      }

      if (evento.defaultPrevented) return;

      this.enviando = true;
      escribir(almacenSesion, CLAVE_PENDIENTE, this.id);

      if (this.boton) {
        var boton = this.boton;
        boton.classList.add('mia-descuento__boton--cargando');
        boton.setAttribute('aria-busy', 'true');
        if (this.textoBoton && mensajes.cargando) this.textoBoton.textContent = mensajes.cargando;
        setTimeout(function () {
          boton.disabled = true;
        }, 0);
      }
    };

    MiaDescuento.prototype.restaurarBoton = function () {
      this.enviando = false;
      if (!this.boton) return;
      this.boton.disabled = false;
      this.boton.classList.remove('mia-descuento__boton--cargando');
      this.boton.removeAttribute('aria-busy');
      if (this.textoBoton) this.textoBoton.textContent = this.textoBotonOriginal;
    };

    MiaDescuento.prototype.procesarEstadoServidor = function () {
      var marca = this.raiz.querySelector('[data-mia-estado]');
      var estado = marca ? marca.getAttribute('data-mia-estado') : '';
      if (!estado) return;

      if (estado === 'exito' && this.puedeGuardarPreferencias()) {
        escribir(almacenLocal, CLAVE_SUSCRITA, '1');
      }

      var pendiente = leer(almacenSesion, CLAVE_PENDIENTE);
      var hashPropio = window.location.hash === '#' + this.cfg.idFormulario;
      if (pendiente !== this.id && !hashPropio) return;

      borrar(almacenSesion, CLAVE_PENDIENTE);
      if (hashPropio && window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
      }

      if (estado === 'exito') {
        this.suscritaEnEstaVisita = true;
        this.mostrarVista('exito');
        this.abrir({ sinAnimacion: true });
      } else {
        if (this.avisoServidor) this.avisoServidor.hidden = false;
        this.mostrarVista('formulario');
        this.abrir({ sinAnimacion: true, enfocar: this.avisoServidor || this.email });
      }
    };

    MiaDescuento.prototype.copiarCodigo = function (boton) {
      var nodo = this.raiz.querySelector('[data-mia-codigo]');
      if (!nodo || !boton) return;
      var texto = nodo.textContent.trim();
      var original = boton.getAttribute('data-texto-original') || boton.textContent;
      var copiado = this.cfg.mensajes.copiado || original;
      boton.setAttribute('data-texto-original', original);

      var confirmar = function () {
        boton.textContent = copiado;
        setTimeout(function () {
          boton.textContent = original;
        }, 2000);
      };

      var alternativa = function () {
        try {
          var seleccion = window.getSelection();
          var rango = document.createRange();
          rango.selectNodeContents(nodo);
          seleccion.removeAllRanges();
          seleccion.addRange(rango);
          if (document.execCommand('copy')) confirmar();
        } catch (error) {}
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(texto).then(confirmar, alternativa);
      } else {
        alternativa();
      }
    };

    MiaDescuento.prototype.destruir = function () {
      var self = this;
      if (this.abierto && this.cfg.modoDiseno) abiertasAntesDeRecargar[this.id] = true;
      this.temporizadores.forEach(clearTimeout);
      clearTimeout(this.temporizadorCierre);
      this.manejadores.forEach(function (manejador) {
        manejador[0].removeEventListener(manejador[1], manejador[2], manejador[3]);
      });
      this.manejadores = [];
      if (this.abierto) this.cerrar('destruir', true);
      if (this.dialogo && this.dialogo.open) {
        try {
          this.dialogo.close();
        } catch (error) {}
      }
      if (this.raiz.parentNode) this.raiz.parentNode.removeChild(this.raiz);
      if (instancias[this.id] === self) delete instancias[this.id];
      if (!this.otraAbierta()) document.documentElement.classList.remove('mia-descuento-bloqueo');
    };

    function iniciarEn(ambito) {
      var raices = (ambito || document).querySelectorAll('.mia-descuento[data-seccion]:not([data-mia-iniciada])');
      Array.prototype.forEach.call(raices, function (raiz) {
        var id = raiz.getAttribute('data-seccion');
        if (instancias[id]) instancias[id].destruir();
        raiz.setAttribute('data-mia-iniciada', '');
        instancias[id] = new MiaDescuento(raiz);
      });
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarEn(evento.target);
    });

    document.addEventListener('shopify:section:unload', function (evento) {
      var instancia = instancias[evento.detail && evento.detail.sectionId];
      if (instancia) instancia.destruir();
    });

    document.addEventListener('shopify:section:select', function (evento) {
      var instancia = instancias[evento.detail && evento.detail.sectionId];
      if (!instancia) return;
      instancia.mostrarVista(instancia.cfg.previsualizarExito ? 'exito' : 'formulario');
      instancia.abrir({ sinFoco: true });
    });

    document.addEventListener('shopify:section:deselect', function (evento) {
      var instancia = instancias[evento.detail && evento.detail.sectionId];
      if (instancia) instancia.cerrar('editor');
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        iniciarEn(document);
      });
    } else {
      iniciarEn(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-cuatro-colecciones"] && !Shopify.designMode) return;
  try {
    
  class PcolColeccionesCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.barra = this.querySelector('[data-progreso-barra]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      if (!this.pista) return;

      this.onScroll = this.actualizar.bind(this);
      if (this.barra) this.barra.style.setProperty('will-change', 'transform', 'important');
      this.onResize = () => {
        this.actualizar();
        this.medirTallas();
      };
      this.pista.addEventListener('scroll', this.onScroll, { passive: true });

      this.onClick = this.gestionarClick.bind(this);
      this.addEventListener('click', this.onClick);

      this.onTouch = (evento) => {
        const media = evento.target && evento.target.closest ? evento.target.closest('.pcol-media') : null;
        if (media && this.contains(media)) this.mostrarTallas(media);
      };
      this.addEventListener('touchstart', this.onTouch, { passive: true });
      this.addEventListener('pointerdown', this.onTouch, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.mover(-1));
      if (this.next) this.next.addEventListener('click', () => this.mover(1));

      this.tallasPaneles = Array.from(this.querySelectorAll('.pcol-tallas'));
      this.tallasPaneles.forEach((panel) => {
        const lista = panel.querySelector('[data-tallas-lista]');
        const barra = panel.querySelector('[data-tallas-scroll-barra]');
        if (!lista || !barra) return;
        panel._lista = lista;
        panel._barra = barra;
        panel._onScroll = () => this.actualizarIndicadorTallas(panel);
        lista.addEventListener('scroll', panel._onScroll, { passive: true });
      });

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.onResize);
        this.observador.observe(this.pista);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      if ('IntersectionObserver' in window) {
        this.observadorVista = new IntersectionObserver((entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) this.medirCuandoListo();
          });
        }, { rootMargin: '250px' });
        this.observadorVista.observe(this);
      }

      this.habilitarArrastre();

      this.onLoad = () => this.medirCuandoListo();
      this.onImgLoad = () => this.refrescar();
      Array.from(this.pista.querySelectorAll('img')).forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.onImgLoad, { once: true });
      });
      if (document.readyState !== 'complete') window.addEventListener('load', this.onLoad);

      this.medirCuandoListo();
    }

    medirCuandoListo(intentos) {
      intentos = intentos || 0;
      if (!this.pista) return;
      const anchoOk = this.pista.clientWidth > 0 && getComputedStyle(this.pista).display === 'grid';
      const hayScroll = (this.pista.scrollWidth - this.pista.clientWidth) > 2;
      if (anchoOk && (hayScroll || intentos >= 45)) {
        this.actualizar();
        this.medirTallas();
      } else if (intentos < 120) {
        requestAnimationFrame(() => this.medirCuandoListo(intentos + 1));
      }
    }

    habilitarArrastre() {
      this.track = this.querySelector('[data-progreso]');
      this.hit = this.querySelector('[data-progreso-wrap]') || this.track;
      if (!this.track || !this.barra || !this.hit) return;

      const maxScroll = () => this.pista.scrollWidth - this.pista.clientWidth;

      const fijarPorX = (clientX) => {
        const rect = this.track.getBoundingClientRect();
        if (rect.width <= 0) return;
        const frac = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1);
        const thumbFrac = Math.min(this.barra.getBoundingClientRect().width / rect.width, 1);
        const restante = 1 - thumbFrac;
        const ms = maxScroll();
        if (ms <= 0 || restante <= 0) return;
        let objetivo = frac - thumbFrac / 2;
        objetivo = Math.min(Math.max(objetivo, 0), restante);
        this.pista.scrollLeft = (objetivo / restante) * ms;
        this.actualizar();
      };

      this.onBarraDown = (e) => {
        if (maxScroll() <= 2) return;
        this._arrastrando = true;
        this.barra.classList.add('pcol-progreso-barra--arrastrando');
        if (this.hit.setPointerCapture && e.pointerId != null) {
          try { this.hit.setPointerCapture(e.pointerId); } catch (err) {}
        }
        fijarPorX(e.clientX);
        e.preventDefault();
      };
      this.onBarraMove = (e) => {
        if (!this._arrastrando) return;
        fijarPorX(e.clientX);
        e.preventDefault();
      };
      this.onBarraUp = () => {
        if (!this._arrastrando) return;
        this._arrastrando = false;
        this.barra.classList.remove('pcol-progreso-barra--arrastrando');
      };
      this.onBarraKey = (e) => {
        if (e.key === 'ArrowLeft') { this.mover(-1); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { this.mover(1); e.preventDefault(); }
      };

      this.hit.addEventListener('pointerdown', this.onBarraDown);
      window.addEventListener('pointermove', this.onBarraMove, { passive: false });
      window.addEventListener('pointerup', this.onBarraUp);
      this.hit.addEventListener('keydown', this.onBarraKey);
    }

    disconnectedCallback() {
      if (this.pista) this.pista.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onClick);
      if (this.onTouch) {
        this.removeEventListener('touchstart', this.onTouch);
        this.removeEventListener('pointerdown', this.onTouch);
      }
      if (this.observador) this.observador.disconnect();
      if (this.observadorVista) this.observadorVista.disconnect();
      window.removeEventListener('resize', this.onResize);
      if (this.onLoad) window.removeEventListener('load', this.onLoad);
      if (this.onImgLoad && this.pista) {
        Array.from(this.pista.querySelectorAll('img')).forEach((img) => img.removeEventListener('load', this.onImgLoad));
      }
      if (this.hit && this.onBarraDown) this.hit.removeEventListener('pointerdown', this.onBarraDown);
      if (this.onBarraMove) window.removeEventListener('pointermove', this.onBarraMove);
      if (this.onBarraUp) window.removeEventListener('pointerup', this.onBarraUp);
      if (this.hit && this.onBarraKey) this.hit.removeEventListener('keydown', this.onBarraKey);
      if (this.tallasPaneles) {
        this.tallasPaneles.forEach((panel) => {
          if (panel._lista && panel._onScroll) panel._lista.removeEventListener('scroll', panel._onScroll);
        });
      }
    }

    refrescar() {
      this.actualizar();
      this.medirTallas();
    }

    medirTallas() {
      if (!this.tallasPaneles) return;
      this.tallasPaneles.forEach((panel) => this.actualizarIndicadorTallas(panel));
    }

    actualizarIndicadorTallas(panel) {
      const lista = panel._lista;
      const barra = panel._barra;
      if (!lista || !barra) return;
      const visible = lista.clientWidth || 1;
      const total = lista.scrollWidth || 1;
      if (total - visible > 2) {
        panel.classList.add('pcol-tallas--scroll');
        const prop = Math.min(visible / total, 1);
        const avance = Math.min(Math.max(lista.scrollLeft / total, 0), 1 - prop);
        barra.style.setProperty('width', prop * 100 + '%', 'important');
        barra.style.setProperty('left', avance * 100 + '%', 'important');
      } else {
        panel.classList.remove('pcol-tallas--scroll');
      }
    }

    paso() {
      const item = this.pista.querySelector('.pcol-item');
      const gap = parseInt(getComputedStyle(this.pista).columnGap, 10) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.pista.clientWidth;
    }

    mover(dir) {
      this.pista.scrollBy({ left: dir * this.paso(), behavior: 'smooth' });
    }

    actualizar() {
      const visible = this.pista.clientWidth || 1;
      const total = this.pista.scrollWidth || 1;
      const max = total - visible;

      if (this.barra && max > 2) {
        const proporcion = Math.min(visible / total, 1);
        const avance = Math.min(Math.max(this.pista.scrollLeft / total, 0), 1 - proporcion);
        this.barra.style.setProperty('width', proporcion * 100 + '%', 'important');
        this.barra.style.setProperty('left', '0%', 'important');
        this.barra.style.setProperty('transform', 'translate3d(' + (avance / proporcion) * 100 + '%, 0, 0)', 'important');
      }

      if (this.prev) this.prev.toggleAttribute('disabled', this.pista.scrollLeft <= 2);
      if (this.next) this.next.toggleAttribute('disabled', this.pista.scrollLeft >= max - 2);
    }

    gestionarClick(evento) {
      const talla = evento.target.closest('[data-talla]');
      if (talla && this.contains(talla)) {
        evento.preventDefault();
        this.anadirTalla(talla);
        return;
      }

      const flechaImg = evento.target.closest('[data-img-prev], [data-img-next]');
      if (flechaImg && this.contains(flechaImg)) {
        evento.preventDefault();
        const dir = flechaImg.hasAttribute('data-img-next') ? 1 : -1;
        this.cambiarImagen(flechaImg, dir);
        return;
      }

      const color = evento.target.closest('[data-color]');
      if (color && this.contains(color)) {
        evento.preventDefault();
        const grupo = color.closest('.pcol-colores');
        if (grupo) grupo.querySelectorAll('.pcol-color').forEach((c) => c.classList.remove('pcol-color--activo'));
        color.classList.add('pcol-color--activo');
        const tarjeta = color.closest('.pcol-tarjeta');
        const media = tarjeta ? tarjeta.querySelector('.pcol-media') : null;
        const pos = color.getAttribute('data-img-pos');
        if (media && pos) this.activarImagenPorPos(media, pos);
        return;
      }
    }

    activarImagenPorPos(media, pos) {
      const galeria = media.querySelector('[data-galeria]');
      if (!galeria) return;
      const slides = galeria.querySelectorAll('.pcol-galeria-slide');
      let objetivo = null;
      slides.forEach((slide) => {
        if (slide.getAttribute('data-img-pos') === String(pos)) objetivo = slide;
      });
      if (!objetivo) return;
      slides.forEach((slide) => slide.classList.remove('pcol-galeria-slide--activa'));
      objetivo.classList.add('pcol-galeria-slide--activa');
    }

    mostrarTallas(media) {
      if (!media) return;
      this.querySelectorAll('.pcol-media--tallas').forEach((otro) => {
        if (otro !== media) otro.classList.remove('pcol-media--tallas');
      });
      media.classList.add('pcol-media--tallas');
    }

    cambiarImagen(flecha, dir) {
      const media = flecha.closest('.pcol-media');
      if (!media) return;
      const galeria = media.querySelector('[data-galeria]');
      if (!galeria) return;
      const slides = galeria.querySelectorAll('.pcol-galeria-slide');
      if (slides.length < 2) return;

      let actual = 0;
      slides.forEach((slide, i) => {
        if (slide.classList.contains('pcol-galeria-slide--activa')) actual = i;
      });

      const siguiente = (actual + dir + slides.length) % slides.length;
      slides[actual].classList.remove('pcol-galeria-slide--activa');
      slides[siguiente].classList.add('pcol-galeria-slide--activa');
    }

    raiz() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async anadirTalla(boton) {
      const variante = boton.dataset.variante;
      if (!variante || boton.getAttribute('aria-busy') === 'true') return;

      boton.setAttribute('aria-busy', 'true');
      this.volarAlCarrito(boton);

      try {
        const respuesta = await fetch(this.raiz() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] })
        });

        const datos = await respuesta.json();
        if (!respuesta.ok || datos.status) throw new Error(datos.description || datos.message || 'error');

        await this.actualizarBurbuja();
        document.dispatchEvent(new CustomEvent('pcol:carrito-actualizado', { detail: datos }));

        boton.classList.add('pcol-talla--anadida');
        clearTimeout(boton.temporizador);
        boton.temporizador = setTimeout(() => boton.classList.remove('pcol-talla--anadida'), 1100);
      } catch (e) {
        boton.classList.add('pcol-talla--error');
        clearTimeout(boton.temporizador);
        boton.temporizador = setTimeout(() => boton.classList.remove('pcol-talla--error'), 1100);
      } finally {
        boton.removeAttribute('aria-busy');
      }
    }

    volarAlCarrito(origen) {
      if (this.dataset.animacion === 'false') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const carrito = document.getElementById('cart-icon-bubble');
      if (!carrito || !origen) return;

      const o = origen.getBoundingClientRect();
      const c = carrito.getBoundingClientRect();
      if (!o.width || !c.width) return;

      const x0 = o.left + o.width / 2;
      const y0 = o.top + o.height / 2;
      const x1 = c.left + c.width / 2;
      const y1 = c.top + c.height / 2;
      const dx = x1 - x0;
      const dy = y1 - y0;
      const ang = Math.atan2(dy, dx) * 180 / Math.PI;
      const color = this.dataset.estrellaColor || '#FFC83D';

      const estrella = document.createElement('div');
      estrella.className = 'pcol-estrella';
      estrella.style.left = x0 + 'px';
      estrella.style.top = y0 + 'px';
      estrella.style.transform = 'translate(0px, 0px) rotate(' + ang + 'deg)';
      estrella.innerHTML =
        '<span class="pcol-estrella-cola"></span><span class="pcol-estrella-nucleo"></span>';
      document.body.appendChild(estrella);

      const nucleo = estrella.querySelector('.pcol-estrella-nucleo');
      const cola = estrella.querySelector('.pcol-estrella-cola');
      if (nucleo) {
        nucleo.style.background = 'radial-gradient(circle, #ffffff 0%, ' + color + ' 55%, ' + color + ' 100%)';
        nucleo.style.boxShadow = '0 0 8px 2px ' + color + ', 0 0 18px 6px ' + color + ', 0 0 3px 1px rgba(0, 0, 0, 0.28)';
      }
      if (cola) {
        cola.style.background = 'linear-gradient(to left, ' + color + ', transparent)';
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          estrella.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + ang + 'deg) scale(0.3)';
          estrella.style.opacity = '0.15';
        });
      });

      window.setTimeout(() => {
        estrella.remove();
        carrito.classList.add('pcol-golpe');
        window.setTimeout(() => carrito.classList.remove('pcol-golpe'), 350);
      }, 430);
    }

    async actualizarBurbuja() {
      try {
        const respuesta = await fetch(this.raiz() + 'cart.js', { headers: { Accept: 'application/json' } });
        const carrito = await respuesta.json();
        const cuenta = carrito.item_count;

        const contenedor = document.getElementById('cart-icon-bubble');
        if (!contenedor) return;

        let burbuja = contenedor.querySelector('.cart-count-bubble');
        if (cuenta > 0) {
          if (!burbuja) {
            burbuja = document.createElement('div');
            burbuja.className = 'cart-count-bubble';
            contenedor.appendChild(burbuja);
          }
          burbuja.innerHTML = '<span aria-hidden="true">' + (cuenta < 100 ? cuenta : '') + '</span>';
        } else if (burbuja) {
          burbuja.remove();
        }
      } catch (e) {}
    }
  }

  if (!customElements.get('pcol-colecciones-carrusel')) {
    customElements.define('pcol-colecciones-carrusel', PcolColeccionesCarrusel);
  }

  class PcolColeccionesGrupo extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pcol-pestana'));
      this.panels = Array.from(this.querySelectorAll('.pcol-panel'));
      this.verTodo = this.querySelector('[data-ver-todo]');

      if (!this.tabs.length) return;

      this.onClick = (evento) => {
        const tab = evento.target.closest('.pcol-pestana');
        if (!tab || !this.contains(tab)) return;
        this.activar(tab);
      };
      this.addEventListener('click', this.onClick);

      const primera = this.tabs[0];
      if (this.verTodo && primera) {
        this.verTodo.setAttribute('href', primera.getAttribute('data-url') || '#');
      }
    }

    disconnectedCallback() {
      if (this.onClick) this.removeEventListener('click', this.onClick);
    }

    activar(tab) {
      const idx = tab.getAttribute('data-pestana');

      this.tabs.forEach((t) => {
        const activo = t === tab;
        t.classList.toggle('pcol-pestana--activa', activo);
        t.setAttribute('aria-selected', activo ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const activo = panel.getAttribute('data-panel') === idx;
        panel.hidden = !activo;
        panel.classList.toggle('pcol-panel--activo', activo);
        if (activo) {
          const carrusel = panel.querySelector('pcol-colecciones-carrusel');
          if (carrusel && typeof carrusel.medirCuandoListo === 'function') {
            carrusel.medirCuandoListo();
          }
        }
      });

      if (this.verTodo) {
        this.verTodo.setAttribute('href', tab.getAttribute('data-url') || '#');
      }
    }
  }

  if (!customElements.get('pcol-colecciones-grupo')) {
    customElements.define('pcol-colecciones-grupo', PcolColeccionesGrupo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productosrios"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function rootUrl() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function actualizarBurbuja(res) {
      if (!res.sections || !res.sections['cart-icon-bubble']) return;
      var burbuja = document.getElementById('cart-icon-bubble');
      if (!burbuja) return;
      var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      var nueva = doc.getElementById('cart-icon-bubble');
      if (nueva) burbuja.innerHTML = nueva.innerHTML;
    }

    function abrirCajon(res) {
      actualizarBurbuja(res);

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        try { drawer.renderContents(res); } catch (e) {}
        if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
        return;
      }

      var notification = document.querySelector('cart-notification');
      if (notification && typeof notification.renderContents === 'function') {
        try { notification.renderContents(res); } catch (e) {}
        return;
      }

      var eventos = ['cart:refresh', 'cart:updated', 'cart:build', 'cart:change', 'ajaxProduct:added', 'product:added', 'cart:open', 'cart-drawer:open', 'openCartDrawer'];
      eventos.forEach(function (nombre) {
        document.dispatchEvent(new CustomEvent(nombre, { bubbles: true, detail: { cart: res } }));
      });

      setTimeout(clicarIconoCarrito, 120);
    }

    function clicarIconoCarrito() {
      var selectores = [
        '#cart-icon-bubble',
        '[data-cart-drawer-toggle]',
        '[data-drawer-toggle="cart"]',
        '[data-cart-toggle]',
        '[data-action="open-cart"]',
        '[aria-controls="cart-drawer"]',
        '.js-drawer-open-cart',
        '.cart-toggle',
        '.header__icon--cart',
        '.site-header__cart',
        '.header-cart',
        '#cart-icon',
        'a[href$="/cart"]'
      ];
      for (var i = 0; i < selectores.length; i++) {
        var el = document.querySelector(selectores[i]);
        if (el) {
          el.click();
          return;
        }
      }
    }

    function anadirAlCarrito(variantId, boton) {
      if (!variantId) return;
      if (boton) boton.classList.add('gpn-anadiendo');

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: 'cart-drawer,cart-notification,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (boton) boton.classList.remove('gpn-anadiendo');
          if (res.status) { return; }
          abrirCajon(res);
        })
        .catch(function () {
          if (boton) boton.classList.remove('gpn-anadiendo');
        });
    }

    function actualizarBarra(contenedor, thumb, minAncho) {
      var track = thumb.parentElement;
      var trackW = track ? track.clientWidth : 0;
      var max = contenedor.scrollWidth - contenedor.clientWidth;
      if (trackW <= 0 || max <= 2) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0px)';
        return;
      }
      var propor = contenedor.clientWidth / contenedor.scrollWidth;
      var thumbW = Math.max(trackW * propor, trackW * (minAncho / 100));
      var frac = contenedor.scrollLeft / max;
      if (frac < 0) { frac = 0; }
      if (frac > 1) { frac = 1; }
      thumb.style.width = thumbW + 'px';
      thumb.style.transform = 'translateX(' + (frac * (trackW - thumbW)) + 'px)';
    }

    var barrasRegistradas = [];
    var frameDebug = 0;

    (function bucleBarras() {
      for (var i = 0; i < barrasRegistradas.length; i++) {
        var b = barrasRegistradas[i];
        try { actualizarBarra(b.c, b.t, b.m); } catch (e) {}
      }
      frameDebug++;
      var dbg = document.querySelector('[data-gpn-debug]');
      if (dbg) {
        var g = document.querySelector('.gpn-grid');
        var st = document.querySelector('[data-gpn-progreso-thumb]');

        var cards = document.querySelectorAll('.gpn-tarjeta');
        var centro = window.innerWidth / 2;
        var mejor = null, mejorDist = 1e9;
        for (var k = 0; k < cards.length; k++) {
          var r = cards[k].getBoundingClientRect();
          var d = Math.abs((r.left + r.right) / 2 - centro);
          if (d < mejorDist) { mejorDist = d; mejor = cards[k]; }
        }
        var sActual = mejor ? mejor.querySelector('[data-gpn-slider]') : null;
        var thActual = mejor ? mejor.querySelector('[data-gpn-img-progreso-thumb]') : null;

        dbg.textContent =
          'SEC despl:' + (g ? Math.round(g.scrollLeft) + '/' + Math.round(g.scrollWidth - g.clientWidth) : '?') +
          ' barraSEC:' + (st ? st.style.transform : '?') +
          ' || FOTO despl:' + (sActual ? Math.round(sActual.scrollLeft) + '/' + Math.round(sActual.scrollWidth - sActual.clientWidth) : 'sin-slider') +
          ' barraFOTO:' + (thActual ? thActual.style.transform : 'sin-barra');
      }
      requestAnimationFrame(bucleBarras);
    })();

    function conectarBarra(contenedor, thumb, minAncho) {
      if (!contenedor || !thumb) return;
      barrasRegistradas.push({ c: contenedor, t: thumb, m: minAncho });
    }

    function initProgreso(seccion) {
      var grid = seccion.querySelector('.gpn-grid');
      if (!grid) return;

      conectarBarra(grid, seccion.querySelector('[data-gpn-progreso-thumb]'), 15);

      function anchoTarjeta() {
        var t = grid.querySelector('.gpn-tarjeta');
        if (!t) return grid.clientWidth;
        var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
        return t.getBoundingClientRect().width + gap;
      }

      var prev = seccion.querySelector('[data-gpn-carrusel-prev]');
      var next = seccion.querySelector('[data-gpn-carrusel-next]');
      if (prev) prev.addEventListener('click', function () {
        grid.scrollBy({ left: -anchoTarjeta(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        grid.scrollBy({ left: anchoTarjeta(), behavior: 'smooth' });
      });
    }

    function initSeccion(seccion) {
      initProgreso(seccion);

      var wraps = seccion.querySelectorAll('[data-gpn-wrap]');
      wraps.forEach(function (wrap) {
        wrap.addEventListener('mouseenter', function () {
          wrap.classList.add('gpn-activa');
        });

        wrap.addEventListener('touchstart', function () {
          wraps.forEach(function (w) {
            if (w !== wrap) w.classList.remove('gpn-activa');
          });
          wrap.classList.add('gpn-activa');
        }, { passive: true });

        wrap.querySelectorAll('[data-gpn-add]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (btn.disabled) return;
            anadirAlCarrito(btn.getAttribute('data-gpn-add'), btn);
          });
        });

        wrap.addEventListener('mouseleave', function () {
          wrap.classList.remove('gpn-activa');
          wrap.classList.remove('gpn-sin-velo');
        });

        var slides = wrap.querySelectorAll('[data-gpn-slide]');
        if (slides.length < 2) return;

        var siguiente = wrap.querySelector('[data-gpn-siguiente]');
        var anterior = wrap.querySelector('[data-gpn-anterior]');
        var slider = wrap.querySelector('[data-gpn-slider]');
        var actual = 0;

        var tarjeta = wrap.closest('.gpn-tarjeta');
        if (tarjeta) {
          conectarBarra(slider, tarjeta.querySelector('[data-gpn-img-progreso-thumb]'), 20);
        }

        function esMovil() {
          return window.matchMedia('(max-width: 748px)').matches;
        }

        function ir(direccion) {
          if (esMovil() && slider) {
            slider.scrollBy({ left: direccion * slider.clientWidth, behavior: 'smooth' });
            return;
          }
          slides[actual].classList.remove('gpn-slide--activa');
          actual = (actual + direccion + slides.length) % slides.length;
          slides[actual].classList.add('gpn-slide--activa');
          wrap.classList.add('gpn-sin-velo');
        }

        if (siguiente) {
          siguiente.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            ir(1);
          });
        }

        if (anterior) {
          anterior.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            ir(-1);
          });
        }
      });
    }

    function boot() {
      document.querySelectorAll('.gpn-seccion').forEach(initSeccion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('.gpn-seccion');
      if (sec) initSeccion(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puntos-clave-2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarrusel(grid) {
    if (grid.__bcInit) return;
    grid.__bcInit = true;

    var originales = Array.prototype.slice.call(grid.querySelectorAll('.barra-confianza__columna'));
    var N = originales.length;
    if (N < 2) return;

    var COPIAS = 2;
    var primero = originales[0];
    var i, j, clon;
    for (i = 0; i < COPIAS; i++) {
      for (j = 0; j < N; j++) {
        clon = originales[j].cloneNode(true);
        clon.classList.add('barra-confianza__columna--clon');
        clon.setAttribute('aria-hidden', 'true');
        grid.insertBefore(clon, primero);
      }
    }
    for (i = 0; i < COPIAS; i++) {
      for (j = 0; j < N; j++) {
        clon = originales[j].cloneNode(true);
        clon.classList.add('barra-confianza__columna--clon');
        clon.setAttribute('aria-hidden', 'true');
        grid.appendChild(clon);
      }
    }

    var realStart = COPIAS * N;
    var slides = Array.prototype.slice.call(grid.querySelectorAll('.barra-confianza__columna'));

    var cs = window.getComputedStyle(grid);
    var CENTRAL = parseFloat(cs.getPropertyValue('--barra-confianza-carrusel-escala-central')) || 1.25;
    var LADOS = parseFloat(cs.getPropertyValue('--barra-confianza-carrusel-escala')) || 0.74;
    var OPAC = parseFloat(cs.getPropertyValue('--barra-confianza-carrusel-opacidad')) || 0.55;

    var anchoSlide = 0;
    var logicoActual = 1;
    var raf = null;
    var finTimer = null;
    var interactuo = false;
    var normalizando = false;

    function esScrollable() { return grid.scrollWidth > grid.clientWidth + 4; }

    function medir() {
      anchoSlide = slides[realStart + 1].offsetLeft - slides[realStart].offsetLeft;
    }

    function centrarEn(idx) {
      var el = slides[idx];
      if (!el) return;
      grid.scrollLeft = el.offsetLeft + (el.offsetWidth / 2) - (grid.clientWidth / 2);
    }

    function indiceCentral() {
      var rect = grid.getBoundingClientRect();
      var centro = rect.left + rect.width / 2;
      var mejor = 0;
      var mejorDist = Infinity;
      for (var k = 0; k < slides.length; k++) {
        var r = slides[k].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - centro);
        if (d < mejorDist) { mejorDist = d; mejor = k; }
      }
      return mejor;
    }

    function render() {
      if (!esScrollable() || anchoSlide <= 0) {
        for (var m = 0; m < slides.length; m++) {
          slides[m].style.removeProperty('transform');
          slides[m].style.removeProperty('opacity');
        }
        return;
      }
      var rect = grid.getBoundingClientRect();
      var centro = rect.left + rect.width / 2;
      for (var k = 0; k < slides.length; k++) {
        var r = slides[k].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var t = Math.abs(c - centro) / anchoSlide;
        if (t > 1) t = 1;
        var escala = CENTRAL + (LADOS - CENTRAL) * t;
        var op = 1 + (OPAC - 1) * t;
        slides[k].style.setProperty('transform', 'scale(' + escala.toFixed(4) + ')', 'important');
        slides[k].style.setProperty('opacity', op.toFixed(4), 'important');
      }
    }

    function normalizar() {
      if (!esScrollable() || anchoSlide <= 0) return;
      var c = indiceCentral();
      var logico = ((c % N) + N) % N;
      logicoActual = logico;
      var el = slides[realStart + logico];
      var destino = el.offsetLeft + (el.offsetWidth / 2) - (grid.clientWidth / 2);
      if (Math.abs(destino - grid.scrollLeft) > 1) {
        normalizando = true;
        grid.scrollLeft = destino;
        window.setTimeout(function () { normalizando = false; }, 60);
      }
    }

    function alScroll() {
      if (normalizando) return;
      if (!raf) {
        raf = window.requestAnimationFrame(function () { raf = null; render(); });
      }
      if (finTimer) clearTimeout(finTimer);
      finTimer = window.setTimeout(function () {
        finTimer = null;
        normalizar();
        render();
      }, 130);
    }

    function marcarInteraccion() { interactuo = true; }

    grid.addEventListener('scroll', alScroll, { passive: true });
    grid.addEventListener('touchstart', marcarInteraccion, { passive: true });
    grid.addEventListener('pointerdown', marcarInteraccion, { passive: true });
    grid.addEventListener('wheel', marcarInteraccion, { passive: true });

    window.addEventListener('resize', function () {
      medir();
      if (esScrollable()) centrarEn(realStart + logicoActual);
      render();
    }, { passive: true });

    function preparar(forzar) {
      medir();
      if (forzar && !interactuo && esScrollable()) {
        centrarEn(realStart + 1);
        logicoActual = 1;
      }
      render();
    }

    preparar(true);
    window.setTimeout(function () { preparar(true); }, 250);
    window.addEventListener('load', function () { preparar(true); });
  }

  function boot() {
    var grids = document.querySelectorAll('[data-barra-confianza-carrusel]');
    for (var i = 0; i < grids.length; i++) initCarrusel(grids[i]);
  }

  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-nuevas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarResenas(root) {
    if (!root || root.dataset.resenasIniciado === 'true') return;
    root.dataset.resenasIniciado = 'true';
    var barrasCont = root.querySelector('.resenas__barras');
    if (barrasCont) {
      if ('IntersectionObserver' in window) {
        var ioBarras = new IntersectionObserver(function (entries) {
          for (var i = 0;
          i < entries.length;
          i++) {
            if (entries[i].isIntersecting) {
              root.classList.add('animar-barras');
              ioBarras.disconnect();
              break;
            }
          }
        }
        , {
          threshold: 0.25
        }
        );
        ioBarras.observe(barrasCont);
      }
      else {
        root.classList.add('animar-barras');
      }
    }
    var carrusel = root.querySelector('.resenas__carrusel');
    if (!carrusel) return;
    var pista = carrusel.querySelector('.resenas__pista');
    var tarjetas = pista ? pista.children : [];
    var total = tarjetas.length;
    if (!pista || total < 1) return;
    var puntos = carrusel.querySelectorAll('.resenas__punto');
    var intervalo = parseInt(carrusel.getAttribute('data-intervalo'), 10) || 2000;
    var indice = 0;
    var timer = null;
    function leerVar(nombre) {
      return getComputedStyle(root).getPropertyValue(nombre).trim();
    }
    function getVisibles() {
      return parseInt(leerVar('--resenas-visibles'), 10) || 1;
    }
    function getGap() {
      return parseFloat(leerVar('--resenas-gap-tarjetas')) || 0;
    }
    function ir(n) {
      var visibles = getVisibles();
      var maximo = Math.max(0, total - visibles);
      if (n > maximo) n = 0;
      if (n < 0) n = maximo;
      indice = n;
      var gap = getGap();
      pista.style.transform = 'translateX(calc((100% + ' + gap + 'px) / ' + visibles + ' * ' + (-indice) + '))';
      for (var i = 0;
      i < puntos.length;
      i++) {
        puntos[i].classList.toggle('is-activo', i === indice);
      }
    }
    function iniciar() {
      parar();
      if (total > getVisibles()) {
        timer = setInterval(function () {
          ir(indice + 1);
        }
        , intervalo);
      }
    }
    function parar() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    for (var i = 0;
    i < puntos.length;
    i++) {
      (function (idx) {
        puntos[idx].addEventListener('click', function () {
          ir(idx);
          iniciar();
        }
        );
      }
      )(i);
    }
    carrusel.addEventListener('mouseenter', function () {
      if (!root.classList.contains('is-expandido')) parar();
    }
    );
    carrusel.addEventListener('mouseleave', function () {
      if (!root.classList.contains('is-expandido')) iniciar();
    }
    );
    function alinearColumnas() {
      if (!carrusel) return;
      carrusel.style.marginTop = '';
      if (window.innerWidth < 990) return;
      var bar5 = root.querySelector('.resenas__barra-fila');
      var primera = pista.querySelector('.resenas__tarjeta');
      if (!bar5 || !primera) return;
      var delta = bar5.getBoundingClientRect().top - primera.getBoundingClientRect().top;
      if (delta > 4) {
        carrusel.style.marginTop = Math.round(delta) + 'px';
      }
    }
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (!root.classList.contains('is-expandido')) ir(indice);
        alinearColumnas();
      }
      , 150);
    }
    );
    var pie = root.querySelector('.resenas__pie');
    var tanda = pie ? (parseInt(pie.getAttribute('data-tanda'), 10) || 5) : 5;
    var btnsTop = root.querySelectorAll('.resenas__superior .resenas__vermas, .resenas__revheader .resenas__vermas');
    var btnPieMas = root.querySelector('.resenas__vermas-mas');
    var btnPieMenos = root.querySelector('.resenas__vermenos');
    function textoBtn(expandido) {
      for (var i = 0;
      i < btnsTop.length;
      i++) {
        var t = btnsTop[i].getAttribute(expandido ? 'data-menos' : 'data-mas');
        if (t) btnsTop[i].textContent = t;
      }
    }
    function aplicarLimite() {
      var todo = root.classList.contains('is-expandido-todo');
      var parcial = root.classList.contains('is-expandido') && !todo;
      for (var i = 0;
      i < total;
      i++) {
        if (parcial && i >= tanda) {
          tarjetas[i].style.setProperty('display', 'none', 'important');
        }
        else {
          tarjetas[i].style.removeProperty('display');
        }
      }
      if (btnPieMas) {
        if (parcial && total > tanda) {
          btnPieMas.style.removeProperty('display');
        }
        else {
          btnPieMas.style.setProperty('display', 'none', 'important');
        }
      }
    }
    function expandir() {
      root.classList.add('is-expandido');
      root.classList.remove('is-expandido-todo');
      parar();
      pista.style.transform = 'none';
      textoBtn(true);
      aplicarLimite();
    }
    function verTodo() {
      root.classList.add('is-expandido-todo');
      aplicarLimite();
    }
    function contraer() {
      var estaba = root.classList.contains('is-expandido');
      root.classList.remove('is-expandido');
      root.classList.remove('is-expandido-todo');
      textoBtn(false);
      aplicarLimite();
      ir(0);
      iniciar();
      if (estaba) {
        try {
          root.scrollIntoView( {
            behavior: 'smooth', block: 'start'
          }
          );
        }
        catch (err) {
          root.scrollIntoView();
        }
      }
    }
    for (var bt = 0;
    bt < btnsTop.length;
    bt++) {
      btnsTop[bt].addEventListener('click', function () {
        if (root.classList.contains('is-expandido')) contraer();
        else expandir();
      }
      );
    }
    if (btnPieMas) {
      btnPieMas.addEventListener('click', verTodo);
    }
    if (btnPieMenos) {
      btnPieMenos.addEventListener('click', contraer);
    }
    var utils = root.querySelectorAll('.resenas__util');
    for (var u = 0;
    u < utils.length;
    u++) {
      (function (cont) {
        var id = cont.getAttribute('data-resena-id');
        var clave = 'resena-voto-' + id;
        var btnSi = cont.querySelector('.resenas__util-si');
        var btnNo = cont.querySelector('.resenas__util-no');
        var baseSi = btnSi ? (parseInt(btnSi.getAttribute('data-base'), 10) || 0) : 0;
        var baseNo = btnNo ? (parseInt(btnNo.getAttribute('data-base'), 10) || 0) : 0;
        var voto = null;
        try {
          voto = localStorage.getItem(clave);
        }
        catch (e) {
        }
        function pinta() {
          if (btnSi) {
            btnSi.querySelector('.resenas__util-num').textContent = baseSi + (voto === 'si' ? 1 : 0);
            btnSi.classList.toggle('is-activo', voto === 'si');
            btnSi.setAttribute('aria-pressed', voto === 'si' ? 'true' : 'false');
          }
          if (btnNo) {
            btnNo.querySelector('.resenas__util-num').textContent = baseNo + (voto === 'no' ? 1 : 0);
            btnNo.classList.toggle('is-activo', voto === 'no');
            btnNo.setAttribute('aria-pressed', voto === 'no' ? 'true' : 'false');
          }
        }
        function guarda() {
          try {
            if (voto) {
              localStorage.setItem(clave, voto);
            }
            else {
              localStorage.removeItem(clave);
            }
          }
          catch (e) {
          }
        }
        if (btnSi) {
          btnSi.addEventListener('click', function () {
            voto = (voto === 'si') ? null : 'si';
            guarda();
            pinta();
          }
          );
        }
        if (btnNo) {
          btnNo.addEventListener('click', function () {
            voto = (voto === 'no') ? null : 'no';
            guarda();
            pinta();
          }
          );
        }
        pinta();
      }
      )(utils[u]);
    }
    function pxPorPaso() {
      var vp = carrusel.querySelector('.resenas__viewport');
      return (vp.clientWidth + getGap()) / getVisibles();
    }
    var arrastrando = false, xIni = 0, dx = 0, baseT = 0, movido = false;
    pista.addEventListener('pointerdown', function (e) {
      if (root.classList.contains('is-expandido')) return;
      if (total <= getVisibles()) return;
      arrastrando = true;
      movido = false;
      xIni = e.clientX;
      dx = 0;
      baseT = -indice * pxPorPaso();
      pista.style.transition = 'none';
      pista.classList.add('is-arrastrando');
      parar();
      try {
        pista.setPointerCapture(e.pointerId);
      }
      catch (err) {
      }
    }
    );
    pista.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      dx = e.clientX - xIni;
      if (Math.abs(dx) > 5) movido = true;
      pista.style.transform = 'translateX(' + (baseT + dx) + 'px)';
    }
    );
    function finArrastre() {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('is-arrastrando');
      pista.style.transition = '';
      var umbral = pxPorPaso() * 0.2;
      if (dx <= -umbral) {
        ir(indice + 1);
      }
      else if (dx >= umbral) {
        ir(indice - 1);
      }
      else {
        ir(indice);
      }
      iniciar();
    }
    pista.addEventListener('pointerup', finArrastre);
    pista.addEventListener('pointercancel', finArrastre);
    pista.addEventListener('click', function (e) {
      if (movido) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    , true);
    aplicarLimite();
    ir(0);
    iniciar();
    alinearColumnas();
    setTimeout(alinearColumnas, 350);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(alinearColumnas);
    }
    window.addEventListener('load', alinearColumnas);
  }
  function iniciarModal(root) {
    var modal = root.querySelector('[data-resena-modal]');
    if (!modal || modal.dataset.modalIniciado === 'true') return;
    modal.dataset.modalIniciado = 'true';
    function limpiarUrl() {
      try {
        if (location.search && location.search.indexOf('contact_posted') !== -1) {
          history.replaceState(null, '', location.pathname + location.hash);
        }
      }
      catch (e) {
      }
    }
    function abrir() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }
    function cerrar() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      limpiarUrl();
    }
    var abridores = root.querySelectorAll('[data-abrir-resena]');
    for (var a = 0;
    a < abridores.length;
    a++) {
      abridores[a].addEventListener('click', abrir);
    }
    var cerradores = modal.querySelectorAll('[data-cerrar-resena]');
    for (var c = 0;
    c < cerradores.length;
    c++) {
      cerradores[c].addEventListener('click', cerrar);
    }
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.resenas__modal-caja')) cerrar();
    }
    );
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && !modal.hidden) cerrar();
    }
    );
    var estrellas = modal.querySelectorAll('.resenas__form-estrella');
    var ratingInput = modal.querySelector('[data-rating-input]');
    var ratingSel = 0;
    function pintaEstrellas(n) {
      for (var i = 0;
      i < estrellas.length;
      i++) {
        estrellas[i].classList.toggle('is-activo', i < n);
      }
    }
    for (var e2 = 0;
    e2 < estrellas.length;
    e2++) {
      (function (idx) {
        estrellas[idx].addEventListener('mouseenter', function () {
          pintaEstrellas(idx + 1);
        }
        );
        estrellas[idx].addEventListener('click', function () {
          ratingSel = idx + 1;
          if (ratingInput) ratingInput.value = ratingSel;
          pintaEstrellas(ratingSel);
        }
        );
      }
      )(e2);
    }
    var estrellasCont = modal.querySelector('.resenas__form-estrellas');
    if (estrellasCont) estrellasCont.addEventListener('mouseleave', function () {
      pintaEstrellas(ratingSel);
    }
    );
    var tallas = modal.querySelectorAll('.resenas__form-talla');
    var tallasInput = modal.querySelector('[data-tallas-input]');
    for (var t = 0;
    t < tallas.length;
    t++) {
      (function (idx) {
        tallas[idx].addEventListener('click', function () {
          for (var k = 0;
          k < tallas.length;
          k++) {
            tallas[k].classList.toggle('is-activo', k === idx);
          }
          if (tallasInput) tallasInput.value = (idx + 1);
        }
        );
      }
      )(t);
    }
    var inputsArchivo = modal.querySelectorAll('[data-archivos]');
    for (var f = 0;
    f < inputsArchivo.length;
    f++) {
      (function (inp) {
        var urls = [];
        inp.addEventListener('change', function () {
          var cont = inp.closest('.resenas__form-subir');
          if (!cont) return;
          var ico = cont.querySelector('.resenas__form-subir-ico');
          var lista = cont.querySelector('[data-archivos-lista]');
          for (var u = 0;
          u < urls.length;
          u++) {
            try {
              URL.revokeObjectURL(urls[u]);
            }
            catch (er) {
            }
          }
          urls = [];
          if (lista) {
            lista.innerHTML = '';
          }
          if (ico) {
            ico.style.removeProperty('background-image');
            ico.classList.remove('resenas__form-subir-ico--foto');
          }
          if (!inp.files || !inp.files.length) return;
          for (var n = 0;
          n < inp.files.length;
          n++) {
            var file = inp.files[n];
            if (file.type.indexOf('image') !== 0) continue;
            var url = URL.createObjectURL(file);
            urls.push(url);
            if (n === 0 && ico) {
              ico.style.setProperty('background-image', 'url("' + url + '")', 'important');
              ico.classList.add('resenas__form-subir-ico--foto');
            }
            else if (lista) {
              var img = document.createElement('img');
              img.className = 'resenas__form-thumb';
              img.src = url;
              lista.appendChild(img);
            }
          }
        }
        );
      }
      )(inputsArchivo[f]);
    }
    if (modal.querySelector('[data-form-ok]') || modal.querySelector('[data-form-error]')) {
      abrir();
      limpiarUrl();
    }
  }
  function initTodas() {
    document.querySelectorAll('.resenas').forEach(function (el) {
      iniciarResenas(el);
      iniciarModal(el);
    }
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodas);
  }
  else {
    initTodas();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.resenas');
    if (el) {
      iniciarResenas(el);
      iniciarModal(el);
    }
  }
  );
}
)();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-resenas-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciarCarrusel(seccion) {
      var pista = seccion.querySelector('[data-resenas-confianza-pista]');
      if (!pista) return;

      var anterior = seccion.querySelector('[data-resenas-confianza-anterior]');
      var siguiente = seccion.querySelector('[data-resenas-confianza-siguiente]');

      function calcularPaso() {
        var tarjeta = pista.querySelector('.resenas-confianza-tarjeta');
        if (!tarjeta) return pista.clientWidth;
        var estilos = window.getComputedStyle(pista);
        var separacion = parseFloat(estilos.columnGap || estilos.gap) || 0;
        return tarjeta.getBoundingClientRect().width + separacion;
      }

      function actualizarEstado() {
        var maximo = pista.scrollWidth - pista.clientWidth - 2;
        if (anterior) anterior.disabled = pista.scrollLeft <= 2;
        if (siguiente) siguiente.disabled = pista.scrollLeft >= maximo;
      }

      if (anterior) {
        anterior.addEventListener('click', function () {
          pista.scrollBy({ left: -calcularPaso(), behavior: 'smooth' });
        });
      }

      if (siguiente) {
        siguiente.addEventListener('click', function () {
          pista.scrollBy({ left: calcularPaso(), behavior: 'smooth' });
        });
      }

      pista.addEventListener('scroll', actualizarEstado, { passive: true });
      window.addEventListener('resize', actualizarEstado);
      actualizarEstado();
    }

    function iniciar() {
      var secciones = document.querySelectorAll('[data-resenas-confianza]');
      for (var i = 0; i < secciones.length; i++) {
        if (secciones[i].dataset.resenasConfianzaIniciado === 'true') continue;
        secciones[i].dataset.resenasConfianzaIniciado = 'true';
        iniciarCarrusel(secciones[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seguimiento-pedido"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TESELA = 256;

    function proyectar(lat, lon, z) {
      var mundo = Math.pow(2, z) * TESELA;
      var seno = Math.sin(lat * Math.PI / 180);
      seno = Math.min(Math.max(seno, -0.9999), 0.9999);
      return {
        x: (lon + 180) / 360 * mundo,
        y: (0.5 - Math.log((1 + seno) / (1 - seno)) / (4 * Math.PI)) * mundo
      };
    }

    function suavizar(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function SegMapa(raiz) {
      this.raiz = raiz;
      this.lienzo = raiz.querySelector('[data-lienzo]');
      this.capa = raiz.querySelector('[data-capa]');
      this.marcador = raiz.querySelector('[data-marcador]');
      this.flecha = raiz.querySelector('[data-flecha]');
      this.botonCentrar = raiz.querySelector('[data-centrar]');
      this.pista = raiz.querySelector('[data-pista]');
      this.panel = raiz.querySelector('[data-panel]');
      this.panelTitulo = raiz.querySelector('[data-panel-titulo]');
      this.panelTexto = raiz.querySelector('[data-panel-texto]');
      this.panelBoton = raiz.querySelector('[data-panel-boton]');
      this.panelCerrar = raiz.querySelector('[data-panel-cerrar]');
      var zona = raiz.closest('.seg-zona');
      this.estado = zona ? zona.querySelector('[data-estado]') : null;
      this.estadoTexto = zona ? zona.querySelector('[data-estado-texto]') : null;

      this.plantilla = raiz.getAttribute('data-teselas') || '';
      this.detalle = parseInt(raiz.getAttribute('data-detalle'), 10) || 14;
      this.z = parseInt(raiz.getAttribute('data-zoom'), 10) || 5;
      var lat = parseFloat(raiz.getAttribute('data-lat'));
      var lon = parseFloat(raiz.getAttribute('data-lon'));
      if (isNaN(lat)) lat = 40.4168;
      if (isNaN(lon)) lon = -3.7038;
      var inicio = proyectar(lat, lon, this.z);
      this.cx = inicio.x;
      this.cy = inicio.y;
      this.destino = null;
      this.teselas = {};
      this.punteroId = null;
      this.vx = 0;
      this.vy = 0;
      this.anim = null;
      this.marco = null;
      this.movido = false;

      this.fijarOrigen();
      this.eventos();
      this.render();
      this.decidirUbicacion();
    }

    SegMapa.prototype.fijarOrigen = function () {
      this.ox = Math.round(this.cx);
      this.oy = Math.round(this.cy);
      for (var clave in this.teselas) {
        if (this.teselas[clave].parentNode) this.teselas[clave].parentNode.removeChild(this.teselas[clave]);
      }
      this.teselas = {};
    };

    SegMapa.prototype.url = function (x, y) {
      var sub = ['a', 'b', 'c'][Math.abs(x + y) % 3];
      var retina = window.devicePixelRatio > 1 ? '@2x' : '';
      return this.plantilla
        .replace('{z}', this.z)
        .replace('{x}', x)
        .replace('{y}', y)
        .replace('{s}', sub)
        .replace('{r}', retina);
    };

    SegMapa.prototype.pedirRender = function () {
      var self = this;
      if (this.marco) return;
      this.marco = requestAnimationFrame(function () {
        self.marco = null;
        self.render();
      });
    };

    SegMapa.prototype.render = function () {
      var ancho = this.lienzo.clientWidth;
      var alto = this.lienzo.clientHeight;
      if (!ancho || !alto) return;

      var n = Math.pow(2, this.z);
      var mundo = n * TESELA;
      if (mundo > alto) {
        this.cy = Math.min(Math.max(this.cy, alto / 2), mundo - alto / 2);
      } else {
        this.cy = mundo / 2;
      }

      var izquierda = this.cx - ancho / 2;
      var arriba = this.cy - alto / 2;
      this.capa.style.transform = 'translate3d(' + Math.round(this.ox - izquierda) + 'px,' + Math.round(this.oy - arriba) + 'px,0)';

      var x0 = Math.floor(izquierda / TESELA) - 1;
      var x1 = Math.floor((izquierda + ancho) / TESELA) + 1;
      var y0 = Math.max(0, Math.floor(arriba / TESELA) - 1);
      var y1 = Math.min(n - 1, Math.floor((arriba + alto) / TESELA) + 1);
      var vivas = {};
      var self = this;

      for (var y = y0; y <= y1; y++) {
        for (var x = x0; x <= x1; x++) {
          var clave = this.z + '/' + x + '/' + y;
          vivas[clave] = true;
          if (this.teselas[clave]) continue;
          var img = document.createElement('img');
          img.className = 'seg-mapa__tesela';
          img.alt = '';
          img.draggable = false;
          img.decoding = 'async';
          img.style.left = (x * TESELA - this.ox) + 'px';
          img.style.top = (y * TESELA - this.oy) + 'px';
          img.onload = function () { this.classList.add('is-cargada'); };
          img.onerror = function () { this.style.visibility = 'hidden'; };
          img.src = this.url(((x % n) + n) % n, y);
          this.capa.insertBefore(img, this.marcador);
          this.teselas[clave] = img;
        }
      }

      Object.keys(this.teselas).forEach(function (clave) {
        if (vivas[clave]) return;
        var tesela = self.teselas[clave];
        if (tesela.parentNode) tesela.parentNode.removeChild(tesela);
        delete self.teselas[clave];
      });

      if (!this.destino) {
        if (this.flecha) this.flecha.hidden = true;
        return;
      }

      this.marcador.style.left = (this.destino.x - this.ox) + 'px';
      this.marcador.style.top = (this.destino.y - this.oy) + 'px';

      var mx = this.destino.x - izquierda;
      var my = this.destino.y - arriba;
      var margen = 28;
      var fuera = mx < margen || mx > ancho - margen || my < margen || my > alto - margen;
      if (this.flecha) {
        this.flecha.hidden = !fuera;
        if (fuera) {
          var angulo = Math.atan2(my - alto / 2, mx - ancho / 2);
          var cos = Math.cos(angulo);
          var sen = Math.sin(angulo);
          var t = Math.min((ancho / 2 - margen) / Math.max(Math.abs(cos), 0.0001), (alto / 2 - margen) / Math.max(Math.abs(sen), 0.0001));
          this.flecha.style.transform = 'translate(' + Math.round(ancho / 2 + cos * t) + 'px,' + Math.round(alto / 2 + sen * t) + 'px)';
          this.flecha.firstElementChild.style.transform = 'rotate(' + angulo + 'rad)';
        }
      }
      if (this.botonCentrar) this.botonCentrar.classList.toggle('is-llamando', fuera);
    };

    SegMapa.prototype.detener = function () {
      if (this.anim) cancelAnimationFrame(this.anim);
      this.anim = null;
    };

    SegMapa.prototype.inercia = function () {
      var self = this;
      this.detener();
      var paso = function () {
        self.vx *= 0.92;
        self.vy *= 0.92;
        if (Math.abs(self.vx) < 0.3 && Math.abs(self.vy) < 0.3) {
          self.anim = null;
          return;
        }
        self.cx -= self.vx;
        self.cy -= self.vy;
        self.render();
        self.anim = requestAnimationFrame(paso);
      };
      this.anim = requestAnimationFrame(paso);
    };

    SegMapa.prototype.animarA = function (x, y, duracion) {
      var self = this;
      this.detener();
      var desdeX = this.cx;
      var desdeY = this.cy;
      var inicio = performance.now();
      duracion = duracion || 750;
      var paso = function (ahora) {
        var t = Math.min((ahora - inicio) / duracion, 1);
        var k = suavizar(t);
        self.cx = desdeX + (x - desdeX) * k;
        self.cy = desdeY + (y - desdeY) * k;
        self.render();
        self.anim = t < 1 ? requestAnimationFrame(paso) : null;
      };
      this.anim = requestAnimationFrame(paso);
    };

    SegMapa.prototype.ocultarPista = function () {
      if (this.pista) this.pista.classList.add('is-oculta');
    };

    SegMapa.prototype.eventos = function () {
      var self = this;
      var lienzo = this.lienzo;
      var ultimoX = 0;
      var ultimoY = 0;
      var ultimoT = 0;
      var recorrido = 0;

      lienzo.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        if (self.punteroId !== null) return;
        self.punteroId = e.pointerId;
        try { lienzo.setPointerCapture(e.pointerId); } catch (err) {}
        self.detener();
        ultimoX = e.clientX;
        ultimoY = e.clientY;
        ultimoT = performance.now();
        recorrido = 0;
        self.vx = 0;
        self.vy = 0;
        self.raiz.classList.add('is-arrastrando');
      });

      lienzo.addEventListener('pointermove', function (e) {
        if (e.pointerId !== self.punteroId) return;
        var ahora = performance.now();
        var dx = e.clientX - ultimoX;
        var dy = e.clientY - ultimoY;
        var dt = Math.max(ahora - ultimoT, 8);
        var limite = 38;
        ultimoX = e.clientX;
        ultimoY = e.clientY;
        ultimoT = ahora;
        recorrido += Math.abs(dx) + Math.abs(dy);
        self.cx -= dx;
        self.cy -= dy;
        self.vx = self.vx * 0.3 + Math.max(-limite, Math.min(limite, (dx / dt) * 16)) * 0.7;
        self.vy = self.vy * 0.3 + Math.max(-limite, Math.min(limite, (dy / dt) * 16)) * 0.7;
        if (!self.movido && recorrido > 6) {
          self.movido = true;
          self.ocultarPista();
        }
        self.pedirRender();
      });

      var soltar = function (e) {
        if (e.pointerId !== self.punteroId) return;
        self.punteroId = null;
        self.raiz.classList.remove('is-arrastrando');
        if (performance.now() - ultimoT < 80) self.inercia();
      };

      lienzo.addEventListener('pointerup', soltar);
      lienzo.addEventListener('pointercancel', soltar);
      lienzo.addEventListener('dblclick', function (e) { e.preventDefault(); });

      ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (tipo) {
        self.raiz.addEventListener(tipo, function (e) {
          if (e.cancelable) e.preventDefault();
        }, { passive: false });
      });

      if (this.botonCentrar) {
        this.botonCentrar.addEventListener('click', function () { self.centrar(); });
      }
      if (this.flecha) {
        this.flecha.addEventListener('click', function () { self.centrar(); });
      }
      if (this.panelBoton) {
        this.panelBoton.addEventListener('click', function () { self.localizar(); });
      }
      if (this.panelCerrar) {
        this.panelCerrar.addEventListener('click', function () { self.ocultarPanel(); });
      }

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(function () { self.pedirRender(); });
        this.observador.observe(lienzo);
      } else {
        window.addEventListener('resize', function () { self.pedirRender(); });
      }
    };

    SegMapa.prototype.ponerEstado = function (tipo) {
      if (!this.estado) return;
      var texto = this.raiz.getAttribute('data-estado-' + tipo);
      this.estado.setAttribute('data-tipo', tipo);
      if (this.estadoTexto && texto) this.estadoTexto.textContent = texto;
    };

    SegMapa.prototype.mostrarPanel = function (tipo) {
      if (!this.panel) return;
      this.panelTitulo.textContent = this.raiz.getAttribute('data-' + tipo + '-titulo') || '';
      this.panelTexto.textContent = this.raiz.getAttribute('data-' + tipo + '-texto') || '';
      if (this.panelBoton) this.panelBoton.hidden = tipo !== 'pedir';
      this.panel.hidden = false;
    };

    SegMapa.prototype.ocultarPanel = function () {
      if (this.panel) this.panel.hidden = true;
    };

    SegMapa.prototype.cuandoVisible = function (accion) {
      var raiz = this.raiz;
      if (!('IntersectionObserver' in window)) {
        accion();
        return;
      }
      var observador = new IntersectionObserver(function (entradas) {
        for (var i = 0; i < entradas.length; i++) {
          if (entradas[i].isIntersecting) {
            observador.disconnect();
            accion();
            return;
          }
        }
      }, { threshold: 0.35 });
      observador.observe(raiz);
    };

    SegMapa.prototype.decidirUbicacion = function () {
      var self = this;
      var automatico = this.raiz.getAttribute('data-auto') === 'true';
      if (!('geolocation' in navigator)) {
        this.ponerEstado('error');
        return;
      }
      var consulta = navigator.permissions && navigator.permissions.query
        ? navigator.permissions.query({ name: 'geolocation' }).then(function (r) { return r.state; }).catch(function () { return 'prompt'; })
        : Promise.resolve('prompt');

      consulta.then(function (permiso) {
        if (permiso === 'granted') {
          self.cuandoVisible(function () { self.localizar(); });
        } else if (permiso === 'denied') {
          self.ponerEstado('error');
        } else if (automatico) {
          self.cuandoVisible(function () { self.localizar(); });
        } else {
          self.mostrarPanel('pedir');
        }
      });
    };

    SegMapa.prototype.localizar = function () {
      var self = this;
      if (!('geolocation' in navigator)) return;
      this.ocultarPanel();
      this.ponerEstado('buscando');
      navigator.geolocation.getCurrentPosition(function (posicion) {
        self.ubicar(posicion.coords.latitude, posicion.coords.longitude);
      }, function (error) {
        self.ponerEstado('error');
        self.mostrarPanel(error && error.code === 1 ? 'denegado' : 'pedir');
      }, { enableHighAccuracy: false, timeout: 12000, maximumAge: 600000 });
    };

    SegMapa.prototype.ubicar = function (lat, lon) {
      this.detener();
      this.z = this.detalle;
      var punto = proyectar(lat, lon, this.z);
      this.destino = punto;
      this.cx = punto.x;
      this.cy = punto.y;
      this.fijarOrigen();
      this.marcador.hidden = false;
      this.marcador.classList.remove('is-nuevo');
      void this.marcador.offsetWidth;
      this.marcador.classList.add('is-nuevo');
      this.render();
      this.ponerEstado('ok');
    };

    SegMapa.prototype.centrar = function () {
      if (this.destino) {
        this.animarA(this.destino.x, this.destino.y);
      } else {
        this.localizar();
      }
    };

    function retirar(id, excepto) {
      var bloques = document.querySelectorAll('.seg-bloque[data-seg="' + id + '"]');
      for (var i = 0; i < bloques.length; i++) {
        if (excepto && excepto.contains(bloques[i])) continue;
        if (bloques[i].parentNode) bloques[i].parentNode.removeChild(bloques[i]);
      }
    }

    function activar(seccion) {
      if (!seccion) return;
      var id = seccion.getAttribute('data-seg-seccion');
      var app = document.getElementById('pp-tracking-page-app');
      var aviso = seccion.querySelector('[data-aviso-editor]');
      if (!app || !app.parentNode) {
        if (aviso) aviso.hidden = false;
        return;
      }
      if (aviso) aviso.hidden = true;
      retirar(id, seccion);

      var cabecera = seccion.querySelector('[data-seg-parte="cabecera"]');
      var final = seccion.querySelector('[data-seg-parte="final"]');

      if (cabecera) {
        app.parentNode.insertBefore(cabecera, app);
        cabecera.classList.add('seg-bloque--activo');
      }
      if (final) {
        app.parentNode.insertBefore(final, app.nextSibling);
        final.classList.add('seg-bloque--activo');
        var mapas = final.querySelectorAll('[data-mapa]');
        for (var i = 0; i < mapas.length; i++) {
          if (!mapas[i].__segMapa) mapas[i].__segMapa = new SegMapa(mapas[i]);
        }
      }
    }

    function iniciar() {
      var secciones = document.querySelectorAll('[data-seg-seccion]');
      for (var i = 0; i < secciones.length; i++) activar(secciones[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var seccion = e.target ? e.target.querySelector('[data-seg-seccion]') : null;
      if (seccion) activar(seccion);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var seccion = e.target ? e.target.querySelector('[data-seg-seccion]') : null;
      if (seccion) retirar(seccion.getAttribute('data-seg-seccion'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-anadir-cesta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '.sticky-atc[data-sticky-atc]';

  function esVisible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }

  function norm(v) {
    return (v == null ? '' : String(v)).trim();
  }

  function getMainAdd(root) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var best = null;
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (root.contains(form)) continue;
      var id = form.getAttribute('id') || '';
      if (id.indexOf('installment') !== -1) continue;
      var btn = form.querySelector('[name="add"]');
      if (!btn || !esVisible(form)) continue;
      best = { form: form, btn: btn };
      if (id.indexOf('product-form-') === 0) break;
    }
    return best;
  }

  function esMovil() {
    return !window.matchMedia || window.matchMedia('(max-width: 989px)').matches;
  }

  function getGaleria(root) {
    var candidatos = document.querySelectorAll('media-gallery, .product__media-gallery, .product__media-list, .product__media-wrapper, .product-media-container, [id^="MediaGallery"]');
    for (var i = 0; i < candidatos.length; i++) {
      if (root && root.contains(candidatos[i])) continue;
      return candidatos[i];
    }
    return null;
  }

  function seccionesCabecera(root) {
    var lista = [];
    var nodos = document.querySelectorAll('.shopify-section-group-header-group, .section-header');
    for (var i = 0; i < nodos.length; i++) {
      if (root.contains(nodos[i]) || lista.indexOf(nodos[i]) !== -1) continue;
      lista.push(nodos[i]);
    }
    return lista;
  }

  function elementosFijos(secciones) {
    var lista = [];
    for (var i = 0; i < secciones.length; i++) {
      var candidatos = [secciones[i]];
      var hijos = secciones[i].querySelectorAll(':scope > *, :scope > * > *');
      for (var k = 0; k < hijos.length; k++) candidatos.push(hijos[k]);
      for (var c = 0; c < candidatos.length; c++) {
        var pos = window.getComputedStyle(candidatos[c]).position;
        if ((pos === 'sticky' || pos === 'fixed') && lista.indexOf(candidatos[c]) === -1) lista.push(candidatos[c]);
      }
    }
    return lista;
  }

  function lineaSuperior(fijos) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var maximo = 0;
    for (var i = 0; i < fijos.length; i++) {
      var el = fijos[i];
      if (!el.isConnected) continue;
      var r = el.getBoundingClientRect();
      if (r.height < 1 || r.bottom <= 0 || r.top >= vh * 0.5 || r.height > vh * 0.4) continue;
      var s = window.getComputedStyle(el);
      if (s.visibility === 'hidden' || parseFloat(s.opacity) === 0) continue;
      if (r.bottom > maximo) maximo = r.bottom;
    }
    return Math.max(0, Math.round(maximo));
  }

  function capaCabecera(secciones) {
    var minimo = null;
    for (var i = 0; i < secciones.length; i++) {
      var nodos = [secciones[i]];
      var s = window.getComputedStyle(secciones[i]);
      if (s.position === 'static' || s.zIndex === 'auto') {
        for (var k = 0; k < secciones[i].children.length; k++) nodos.push(secciones[i].children[k]);
      }
      for (var n = 0; n < nodos.length; n++) {
        var e = window.getComputedStyle(nodos[n]);
        if (e.position === 'static') continue;
        var z = parseInt(e.zIndex, 10);
        if (isNaN(z)) continue;
        if (minimo === null || z < minimo) minimo = z;
      }
    }
    return minimo;
  }

  function initOne(root) {
    if (root.__satInited) return;
    root.__satInited = true;

    var cfg = {};
    var cfgNode = root.querySelector('.sticky-atc__config');
    if (cfgNode) { try { cfg = JSON.parse(cfgNode.textContent); } catch (e) { cfg = {}; } }

    var barra = root.querySelector('.sticky-atc__barra');
    var stickyBtns = root.querySelectorAll('[data-sticky-boton]');
    var priceNodes = root.querySelectorAll('[data-sticky-precio]');
    var tallaBtns = root.querySelectorAll('.sticky-atc__talla');
    var dataWrap = root.querySelector('.sticky-atc__precios-data');
    var carrusel = root.querySelector('[data-sticky-tallas]');
    var imagen = root.querySelector('[data-sticky-img]');
    var maxTallas = cfg.maxTallas || 4;
    var tallaPos = cfg.tallaOptionPosition || 0;
    var variants = cfg.variants || [];
    var opciones = cfg.opciones || [];
    var capaAjuste = parseInt(cfg.capa, 10);

    var conjuntos = [];
    for (var oi = 0; oi < opciones.length; oi++) {
      var mapa = {};
      var valoresOpcion = opciones[oi].valores || [];
      for (var vi = 0; vi < valoresOpcion.length; vi++) mapa[norm(valoresOpcion[vi])] = true;
      conjuntos.push(mapa);
    }

    var _btn = null, _form = null;
    function refreshForm() { var m = getMainAdd(root); _form = m ? m.form : null; _btn = m ? m.btn : null; }
    function vigente() { return _form && _btn && document.contains(_btn) && esVisible(_form); }
    function getBtn() { if (!vigente()) refreshForm(); return _btn; }
    function getForm() { if (!vigente()) refreshForm(); return _form; }
    function getIdInput() { var f = getForm(); return f ? f.querySelector('[name="id"]') : null; }

    function pickerVisible() {
      var f = getForm();
      var ambito = (f && (f.closest('product-info') || f.closest('.shopify-section'))) || document;
      var lista = ambito.querySelectorAll('variant-selects, variant-radios');
      if (!lista.length && ambito !== document) lista = document.querySelectorAll('variant-selects, variant-radios');
      var elegido = null, ultimo = null;
      for (var i = 0; i < lista.length; i++) {
        if (root.contains(lista[i])) continue;
        ultimo = lista[i];
        if (!elegido && esVisible(lista[i])) elegido = lista[i];
      }
      return elegido || ultimo;
    }

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function buscarPorValores(valores) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options || [];
        var ok = true;
        for (var k = 0; k < valores.length; k++) {
          if (valores[k] == null) continue;
          if (norm(o[k]) !== norm(valores[k])) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function indiceDeGrupo(valores, usados, posicion) {
      var mejor = -1, mejorCuenta = 0;
      for (var k = 0; k < conjuntos.length; k++) {
        if (usados[k]) continue;
        var cuenta = 0;
        for (var j = 0; j < valores.length; j++) { if (conjuntos[k][norm(valores[j])]) cuenta++; }
        if (cuenta > mejorCuenta) { mejorCuenta = cuenta; mejor = k; }
      }
      if (mejor < 0 && posicion < conjuntos.length && !usados[posicion]) mejor = posicion;
      return mejor;
    }

    function gruposDelPicker(picker) {
      var grupos = [], porNombre = {};
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        var nm = r.name || ('__' + i);
        if (!porNombre[nm]) { porNombre[nm] = { tipo: 'radio', nodos: [], valores: [], elegido: null }; grupos.push(porNombre[nm]); }
        porNombre[nm].nodos.push(r);
        porNombre[nm].valores.push(r.value);
        if (r.checked) porNombre[nm].elegido = r.value;
      }
      var selects = picker.querySelectorAll('select');
      for (var s = 0; s < selects.length; s++) {
        var vals = [];
        for (var o = 0; o < selects[s].options.length; o++) vals.push(selects[s].options[o].value);
        grupos.push({ tipo: 'select', nodo: selects[s], valores: vals, elegido: selects[s].value });
      }
      var usados = {};
      for (var g = 0; g < grupos.length; g++) {
        var k = indiceDeGrupo(grupos[g].valores, usados, g);
        grupos[g].indice = k;
        if (k >= 0) usados[k] = true;
      }
      return grupos;
    }

    var tallaLocal = null;

    function estadoTema() {
      var idIn = getIdInput();
      var base = idIn ? variantById(idIn.value) : null;
      var picker = pickerVisible();
      if (picker && opciones.length) {
        var grupos = gruposDelPicker(picker);
        var valores = [];
        var completos = grupos.length > 0;
        for (var k = 0; k < opciones.length; k++) valores[k] = base && base.options ? base.options[k] : null;
        for (var g = 0; g < grupos.length; g++) {
          if (grupos[g].indice < 0) continue;
          if (grupos[g].elegido == null) { completos = false; continue; }
          valores[grupos[g].indice] = grupos[g].elegido;
        }
        if (tallaLocal != null && tallaPos > 0) valores[tallaPos - 1] = tallaLocal;
        if (completos) {
          var v = buscarPorValores(valores);
          return { variante: v, inexistente: !v, valores: valores };
        }
      }
      if (base && tallaLocal != null && tallaPos > 0 && base.options) {
        var opts = base.options.slice();
        opts[tallaPos - 1] = tallaLocal;
        var m = buscarPorValores(opts);
        if (m) return { variante: m, inexistente: false, valores: m.options };
      }
      var final = base || variantById(cfg.inicial);
      return { variante: final, inexistente: false, valores: final ? final.options : [] };
    }

    var visible = false;
    function show(state) {
      if (state === visible) return;
      visible = state;
      root.classList.toggle('is-visible', state);
    }

    function setPriceById(id) {
      if (!dataWrap) return;
      var tpl = dataWrap.querySelector('template[data-vid="' + id + '"]');
      if (!tpl) return;
      for (var i = 0; i < priceNodes.length; i++) {
        priceNodes[i].innerHTML = '';
        priceNodes[i].appendChild(tpl.content.cloneNode(true));
      }
    }

    function setImagen(v) {
      if (!imagen || !v || !v.imagen) return;
      if (imagen.getAttribute('src') !== v.imagen) imagen.setAttribute('src', v.imagen);
    }

    function setActive(value) {
      for (var i = 0; i < tallaBtns.length; i++) {
        if (norm(tallaBtns[i].getAttribute('data-talla')) === norm(value)) tallaBtns[i].classList.add('is-activa');
        else tallaBtns[i].classList.remove('is-activa');
      }
    }

    function syncButton(est) {
      var v = est.variante;
      var disponible = v ? (!est.inexistente && v.available !== false) : !est.inexistente;
      var label = cfg.textoBoton;
      if (!disponible) {
        var vs = window.variantStrings || {};
        label = (est.inexistente || !v) ? (vs.unavailable || cfg.textoNoDisponible || label) : (vs.soldOut || cfg.textoAgotado || label);
      }
      for (var i = 0; i < stickyBtns.length; i++) {
        stickyBtns[i].disabled = !disponible;
        var tn = stickyBtns[i].querySelector('.sticky-atc__boton-texto');
        if (tn && tn.textContent !== label) tn.textContent = label;
      }
    }

    var ultimoPintado = null;
    function pintar() {
      var est = estadoTema();
      var v = est.variante;
      if (tallaPos > 0 && est.valores && est.valores[tallaPos - 1] != null) setActive(est.valores[tallaPos - 1]);
      if (v && String(v.id) !== String(ultimoPintado)) {
        ultimoPintado = v.id;
        setPriceById(v.id);
        setImagen(v);
      }
      syncButton(est);
    }

    function fireChange(el) {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function keepPosition() {
      var sx = window.pageXOffset, sy = window.pageYOffset;
      window.__satFocusUntil = Date.now() + 3000;
      if (!window.__satFocusPatched) {
        window.__satFocusPatched = true;
        var origFocus = HTMLElement.prototype.focus;
        HTMLElement.prototype.focus = function (opts) {
          if (Date.now() < (window.__satFocusUntil || 0)) {
            var o = { preventScroll: true };
            if (opts) { for (var k in opts) o[k] = opts[k]; }
            try { return origFocus.call(this, o); } catch (e) { return origFocus.call(this); }
          }
          return origFocus.apply(this, arguments);
        };
        var tick = function () {
          if (Date.now() < (window.__satFocusUntil || 0)) { setTimeout(tick, 250); }
          else { HTMLElement.prototype.focus = origFocus; window.__satFocusPatched = false; }
        };
        setTimeout(tick, 300);
      }
      function restore() { if (window.pageXOffset !== sx || window.pageYOffset !== sy) window.scrollTo(sx, sy); }
      window.addEventListener('scroll', restore, true);
      setTimeout(function () { window.removeEventListener('scroll', restore, true); }, 600);
    }

    function driveTalla(value) {
      var picker = pickerVisible();
      if (!picker || tallaPos < 1) return false;
      var grupos = gruposDelPicker(picker);
      var objetivo = norm(value);
      for (var g = 0; g < grupos.length; g++) {
        if (grupos[g].indice !== tallaPos - 1) continue;
        if (grupos[g].tipo === 'radio') {
          for (var r = 0; r < grupos[g].nodos.length; r++) {
            var radio = grupos[g].nodos[r];
            if (norm(radio.value) === objetivo) {
              if (!radio.checked) { radio.checked = true; fireChange(radio); }
              return true;
            }
          }
        } else {
          var sel = grupos[g].nodo;
          for (var o = 0; o < sel.options.length; o++) {
            if (norm(sel.options[o].value) === objetivo || norm(sel.options[o].textContent) === objetivo) {
              if (sel.value !== sel.options[o].value) { sel.value = sel.options[o].value; fireChange(sel); }
              return true;
            }
          }
        }
      }
      return false;
    }

    function getCartEl() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    function fallbackNativo(vid) {
      var idIn = getIdInput();
      if (idIn && vid != null) idIn.value = vid;
      var btn = getBtn(), form = getForm();
      if (btn) { btn.click(); }
      else if (form) { if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit(); }
    }

    function actualizarBubble() {
      try {
        var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = raiz.replace(/\/+$/, '') + '/?sections=cart-icon-bubble';
        fetch(url).then(function (r) { return r.json(); }).then(function (j) {
          var html = j['cart-icon-bubble'];
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var src = tmp.querySelector('#cart-icon-bubble') || tmp;
          var dest = document.getElementById('cart-icon-bubble');
          if (dest && src) dest.innerHTML = src.innerHTML;
        }).catch(function () {});
      } catch (e) {}
    }

    function agregarAlCarrito(vid) {
      if (!window.fetch) { fallbackNativo(vid); return; }
      var cartEl = getCartEl();
      var payload = { id: vid, quantity: 1 };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        var secs = [];
        try { cartEl.getSectionsToRender().forEach(function (s) { if (s && s.id) secs.push(s.id); }); } catch (e) {}
        if (secs.length) { payload.sections = secs.join(','); payload.sections_url = window.location.pathname; }
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (r) {
          if (!r.ok || (r.j && r.j.status)) { fallbackNativo(vid); return; }
          if (cartEl && typeof cartEl.renderContents === 'function') {
            try { cartEl.renderContents(r.j); } catch (e) { actualizarBubble(); }
          } else {
            actualizarBubble();
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () { fallbackNativo(vid); });
    }

    var esperando = false;
    var ultimoCambioId = 0;

    function marcarCarga(estado) {
      for (var i = 0; i < stickyBtns.length; i++) {
        if (estado) stickyBtns[i].setAttribute('aria-busy', 'true');
        else stickyBtns[i].removeAttribute('aria-busy');
      }
    }

    function esperarTema(id, boton) {
      if (esperando) return;
      esperando = true;
      marcarCarga(true);
      var inicio = Date.now();
      function seguirClic() {
        esperando = false;
        marcarCarga(false);
        var est = estadoTema();
        if (!est.variante || String(est.variante.id) !== String(id)) { pintar(); return; }
        boton.__satPaso = true;
        boton.click();
      }
      (function comprobar() {
        if (!esperando) return;
        var idIn = getIdInput();
        if (idIn && String(idIn.value) === String(id)) {
          setTimeout(seguirClic, Math.max(60, 220 - (Date.now() - ultimoCambioId)));
          return;
        }
        if (Date.now() - inicio > 4000) {
          if (idIn) { idIn.value = id; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
          setTimeout(seguirClic, 220);
          return;
        }
        setTimeout(comprobar, 80);
      })();
    }

    window.addEventListener('click', function (e) {
      var boton = e.target && e.target.closest ? e.target.closest('[data-sticky-boton]') : null;
      if (!boton || !root.contains(boton)) return;
      if (boton.__satPaso) { boton.__satPaso = false; return; }
      if (esperando) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var est = estadoTema();
      var v = est.variante;
      if (est.inexistente || (v && v.available === false)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        pintar();
        return;
      }
      if (!v) return;
      var idIn = getIdInput();
      if (!idIn) return;
      if (String(idIn.value) === String(v.id) && Date.now() - ultimoCambioId > 220) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      esperarTema(v.id, boton);
    }, true);

    for (var t = 0; t < tallaBtns.length; t++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-talla');
          keepPosition();
          tallaLocal = driveTalla(value) ? null : value;
          pintar();
        });
      })(tallaBtns[t]);
    }

    for (var b = 0; b < stickyBtns.length; b++) {
      stickyBtns[b].addEventListener('click', function () {
        var est = estadoTema();
        var v = est.variante;
        if (!v || v.id == null) { fallbackNativo(null); return; }
        if (est.inexistente || v.available === false) { pintar(); return; }
        agregarAlCarrito(v.id);
      });
    }

    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.getAttribute && el.getAttribute('name') === 'id') ultimoCambioId = Date.now();
      pintar();
      requestAnimationFrame(pintar);
    });

    function limitCarousel() {
      if (!carrusel) return;
      carrusel.style.removeProperty('max-width');
      var pills = carrusel.querySelectorAll('.sticky-atc__talla');
      if (pills.length <= maxTallas) return;
      if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;
      var base = pills[0].getBoundingClientRect().left;
      var edge = pills[maxTallas - 1].getBoundingClientRect().right;
      var w = Math.ceil(edge - base);
      if (w > 0) carrusel.style.setProperty('max-width', w + 'px', 'important');
    }

    var secciones = [];
    var fijos = [];
    var ultimaCapa = null;
    var ultimoTop = null;
    var observador = null;

    function aplicarCapa() {
      var zc = capaCabecera(secciones);
      var ajuste = isNaN(capaAjuste) ? 3 : capaAjuste;
      var z = zc === null ? ajuste : Math.min(ajuste, Math.max(1, zc - 1));
      if (z !== ultimaCapa) {
        ultimaCapa = z;
        root.style.setProperty('--sat-z-efectivo', String(z));
      }
    }

    function medirCabecera() {
      secciones = seccionesCabecera(root);
      fijos = elementosFijos(secciones);
      aplicarCapa();
      if (window.ResizeObserver) {
        if (observador) observador.disconnect();
        observador = new ResizeObserver(function () { seguir(300); });
        for (var i = 0; i < secciones.length; i++) observador.observe(secciones[i]);
      }
    }

    function evaluate() {
      var linea = lineaSuperior(fijos);
      var top = linea + (cfg.desktopOffset || 0);
      if (top !== ultimoTop) {
        ultimoTop = top;
        root.style.setProperty('--sticky-top', top + 'px');
      }
      var mainBtn = getBtn();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;

      if (esMovil()) {
        if (!mainBtn) {
          show((window.pageYOffset || document.documentElement.scrollTop || 0) > 500);
          return;
        }
        var rect = mainBtn.getBoundingClientRect();
        var botonVisible = rect.top < vh && rect.bottom > linea;
        if (botonVisible) { show(false); return; }
        var galeria = getGaleria(root);
        var pasadasImagenes;
        if (galeria) {
          var barraAltura = barra ? barra.offsetHeight : 0;
          pasadasImagenes = galeria.getBoundingClientRect().bottom <= (vh - barraAltura);
        } else {
          pasadasImagenes = rect.top < vh;
        }
        show(pasadasImagenes);
        return;
      }

      if (mainBtn) {
        show(mainBtn.getBoundingClientRect().bottom <= linea);
      } else {
        show((window.pageYOffset || document.documentElement.scrollTop || 0) > 500);
      }
    }

    var rafId = 0;
    var seguirHasta = 0;
    function bucle() {
      rafId = 0;
      evaluate();
      if (Date.now() < seguirHasta) rafId = requestAnimationFrame(bucle);
    }
    function seguir(ms) {
      seguirHasta = Math.max(seguirHasta, Date.now() + ms);
      if (!rafId) rafId = requestAnimationFrame(bucle);
    }

    function alAnimarCabecera(e) {
      var obj = e.target;
      if (fijos.indexOf(obj) !== -1 || secciones.indexOf(obj) !== -1) seguir(700);
    }

    window.addEventListener('scroll', function () { seguir(450); }, { passive: true });

    var lct;
    window.addEventListener('resize', function () {
      medirCabecera();
      seguir(450);
      clearTimeout(lct);
      lct = setTimeout(limitCarousel, 120);
    }, { passive: true });

    document.addEventListener('transitionrun', alAnimarCabecera, true);
    document.addEventListener('transitionend', alAnimarCabecera, true);
    document.addEventListener('animationstart', alAnimarCabecera, true);
    document.addEventListener('animationend', alAnimarCabecera, true);

    document.addEventListener('shopify:section:load', function () {
      medirCabecera();
      seguir(300);
    });

    window.addEventListener('load', function () {
      medirCabecera();
      seguir(300);
      pintar();
    });

    window.addEventListener('pageshow', function () {
      esperando = false;
      marcarCarga(false);
      medirCabecera();
      seguir(300);
      pintar();
    });

    medirCabecera();
    evaluate();
    limitCarousel();
    setTimeout(limitCarousel, 300);
    pintar();
  }

  function initAll() {
    var roots = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  function boot() {
    initAll();
    setTimeout(initAll, 400);
    setTimeout(initAll, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
    if (root) root.classList.add('is-visible');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["targetas-de-coleccion"] && !Shopify.designMode) return;
  try {
    
  class ColecDeslizable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.pista = this.querySelector('[data-pista]');
      this.thumb = this.querySelector('[data-thumb]');

      if (!this.pista || !this.thumb) return;

      this.onScroll = this.actualizar.bind(this);
      this.pista.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.onScroll);
        this.observador.observe(this.pista);
      } else {
        window.addEventListener('resize', this.onScroll);
      }

      this.actualizar();
    }

    disconnectedCallback() {
      if (this.pista) this.pista.removeEventListener('scroll', this.onScroll);
      if (this.observador) this.observador.disconnect();
      window.removeEventListener('resize', this.onScroll);
    }

    actualizar() {
      const desplazable = this.pista.scrollWidth - this.pista.clientWidth;
      const ratio = this.pista.scrollWidth > 0 ? this.pista.clientWidth / this.pista.scrollWidth : 1;
      const progreso = desplazable > 0 ? this.pista.scrollLeft / desplazable : 0;
      const anchoThumb = Math.max(Math.min(ratio * 100, 100), 12);

      this.thumb.style.setProperty('width', anchoThumb + '%', 'important');
      this.thumb.style.setProperty('left', progreso * (100 - anchoThumb) + '%', 'important');
    }
  }

  if (!customElements.get('colec-deslizable')) {
    customElements.define('colec-deslizable', ColecDeslizable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["triple-banner"] && !Shopify.designMode) return;
  try {
    
  class BcolAnimado extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.classList.contains('bcol-anim')) return;

      if (!('IntersectionObserver' in window)) {
        this.classList.add('bcol-activo');
        return;
      }

      this.observador = new IntersectionObserver(
        (entradas) => {
          entradas.forEach((entrada) => {
            if (entrada.isIntersecting) {
              this.classList.add('bcol-activo');
              this.observador.disconnect();
            }
          });
        },
        { threshold: 0.12 }
      );

      this.observador.observe(this);
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
    }
  }

  if (!customElements.get('bcol-animado')) {
    customElements.define('bcol-animado', BcolAnimado);
  }

  } catch(e) { console.error(e); }
})();
})();
